var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthyNewWorld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 639,
    height: 596,
    fill: "none",
    viewBox: "0 0 639 596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "healthy-new-world 1",
    className: "healthy-new-world 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#D8D8D8",
    fillOpacity: 0.35,
    d: "M580.785 210.21C547.307 121.991 462.256 33.052 346.299 23.354 211.794 12.146 72.74 110.746 60.105 227.535c-11.014 101.58 77.717 180.085 134.123 229.998 50.295 44.514 167.459 148.129 274.287 109.223 112.566-40.957 163.313-221.92 112.27-356.537v-.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sun",
    fill: "#FFDF5A",
    d: "M507.932 168.021c40.891 0 74.031-33.143 74.031-74.03 0-40.89-33.148-74.023-74.031-74.023-40.889 0-74.029 33.142-74.029 74.031s33.145 74.03 74.029 74.03v-.008Z",
    className: "sun"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fill: "#6B655F",
    d: "M92.219 311.775h263.096v-94.944s-33.313 67.793-54.529 34.215c-21.02-33.284-50.406-4.414-50.999-3.851-18.978 27.397-41.79 27.947-58.298 23.029a57.134 57.134 0 0 0-11.426-2.199 53.7 53.7 0 0 0-18.092 1.427 66.97 66.97 0 0 0-22.729 10.757l-47.023 31.566Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#908C85",
    d: "M300.711 161.634c-14.016 12.011-27.023 28.009-33.779 48.892-4.609 14.442-10.436 26.873-17.168 36.647.592-.563 29.98-29.426 51 3.851 21.236 33.602 69.813-35.469 69.813-35.469L355.314 131.3c0-.001-28.974 8.423-54.603 30.334ZM37.706 324.904l21.92-13.129h32.595l46.991-31.588a66.955 66.955 0 0 1 22.7-10.758s-17.025-44.416-44.109-53.104c-7.191-2.252-14.533 0-21.132 6.628a51.536 51.536 0 0 0-8.595 11.763l-50.37 90.188Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fill: "#7D8696",
    d: "m130.518 66.539-33.78 156.417c6.599-6.606 13.939-8.91 21.123-6.628 27.048 8.686 44.051 53.104 44.051 53.104a64.245 64.245 0 0 1 3.477-.752l34.289-109.859L157.49 57.253a24.734 24.734 0 0 0-.57-1.298c-7.957-17.392-21.619-11.56-26.402 10.584Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fill: "#E1B7A3",
    d: "M165.418 268.68a53.635 53.635 0 0 1 14.615-.676s38.584-7.837 41.287-53.146c2.252-37.735 1.906-68.865 30.025-84.359 19.576-10.771 23.76-56.104 23.76-56.104L265.06 40.112c-4.971-16.905-15.32-21.891-23.145-11.125a35.935 35.935 0 0 0-4.879 10.254l-37.322 119.58-34.305 109.859h.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fill: "#C79A83",
    d: "M180.033 268.004a56.609 56.609 0 0 1 11.425 2.199c16.515 4.917 39.319 4.361 58.297-23.03 6.757-9.759 12.56-22.205 17.168-36.647 6.757-20.883 19.767-36.909 33.78-48.892l-17.671-60.241-7.919-27.022s-4.182 45.34-23.76 56.104c-28.149 15.493-27.774 46.623-30.026 84.354-2.688 45.316-41.286 53.154-41.286 53.154l-.008.021Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fill: "#E1B7A3",
    d: "m282.875 101.852 17.672 60.233c25.635-21.912 54.348 36.092 54.348 36.092l7.199 17.378h32.924l-62.157-138.2c-5.029-11.154-12.762-14.135-19.27-7.395l-30.716 31.892Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fill: "#44AA85",
    d: "M22.288 423.527s35.528-158.603 174.005-158.603c138.49 0 172.842 158.603 172.842 158.603H22.288Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fill: "#F3EEEC",
    d: "M626.5 353.514H509.848v48.252H626.5v-48.252Zm-95.086-44.261H519.84v32.302h11.574v-32.302Zm21.274 0h-11.576v32.302h11.576v-32.302Zm21.275 0h-11.576v32.302h11.576v-32.302Zm21.273 0h-11.592v32.302h11.584v-32.302h.008Zm21.282 0h-11.576v32.302h11.576v-32.302Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fill: "#CCC",
    d: "M552.695 364.391H519.84v26.498h32.855v-26.498Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fill: "#F3EEEC",
    d: "M537.096 364.391h-1.658v26.498h1.65v-26.498h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fill: "#CCC",
    d: "M616.518 364.391H583.66v26.498h32.857v-26.498h.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fill: "#F3EEEC",
    d: "M600.91 364.391h-1.65v26.498h1.65v-26.498Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fill: "#CCC",
    d: "M576.928 377.632h-17.506v24.125h17.506v-24.125Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fill: "#E59E97",
    d: "M302.541 366.048h-5.109v13.438h5.104v-13.438h.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sea-water",
    className: "sea-water"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fill: "#AFCCEF",
    d: "m467.104 453.419-87.994-.563v-.053h-8.084v.053l-87.984.563c-4.88 1.26-8.167 4.053-8.13 6.883.036 2.838 3.416 5.602 8.332 6.816 4.933 1.217 10.51.924 15.831 1.223 5.314.301 11.262 1.607 12.648 4.316 2.928 5.781-17.019 9.393-14.744 15.254 1.412 3.646 10.225 4.76 17.334 5.053 7.109.301 15.898 1.201 17.768 4.789 2.254 4.34-8.145 8.596-5.307 12.844 2.094 3.131 9.758 3.891 16.094 4.139 21.461.834 42.947.834 64.408 0 6.328-.248 13.992-1.008 16.086-4.139 2.838-4.248-7.563-8.506-5.307-12.836 1.877-3.604 10.66-4.504 17.77-4.797 7.107-.285 15.932-1.404 17.34-5.053 2.254-5.861-17.672-9.473-14.758-15.254 1.373-2.701 7.326-4.018 12.656-4.316 5.328-.299 10.982 0 15.83-1.223 4.85-1.224 8.258-3.971 8.334-6.816.074-2.845-3.245-5.623-8.123-6.883Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fill: "#AFCCEF",
    d: "M625.563 431.957c-5.494 9.76-15.088 26.207-19.652 31.686l-466.164.055c-8.26-15.014-10.512-20.545-14.413-31.963l500.229.222Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fill: "#E2E8E7",
    d: "M634.834 432.513c-80.465-.977-127.914-3.123-134.168-3.168l-111.85-.879c-22.881-.18-47.346-6.756-67.561-16.565-8.643-4.205-16.244-1.719-24.771-6.118-26.551-13.722-58.959-12.828-89.33-10.509 5.06-7.681 15.307-49.153 41.91-46.534 26.597 2.627 56.396 4.233 75.531 21.268 8.033 7.146 24.307 18.896 34.529 22.834 21.426 8.259 31.107 8.438 54.123 8.642 19.914.181 103.99.569 221.592-.69l-.005 31.719Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fill: "#99AA6D",
    d: "M137.928 429.923s22.316-99.651 109.327-99.651 108.593 99.651 108.593 99.651h-217.92Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fill: "#7D8696",
    d: "M634.834 423.453H8.048v10.156h626.784l.002-10.156Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "road",
    fill: "#E2E8E7",
    d: "M321.258 411.9c-8.643-4.205-16.246-1.719-24.773-6.119-26.551-13.721-58.957-12.828-89.33-10.508-30.369 2.326-62.025 5.381-90.453-4.77a216.133 216.133 0 0 1-33.436-15.104c-24.346-13.678-52.6-21.957-79.159-17.692-4.504-6.892-.938-15.711 3.753-22.414 23.152-32.955 75.126-46.092 114.162-28.851 17.268 7.636 31.528 20.119 48.793 27.902 24.021 10.854 51.646 11.771 78.25 14.391 26.604 2.627 56.398 4.234 75.533 21.269 8.031 7.146 24.307 18.896 34.531 22.834 21.424 8.259-17.656 28.871-37.871 19.068v-.006Z",
    className: "road"
  }), /*#__PURE__*/React.createElement("g", {
    id: "runners",
    className: "runners"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fill: "#28130F",
    d: "M67.732 316.714c.863-2.731 2.388-7.461 2.619-9.008l-3.752.646c-.105 2.352-.916 5.404-1.201 7.678-.285 2.275 1.682 2.328 2.326.686l.008-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fill: "#28130F",
    d: "M66.734 318.134c.834-.788 1.201-1.403.676-2.141-.602-.854-1.764-.533-5.383 2.771-1.816 1.651-2.912 2.897-3.617 3.582-.467.606.148.823.33 1.079.42.587 1.794-.375.976.15 3.153-2.425 4.691-3.152 7.026-5.441h-.008Zm7.35-4.107c-.689-2.777-1.861-7.611-2.492-9.076l-2.854 2.516c1.142 2.057 2.05 5.09 3.003 7.168.954 2.08 2.673 1.135 2.343-.6v-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fill: "#28130F",
    d: "M74.391 315.408c-.24-1.117-.586-1.748-1.5-1.674-1.053.076-1.367 1.238-.397 6.043.487 2.418.976 3.986 1.2 4.955.285.695.805.285 1.104.262.751-.059.751-.338.751.639-.412-3.949-.393-7.025-1.146-10.225h-.012Zm17.063 2.259c1.126-.209 1.771-.524 1.728-1.426-.045-1.052-1.2-1.418-6.006-.601-1.877.313-3.807.75-5.045 1.051-.375.074.396 1.847.706 1.83 3.498-.244 5.675-.244 8.617-.854Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fill: "#FFFFF6",
    d: "M83.249 322.488c-.33.053-1.126-1.742-1.237-2.207a4.88 4.88 0 0 1 .098-1.607c.061-.391-.602-1.764-.414-2.199a.576.576 0 0 1 .158-.172.442.442 0 0 1 .211-.084c.396-.074.812-.09 1.207-.045.195 0 .265.293.265.293a4.416 4.416 0 0 0-.442 1.576.646.646 0 0 0 0 .24c.055.338.85.443 1.061.549a3.519 3.519 0 0 1-.182.668l-.563 1.336v.098c-.138.301.073.752.098.939a.883.883 0 0 1 0 .299c0 .076-.021.15-.073.203a.297.297 0 0 1-.183.105l-.004.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fill: "#242424",
    d: "M83.505 322.171a6.16 6.16 0 0 1-1.11-2.153 5.2 5.2 0 0 1 .09-1.613c.068-.375-.602-1.728-.412-2.178a4.063 4.063 0 0 1 1.199-.054c.203 0 .27.302.27.302a4.467 4.467 0 0 0-.45 1.575c.174.302 1.037.228 1.066.324.029.147.029.308 0 .465a5.03 5.03 0 0 1-.18.668c-.188.524-.451 1.08-.563 1.336v.099c-.144.302.075.75.099.938l-.008.302-.001-.011Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fill: "#FFFFF6",
    d: "M84.188 319.634a.241.241 0 0 0-.135-.217l-.19-.121c-.097-.065-.237-.188-.353-.104a.102.102 0 0 0-.013.14l.013.012c.075.091.174.175.278.248.082.076.218.226.32.166a.16.16 0 0 0 .055-.053.121.121 0 0 0 .022-.076v.007l.003-.002Zm-.15.707a.659.659 0 0 0-.218-.368 1.318 1.318 0 0 0-.323-.277c-.09-.053-.202.062-.144.181.076.121.158.231.256.338.074.091.164.248.285.271l.06-.008c.017 0 .03-.017.046-.031a.093.093 0 0 0 .029-.045v-.06h.009v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fill: "#003948",
    d: "M91.934 304.246a8.96 8.96 0 0 1-1.06-.75c-.308-.354-.39-.9-.57-1.148a.756.756 0 0 1-.09-.752.67.67 0 0 1 .526-.396c.449 0 .81.631 1.365.75.076.256.375.18.668.479.076.09.474.276.549.354.128.238.128.238.045.41-.082.176-.165.176-.458.459-.3.291-.578.85-.976.586v.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fill: "#003948",
    d: "m90.898 302.091 2.13.226s.093 0 .138-.135v-.06a.158.158 0 0 0-.061-.099.1.1 0 0 0-.045-.022 1.713 1.713 0 0 0-.525-.271 3.394 3.394 0 0 1-1.501-.524",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fill: "#F29A7E",
    d: "M51.376 315.432c.751-2.777 2.063-7.56 2.252-9.144l-3.7.812c0 2.351-.684 5.44-.863 7.717-.181 2.272 1.771 2.289 2.313.606l-.002.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fill: "#F29A7E",
    d: "M50.73 316.873c.523-1.021.676-1.727-.067-2.252-.856-.607-1.847.074-4.175 4.383-1.17 2.17-2.252 4.572-2.68 5.459-.24.75.037.75.276.893.603.42.924.256 1.021.127 2.178-3.316 4.172-5.682 5.63-8.607l-.005-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fill: "#C6C6C6",
    fillOpacity: 0.35,
    d: "M67.41 327.607c6.471 0 11.711-.723 11.711-1.613 0-.895-5.24-1.615-11.711-1.615-6.456 0-11.695.729-11.695 1.615 0 .893 5.239 1.613 11.703 1.613h-.008Zm10.502 7.101c6.456 0 11.703-.722 11.703-1.615s-5.24-1.612-11.711-1.612c-6.455 0-11.695.729-11.695 1.612 0 .895 5.24 1.615 11.703 1.615Zm26.341 7.058c9.009 0 16.319-1.007 16.319-2.246 0-1.237-7.313-2.244-16.319-2.244s-16.319 1.007-16.319 2.252c0 1.231 7.302 2.238 16.319 2.238Zm-11.417-13.325c6.455 0 11.702-.721 11.702-1.615 0-.893-5.239-1.613-11.71-1.613-6.456 0-11.695.729-11.695 1.613 0 .895 5.239 1.615 11.703 1.615Zm38.357 2.176c0 .863-6.426 1.563-14.359 1.563s-14.367-.699-14.367-1.563 6.426-1.561 14.367-1.561c7.941 0 14.368.682 14.368 1.561h-.009Zm-78.625 1.373c6.457 0 11.703-.719 11.703-1.613 0-.893-5.238-1.613-11.709-1.613-6.457 0-11.696.729-11.696 1.613 0 .894 5.239 1.613 11.702 1.613Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fill: "#28130F",
    d: "M98.458 314.605c-.12-1.148-.392-1.801-1.284-1.84-1.051-.037-1.501 1.082-1.08 5.961.217 2.455.646 5.053.75 6.006a2.68 2.68 0 0 0 1.313 1.592c.75 0 .323-1.291.33-1.457 0-3.949.368-7.012-.03-10.27v.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fill: "#28130F",
    d: "M98.105 313.225c-1.164-2.619-3.168-7.17-4.04-8.507l-3.542 4.625c1.5 1.824 4.194 3.589 5.357 4.888 1.518 1.703 2.803.623 2.217-1.006h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fill: "#D83D3D",
    d: "m96.64 309.771-2.354 3.258-1.501-1.576a19.372 19.372 0 0 1-3.005-3.859 4.727 4.727 0 0 1 .375-3.752l4.03.863 2.118 4.465c.143.219.225.43.33.602h.008v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fill: "#FFFFF6",
    d: "M101.693 326.602c0 .412-1.621.953-2.012.981a2.733 2.733 0 0 1-1.246-.474c-.303-.164-1.502.338-1.832 0a.731.731 0 0 1-.121-.502 7.368 7.368 0 0 1 .24-1.502.34.34 0 0 1 .293-.248c.053.062.752.851 1.072.862h.063c.06.031.119.054.188.063.277 0 .549-.925.668-1.156.174.104.338.226.495.367.33.338.751.752.924.978v.073c.21.228.623.084.751.093.074 0 .165.014.24.045.202.089.292.194.277.42Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    fill: "#242424",
    d: "M101.506 326.227a4.242 4.242 0 0 1-1.951.849 2.678 2.678 0 0 1-1.246-.474c-.301-.166-1.502.33-1.824 0a7.604 7.604 0 0 1 .232-1.502.338.338 0 0 1 .3-.248c.046.062.75.851 1.073.862h.06c.278-.147.407-1.2.497-1.2a.57.57 0 0 1 .359.104c.174.104.338.228.495.368.323.3.64.623.924.976v.076c.202.226.623.073.751.09.112 0 .224.038.33.099Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fill: "#FFFFF6",
    d: "M99.65 324.837c-.098 0-.135 0-.194.104l-.149.201c-.061.104-.188.256-.148.405l.008.029.027.022a.127.127 0 0 0 .039 0l.029-.009a1.78 1.78 0 0 0 .271-.271c.074-.098.218-.219.201-.368-.015-.143-.039-.113-.084-.113Zm.528.33c-.144 0-.24.099-.339.188a1.89 1.89 0 0 0-.3.313c-.061.104 0 .271.111.221a1.46 1.46 0 0 0 .324-.227c.09-.076.238-.148.275-.287.041-.133.003-.2-.071-.208Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    fill: "#FFB4A0",
    d: "M100.604 297.002s.092-1.178.285-1.352c.195-.172.346.57.346.57s.541-.676.662-.652c.119.021.354.404.404.646a.976.976 0 0 1 0 1.448 5.193 5.193 0 0 1-.938.615l-.759-1.275Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    fill: "#FF5F5C",
    d: "M94.23 304.718s-.201 4.753-.375 6.982v.11a8.838 8.838 0 0 1-3.754-.39 62.586 62.586 0 0 1-.854-4.633 5.35 5.35 0 0 1 .63-3.002l4.353.933Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    fill: "#28130F",
    d: "m95.65 292.385-.646 1.667-1.313-.772.646-2.215.713.248.503-.428.097 1.5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    fill: "#3F1E19",
    d: "M97.736 291.357c0-.075 0-.172-.06-.265l-.157-.532v-.099a6.243 6.243 0 0 0-.166-1.877c-.24-.437-1.11-.313-1.11-.313a3.8 3.8 0 0 0-.961 1.787c-.06-.129-.15-.228-.271-.182a.75.75 0 0 0-.33.932.805.805 0 0 0 .53.404c0 .173.039.346.084.512.646 1.74 1.704 1.17 1.815 1.034.203-.353.322-.75.339-1.155a.602.602 0 0 0 .194-.037c.045 0 .099-.045.11-.1l-.017-.109Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    fill: "#000",
    d: "M97.505 288.001a.487.487 0 0 0-.36-.42.913.913 0 0 0-.486-.638.477.477 0 0 0-.36 0 .704.704 0 0 0-.263-.248.898.898 0 0 0-.751-.053c-.194.084-.36.226-.474.396a.333.333 0 0 0-.166 0 .607.607 0 0 0-.523.286.735.735 0 0 0-.112.396.507.507 0 0 0-.321.278.892.892 0 0 0-.055.465c.03.158.104.3.211.429a.526.526 0 0 0-.479.449.82.82 0 0 0 .263.75 1.15 1.15 0 0 0-.136.264.587.587 0 0 0 .119.601c.15.128.369.112.488-.037l.016-.022a.434.434 0 0 0 .164.451c.068.053.15.074.227.066.09-.016.165-.053.21-.12.044.127.166.21.302.203.111 0 .239-.188.291-.323a.653.653 0 0 1-.531-.263.617.617 0 0 1 0-.668.362.362 0 0 1 .226-.181.356.356 0 0 1 .285.066.39.39 0 0 0 .263-.248.436.436 0 0 0-.052-.367c.12 0 .231-.061.3-.166a.517.517 0 0 0 .055-.375c.188.074.375-.099.403-.338.083.09.21.127.33.104a.427.427 0 0 0 .149-.075.405.405 0 0 0 .111-.15c.127.145.34.168.496.062a.584.584 0 0 0 .16-.574Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    fill: "#FFB4A0",
    d: "M76.523 297.678s.104-1.644.375-1.764c.27-.12.263.826.263.826s.825-.586.969-.51c.203.27.308.601.3.944.12.302.182.615.195.933a2.137 2.137 0 0 1-.602.804c-.375.135-.75.225-1.142.262l-.358-1.495Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    fill: "#FFFFF6",
    d: "M78.122 325.363c0 .404-1.501 1.133-1.86 1.209a2.554 2.554 0 0 1-1.246-.293c-.302-.121-1.45.518-1.771.232a.703.703 0 0 1-.15-.475 6.82 6.82 0 0 1 .099-1.449.33.33 0 0 1 .264-.271c.06.053.81.75 1.11.697h.247c.27 0 .45-.969.549-1.201.18.074.354.182.51.303l.979.824v.029c.226.203.606 0 .75 0h.239a.317.317 0 0 1 .285.256v.137h-.004v.002h-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    fill: "#242424",
    d: "M77.912 325.001c-.51.5-1.133.867-1.816 1.074a2.56 2.56 0 0 1-1.246-.302c-.3-.119-1.434.513-1.765.24a7.21 7.21 0 0 1 .104-1.449.334.334 0 0 1 .264-.271c.061.054.811.75 1.111.697h.06c.256-.173.293-1.201.376-1.224a.6.6 0 0 1 .36.053c.18.074.353.181.51.302.346.254.676.524.978.823v.039c.225.195.606 0 .75 0 .104-.01.21-.003.314.018Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    fill: "#FFFFF6",
    d: "M75.998 323.861c-.098 0-.128.045-.182.135l-.119.211c-.053.113-.172.27-.12.412 0 .016.016.016.022.023l.028.008a.085.085 0 0 0 .062-.031.989.989 0 0 0 .226-.299c.075-.098.203-.229.173-.377-.029-.145-.045-.074-.09-.074v-.008Zm.54.301c-.127 0-.226.111-.313.209a1.705 1.705 0 0 0-.257.346c-.053.105 0 .256.128.195.104-.074.202-.158.293-.262.074-.076.22-.174.248-.301.03-.145-.016-.203-.099-.195v.008Zm-17.1 3.332c-.313.105-1.237-1.5-1.38-1.951a4.567 4.567 0 0 1-.062-1.568c0-.391-.75-1.621-.602-2.072a.546.546 0 0 1 .338-.301 4.449 4.449 0 0 1 1.172-.209c.18 0 .271.262.271.262a4.756 4.756 0 0 0-.293 1.805c.075.32.863.309 1.081.375a5.127 5.127 0 0 1-.113.676l-.42 1.365v.053a.064.064 0 0 1 0 .047c-.098.309.135.75.182.898.021.09.037.188.046.285a.313.313 0 0 1-.228.338l.008-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    fill: "#242424",
    d: "M59.656 327.164a5.68 5.68 0 0 1-1.262-1.936 4.615 4.615 0 0 1-.062-1.563c0-.392-.751-1.604-.603-2.063a4.452 4.452 0 0 1 1.172-.209c.181 0 .271.254.271.254a4.664 4.664 0 0 0-.283 1.576c.192.256 1.012.075 1.051.166.045.149.053.301.037.45a5.655 5.655 0 0 1-.112.675c-.128.532-.33 1.098-.421 1.358v.098c-.098.31.143.75.181.894.023.096.031.202.031.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    fill: "#FFFFF6",
    d: "M60.084 324.605a.219.219 0 0 0-.15-.184c-.061-.031-.123-.063-.188-.09-.098-.055-.248-.148-.354-.055a.115.115 0 0 0-.029.076c0 .029.015.045.029.061.082.084.18.156.293.211.09.063.226.188.338.111a.123.123 0 0 0 .053-.061.117.117 0 0 0 0-.074h.008v.005Zm-.075.713a.537.537 0 0 0-.247-.324 1.133 1.133 0 0 0-.33-.232l-.076.008a.134.134 0 0 0-.053.055.103.103 0 0 0-.015.072l.022.068c.073.105.172.203.271.285.075.076.188.219.3.225.016 0 .038 0 .053-.014.02-.01.032-.023.045-.037a.136.136 0 0 0 .03-.106Zm14.593 10.45c-.203.403-2.063-.076-2.479-.315a4.252 4.252 0 0 1-1.08-1.291c-.227-.359-1.704-.66-1.861-1.201a.873.873 0 0 1 .098-.578c.24-.479.533-.922.88-1.336.147-.194.403-.062.403-.062.149.563.405 1.104.75 1.578h.076a.507.507 0 0 0 .164.188c.271.194.954-.586 1.18-.752.127.228.248.459.347.699.18.551.354 1.104.524 1.657v.062c.111.358.602.496.75.601.082.053.166.121.227.194.148.149.148.39.021.556Zm5.914-2.944c-.188.354-1.83-.135-2.189-.346a3.712 3.712 0 0 1-.932-1.188c-.203-.33-1.502-.641-1.65-1.119a.866.866 0 0 1 .104-.523c.225-.412.495-.813.803-1.17.137-.174.361 0 .361 0 .111.51.321.998.614 1.434a.083.083 0 0 0 .054 0 .94.94 0 0 0 .148.172c.24.182.855-.494 1.059-.631.12.203.219.414.301.639l.442 1.441a.08.08 0 0 0 0 .053.08.08 0 0 0 0 .053c.091.33.524.451.64.547.074.055.144.121.201.189a.392.392 0 0 1 .044.449Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    fill: "#E5CFA5",
    d: "m80.997 290.938-.36 2.313-1.824-.441.578-3.107.594.15.52-.723.503 1.811h-.01v-.003h-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    fill: "#F7E1AE",
    d: "M83.34 289.188a1.816 1.816 0 0 0-.128-.313l-.284-.63-.062-.12a7.332 7.332 0 0 0-.556-2.356c-.375-.466-1.45-.074-1.45-.074a5.269 5.269 0 0 0-.884 2.506c-.1-.143-.228-.247-.375-.157a.875.875 0 0 0-.377 1.006.87.87 0 0 0 .87.623c.037.218.105.42.202.623 1.126 2.004 2.253 1.224 2.47.796a3.375 3.375 0 0 0 .212-1.546 1.09 1.09 0 0 0 .24-.104c.06-.037.119-.084.127-.149l-.005-.105Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    fill: "#FF5F5C",
    d: "M78.37 291.859a4.195 4.195 0 0 0-1.907.826 16.197 16.197 0 0 0-1.402 2.883l3.234 1.803 1.299-1.938v-1.92c0-.068-1.216-1.646-1.216-1.646l-.008-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    fill: "#FFC655",
    d: "M81.854 285.104a2.254 2.254 0 0 0-2.252-.367 2.477 2.477 0 0 0-1.502 2.178 4.086 4.086 0 0 0 0 1.179c.22.884.549 1.734.978 2.537.353-.293.678-.612.978-.961a1.011 1.011 0 0 1-.752-1.404s.375-.479.752.129a9.204 9.204 0 0 0 .877-2.313s.932-.347 1.396 0a.99.99 0 0 0-.183-.488 2.17 2.17 0 0 0-.3-.487h.009v-.003h-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    fill: "#FFFFF6",
    d: "M77.949 287.229s4.219-1.86 4.406-1.793c.188.074.367.826.285.9-.082.075-4.691 1.426-4.691 1.426v-.533Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    fill: "#FFC655",
    d: "M75.915 289.135c-.308.391-.54.855-.862 1.231a2.254 2.254 0 0 1-2.253.75 3.79 3.79 0 0 0 2.5 1.292c.353.052.714-.03 1.015-.219a2.02 2.02 0 0 0 .646-1.021c.137-.413.202-.85.301-1.275.074-.42.239-.817.475-1.179a.974.974 0 0 1 .959-.45c-.225-.061-.428-.248-.646-.264-.271 0-.54.045-.795.148a2.942 2.942 0 0 0-1.34.987Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    fill: "#FFFFF6",
    d: "M47.367 329.468c-.264.354-2.057-.577-2.432-.899a4.803 4.803 0 0 1-.88-1.563c-.173-.412-1.605-1.051-1.687-1.635 0-.203.06-.406.188-.572.307-.42.676-.803 1.08-1.141.18-.164.412 0 .412 0 .053.607.219 1.199.479 1.758a.123.123 0 0 0 .068.045.67.67 0 0 0 .135.23c.248.258 1.052-.375 1.299-.473.099.248.174.494.232.75.1.619.19 1.24.277 1.861.06.398.525.646.652.752.074.074.148.164.195.254a.463.463 0 0 1-.017.623l-.001.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    fill: "#FF5F5C",
    d: "M47.42 328.951c-.495.098-1.96-.676-2.305-.969a4.78 4.78 0 0 1-.87-1.553c-.173-.424-1.584-1.055-1.688-1.633a6.382 6.382 0 0 1 1.08-1.141c.18-.164.413 0 .413 0 .052.607.218 1.199.479 1.758a.16.16 0 0 0 .068.045c.33.119 1.07-.752 1.16-.668.12.119.213.271.272.43.09.246.174.492.232.75.127.613.22 1.234.277 1.859.06.396.525.641.652.752a.95.95 0 0 1 .226.375l.004-.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    fill: "#FFFFF6",
    d: "M46.525 325.994a.189.189 0 0 0-.111-.076.195.195 0 0 0-.135.008l-.24.061c-.137 0-.346.055-.398.232 0 .029 0 .061.018.082a.123.123 0 0 0 .06.053c.144.023.27.023.405 0 .136 0 .33 0 .404-.148a.23.23 0 0 0-.003-.212Zm.293.787a.54.54 0 0 0-.42-.127 1.134 1.134 0 0 0-.457 0c-.113.037-.15.248 0 .301.135.045.275.066.428.074.128 0 .3.074.42 0a.218.218 0 0 0 .029-.248Zm15.646 3.386c-.038.479-1.93 1.058-2.396 1.071a3.196 3.196 0 0 1-1.448-.6c-.338-.203-1.802.329-2.147-.068a.96.96 0 0 1-.127-.6 8.377 8.377 0 0 1 .315-1.714.382.382 0 0 1 .353-.276c.062.076.879 1.028 1.238 1.06h.075a.789.789 0 0 0 .218.082c.33 0 .66-1.072.818-1.336.2.135.39.284.563.459l1.066 1.192.037.045c.232.276.75.127.894.144.099 0 .195.021.285.062a.412.412 0 0 1 .256.479Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    fill: "#F29A7E",
    d: "M58.215 316.783c-.57-2.809-1.547-7.68-2.11-9.158l-3.331 2.68c1.064 2.104 2.207 4.863 3.076 6.988.856 2.124 2.605 1.238 2.365-.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    fill: "#F29A7E",
    d: "M58.395 317.855c-.158-1.125-.45-1.785-1.352-1.785-1.052 0-1.502 1.125-.87 6.004.292 2.447.817 5.029.968 6.006.217.75 1.065 1.547 1.358 1.547.751 0 .276-1.299.276-1.465-.132-3.963.13-7.049-.38-10.307Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    fill: "#FFFFF6",
    d: "M50.04 306.355c-.256.486-.474.982-.653 1.502-.15.518-.811 5.93-.811 5.93s3.415 1.359 3.617 1.502l.899-2.92 1.148 2.252 3.616-2.357-1.305-5.479-6.511-.43Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    fill: "#FF5F5C",
    d: "M62.253 329.716a5.032 5.032 0 0 1-2.32.925 3.346 3.346 0 0 1-1.454-.608c-.33-.201-1.771.329-2.141-.06.053-.578.15-1.156.314-1.714a.387.387 0 0 1 .36-.276c.06.076.878 1.029 1.23 1.052h.073c.33-.15.52-1.373.615-1.382.149 0 .3.046.42.136.21.129.398.285.57.45.376.384.729.781 1.066 1.201l.037.045c.226.276.75.127.886.144a.837.837 0 0 1 .344.087Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    fill: "#FFFFF6",
    d: "M60.105 328.005c-.104 0-.15 0-.227.127l-.173.226c-.082.129-.24.302-.202.474.01.045.053.074.098.065a.05.05 0 0 0 .03-.015 1.72 1.72 0 0 0 .322-.299c.099-.112.263-.256.239-.429-.01-.172-.026-.134-.087-.149Zm.616.42c-.156 0-.277.099-.396.203a1.739 1.739 0 0 0-.354.358c-.074.121 0 .315.127.257.137-.068.264-.15.375-.248.12-.074.286-.172.338-.322.052-.15 0-.239-.09-.248Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    fill: "#F29A7E",
    d: "M55.398 301.416c-.539.48-.824.518-1.299.129-.474-.391-.375-1.24 1.877-3.35 1.147-1.065 2.455-2.103 2.928-2.506.406-.265.451-.076.615.045.377.308.347.548.285.623-1.665 1.877-2.904 3.707-4.406 5.059Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    fill: "#F29A7E",
    d: "M61.059 294.75a7.38 7.38 0 0 1-.457 1.171c-.24.36-.752.571-.924.796a.754.754 0 0 1-.676.264.644.644 0 0 1-.495-.391c-.091-.436.397-.9.345-1.441.228-.135.076-.39.293-.75.062-.104.145-.51.195-.601.195-.173.195-.173.367-.135.173.038.195.112.533.315.338.202.962.344.819.772Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    fill: "#F29A7E",
    d: "m59.266 296.236-.302-2.027a.148.148 0 0 0-.15-.098c-.147 0-.147.148-.147.148a1.726 1.726 0 0 0-.111.541 3.129 3.129 0 0 1-.15 1.501m-3.478-5.672-.271 2.146-1.696-.33.128-2.762.87-.017.45-.685.52 1.651v-.005h-.001v.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    fill: "#FFB4A0",
    d: "M56.99 288.617a1.597 1.597 0 0 0-.135-.271l-.322-.539a.63.63 0 0 0-.061-.104 6.566 6.566 0 0 0-.705-2.089c-.377-.375-1.33.121-1.33.121a5.127 5.127 0 0 0-.602 2.401c-.104-.12-.227-.194-.36-.09a.925.925 0 0 0-.118 1.187.882.882 0 0 0 .713.24c.06.18.082.412.232.541 1.758 1.5 2.252.615 2.326.42.145-.474.165-.961.075-1.44a.921.921 0 0 0 .202-.127.265.265 0 0 0 .11-.158.296.296 0 0 0-.02-.09l-.004-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    fill: "#00B6A5",
    d: "M56.301 294.148a8.66 8.66 0 0 0-.466-1.621c-.495-.916-1.638-1.215-2.515-1.426a8.61 8.61 0 0 0-2.674-.172 1.21 1.21 0 0 0-.862.307.753.753 0 0 0 0 .977c-.247.09-.487.21-.705.36-.226.143-.384.36-.45.614a.724.724 0 0 0 0 .437.752.752 0 0 0 .391.474c.172.074.359.127.549.144-.053.383.188.75.254 1.133.182.944.393 6.253.393 6.253a22.985 22.985 0 0 1-.227 4.248c-.092.465-.27.907-.524 1.309.558.568 6.757 0 7.116-.398l.074-6.643a38.67 38.67 0 0 0-.354-5.996Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    fill: "#00B6A5",
    d: "M52.622 291.988a9.14 9.14 0 0 0-1.606 2.252c-.313.886-.863 4.406-.863 4.406l3.326 1.164s1.313-4.617 1.336-5.158c.023-.541.104-2.252-.42-2.327-.527-.075-1.773-.337-1.773-.337Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    fill: "#009983",
    d: "m51.781 293.234-.045.082.045-.074v-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    fill: "#28130F",
    d: "M52.089 287.656a5.84 5.84 0 0 0 .751 2.072c.143.248.285.451.354.428.195-.038.502-.406.502-.406s.076.428.285.331c.211-.099.265-.608.265-.608s-.75-.074-.849-.494c-.099-.414 0-.797.226-.879a.419.419 0 0 1 .403.113s.826-1.816.707-2.326c0 0 1.18.059 1.328-.271a1.946 1.946 0 0 0-.285-1.606c-.321-.263-.623.706-.623.706a2.256 2.256 0 0 0-2.491.503c-.487.45-.849.842-.577 2.439l.004-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    fill: "#FF5F5C",
    d: "M51.945 287.131a35.267 35.267 0 0 0 4.166-2.072s.264.685-.051.887a41.297 41.297 0 0 1-4.002 1.592 1.347 1.347 0 0 1-.119-.413l.006.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    fill: "#F29A7E",
    d: "M54.236 289.48a.623.623 0 0 1-.285.052.614.614 0 0 1-.563-.548c-.092-.405 0-.795.225-.879a.45.45 0 0 1 .414.112c.266.365.344.834.209 1.263Zm-4.894 11.98c.016-2.565.188-5.126.525-7.671l1.727 1.246c-.15 1.922-.037 4.556-.466 6.441-.428 1.885-1.621 1.471-1.786-.016Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    fill: "#F29A7E",
    d: "M50.415 302.841c-.698-.188-.886-.403-.825-1.012.074-.608.84-.992 3.844-.248 1.502.367 3.086.899 3.687 1.065.45.201.33.345.3.547-.044.488-.262.595-.357.578-2.468-.396-4.72-.425-6.65-.93Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    fill: "#028E7D",
    d: "M53.343 294.652c-.053.533-1.336 5.158-1.336 5.158l-3.325-1.164s.549-3.521.862-4.406c0 0 .63-2.68 2.649-2.133 1.405.375 1.262 1.209 1.15 2.545Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    fill: "#F29A7E",
    d: "M59.093 303.923a8.33 8.33 0 0 1-1.224.257 6.908 6.908 0 0 1-1.172-.339.744.744 0 0 1-.586-.422.631.631 0 0 1 .054-.629c.315-.301.978-.166 1.396-.496.232.113.375-.144.752-.149.127 0 .502-.166.606-.166.256.076.256.076.315.233.061.156 0 .226 0 .615s.286.984-.141 1.096Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    fill: "#F29A7E",
    d: "m56.848 303.24 1.502-1.352a.135.135 0 0 0 0-.188.135.135 0 0 0-.1-.066.158.158 0 0 0-.103.021 1.81 1.81 0 0 0-.523.195 3.159 3.159 0 0 1-1.337.699",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    fill: "#E5CFA5",
    d: "M80.247 289.607a.677.677 0 0 1-.902-.599c-.082-.465.065-.893.301-.968a.444.444 0 0 1 .44.149c.271.42.33.946.15 1.412l.011.006Zm2.327 28.812c-.578-1.651-1.292-3.754-2.027-5.676-.465-1.238-1.764.366-2.357.098l-.238.99c-.188.256-.75.219-.313.933.943 1.502 1.875 3.131 2.647 4.504 1.14 1.966 2.753.839 2.288-.849Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    fill: "#E5CFA5",
    d: "M82.416 320.257c.375-1.08.413-1.793-.391-2.207-.938-.479-1.823.347-3.498 4.955-.848 2.306-1.254 4.817-1.563 5.759a.945.945 0 0 0 .66 1.11c.639.321.396-.129.475-.271 1.674-3.603 3.303-6.23 4.317-9.346Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    fill: "#FFFFF6",
    d: "m77.012 328.447.291-1.568 1.862 1.201-.556 1.043-.78.998h-.75l-.166-1.133.1-.541Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    fill: "#14475A",
    d: "M80.502 332.375a4.125 4.125 0 0 1-2.087-.43 3.709 3.709 0 0 1-.931-1.188c-.195-.328-1.502-.631-1.637-1.109.225-.412.493-.803.803-1.17.136-.174.36 0 .36 0 .11.51.32.998.614 1.434a.086.086 0 0 0 .055 0c.299.045.84-.818.922-.75a.75.75 0 0 1 .285.314c.119.203.219.42.3.639.195.547.36 1.156.442 1.441a.074.074 0 0 0 0 .051.08.08 0 0 0 0 .053c.083.332.523.459.64.549.083.045.156.105.226.166h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    fill: "#FFFFF6",
    d: "M79.398 329.994a.183.183 0 0 0-.228 0l-.192.098c-.113.053-.287.098-.311.264a.077.077 0 0 0 0 .037.103.103 0 0 0 .038.063.059.059 0 0 0 .037.006.904.904 0 0 0 .346-.074c.112 0 .293-.053.33-.211a.145.145 0 0 0 .017-.09.146.146 0 0 0-.037-.093Zm.338.623a.453.453 0 0 0-.375-.037c-.137.01-.271.045-.391.105-.092.053-.105.238 0 .262.118.016.246.016.375 0 .104 0 .271 0 .358-.074.1-.09.108-.196.033-.256Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    fill: "#E5CFA5",
    d: "M77.018 319.71c.496-2.838 1.354-7.726 1.366-9.31l-3.618 1.142c.219 2.342-.173 5.479-.143 7.771.029 2.289 1.982 2.103 2.402.392l-.007.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    fill: "#E5CFA5",
    d: "M76.418 321.145c.338-1.09.354-1.804-.458-2.192-.944-.449-1.81.391-3.354 5.045-.75 2.336-1.426 4.887-1.695 5.834-.112.75.148.705.438.832.637.31.944.099 1.014-.054 1.576-3.647 3.138-6.327 4.054-9.457v-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    fill: "#FFFFF6",
    d: "m70.563 330.984.293-1.553 2.252.988-.75 1.277s-.916 1.611-1.238 1.363c-.324-.243-.557-2.075-.557-2.075Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    fill: "#14475A",
    d: "M74.579 335.271a4.56 4.56 0 0 1-2.364-.42 4.262 4.262 0 0 1-1.072-1.291c-.227-.361-1.683-.654-1.863-1.182.24-.479.533-.922.881-1.336.148-.193.404-.063.404-.063.148.572.404 1.104.75 1.578h.074c.338.037.924-.938 1.021-.895.135.09.247.211.322.346.135.225.248.457.346.697.204.545.38 1.098.525 1.66v.061c.11.359.601.494.75.602.09.072.167.154.226.243Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    fill: "#FFFFF6",
    d: "M73.678 333.328a.501.501 0 0 0-.428 0c-.15.014-.301.059-.436.127-.105.074-.105.27 0 .301h.428c.119 0 .3 0 .404-.113.1-.106.114-.248.032-.315Zm-.4-.676a.182.182 0 0 0-.118-.053.171.171 0 0 0-.12.045l-.231.111c-.076.046-.314.119-.338.309 0 .027 0 .053.014.076l.03.027.046.008c.135-.016.262-.045.392-.104.118-.045.32-.074.366-.232a.186.186 0 0 0-.037-.195v.008h-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    fill: "#009983",
    d: "M74.678 307.234a44.935 44.935 0 0 0-.564 7.791c.398.148.826.24 1.255.248a1.35 1.35 0 0 0 1.126-.615c.053.443.248.855.556 1.178.277.287.66.443 1.066.443a23.969 23.969 0 0 0 1.546-4.068 5.608 5.608 0 0 0 .275-2.094 3.325 3.325 0 0 0-2.05-2.674c-.99-.404-2.175-.209-3.21-.209Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    fill: "#00B6A5",
    d: "M81.125 312.007a2.282 2.282 0 0 1-1.329 1.144 1.866 1.866 0 0 1-1.606-.301c.1.412.047.854-.143 1.246a2.432 2.432 0 0 1-1.373 1.014l-.301-.293a7.76 7.76 0 0 1-1.975-3.258 5.77 5.77 0 0 1 .396-4.394h.396l1.06.045 3.399.166 1.3 4.062.176.569Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    fill: "#FFFFF6",
    d: "M81.125 312.007a2.282 2.282 0 0 1-1.329 1.144 1.866 1.866 0 0 1-1.606-.301c.1.412.047.854-.143 1.246a2.432 2.432 0 0 1-1.373 1.014l-.301-.293c.143-.036.277-.09.404-.166a1.55 1.55 0 0 0 .752-.944 2.689 2.689 0 0 0-.045-1.313 14.811 14.811 0 0 0-2.328-5.201l1.052.045a52.162 52.162 0 0 0 1.674 3.438c.24.596.677 1.09 1.224 1.404.422.135.888.072 1.254-.182.195-.129.385-.271.558-.436l.207.545Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    fill: "#E5CFA5",
    d: "M81.921 304.037c-.466.623-.751.75-1.336.404-.586-.348-.653-1.215 1.274-3.918.97-1.367 2.133-2.727 2.537-3.258.377-.361.467-.188.662-.076.465.24.479.496.428.601-1.358 2.327-2.267 4.504-3.565 6.247Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    fill: "#E5CFA5",
    d: "M86.469 295.824c-.053.449-.128.886-.232 1.32-.18.437-.651.752-.803 1.037a.812.812 0 0 1-.651.42.68.68 0 0 1-.608-.302c-.188-.44.227-1.034.061-1.591.203-.188 0-.428.149-.826 0-.128 0-.57.075-.676.165-.227.165-.227.354-.227.188 0 .239.076.64.227.392.137 1.075.129 1.015.618Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    fill: "#003948",
    d: "M86.657 296.792c-.353-.668-.3-.961.21-1.344.511-.384 1.352-.06 2.904 2.778a83.687 83.687 0 0 1 1.778 3.604c.15.473 0 .48-.21.6-.412.301-.639.219-.706.127-1.46-2.168-2.999-3.895-3.976-5.765Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    fill: "#003948",
    d: "M87.168 295.014a8.936 8.936 0 0 1 5.044-3.078l-.112 2.116c-1.703 1.081-2.012 1.577-3.851 2.425-1.84.839-2.23-.391-1.081-1.463Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    fill: "#28130F",
    d: "M90.996 300.695s.945.203 1.08.451c.136.248-.478.383-.478.383s.524.713.502.863c-.015.148-.345.402-.523.447 0 0-.393.348-.557.34-.174 0-.504-.322-.623-.449a8.814 8.814 0 0 1-.465-1.201l1.064-.834Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    fill: "#004D60",
    d: "M96.326 299.18a13.15 13.15 0 0 1-.512 1.502c-.614 1.657-1.584 4.022-1.584 4.022l-4.383-.925c.41-1.081 1.17-2.776 1.17-2.776s-.375-4.64-.412-5.458c-.045-.818 1.336-3.438 1.592-3.611.255-.172 1.262 0 1.262 0a5.995 5.995 0 0 1 2.529 2.252c.119.475.195.955.218 1.436.128 1.177.165 2.371.12 3.558Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    fill: "#004D60",
    d: "M95.807 294.127c.438.195.818 2.643 1 4.001.074.519.104 1.165.104 1.165l3.688-2.005.75.992s-3.002 3.497-4.393 3.653c-.641.075-1.074.144-2.611-2.438l-.074-.119a13.346 13.346 0 0 1-.691-1.366c-.75-1.824.314-4.055 1.982-3.935a.923.923 0 0 1 .245.052Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    fill: "#004D60",
    d: "M97.497 301.664c-.706.398-1.021.367-1.45-.164-.427-.533-.111-1.441 2.86-3.207 1.503-.885 3.177-1.695 3.755-2.034.518-.18.525 0 .675.203.338.437.233.677.149.751-2.236 1.65-4.03 3.376-5.99 4.451Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    fill: "#FF5F5C",
    d: "M78.37 291.859s2.351.607 2.59 1.127c.24.525 1.854 4.632 1.593 5.652-.265 1.021-1.201 3.379-1.201 3.379s-1.465 2.086-1.502 6.08c0 0-3.754 1.033-5.33-.633 0 0 2.252-6.229 2.252-7.004 0-.779-.623-4.204-.451-5.254.166-1.051.902-2.875 2.06-3.35h-.01v.003h-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    fill: "#E5CFA5",
    d: "M73.686 301.175a77.409 77.409 0 0 1 3.287-8.842l1.502 2.042c-.85 2.207-1.637 5.33-2.793 7.395-1.157 2.065-2.35 1.201-1.996-.595Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    fill: "#E5CFA5",
    d: "M74.443 303.134c-.75-.465-.9-.75-.602-1.5.33-.811 1.313-.879 4.579 1.035 1.649.97 3.312 2.14 3.963 2.554.443.383.257.51.15.75-.226.549-.519.603-.632.541-2.773-1.276-5.348-2.089-7.458-3.38Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    fill: "#E5CFA5",
    d: "M84.225 307.445c-.496 0-.998-.047-1.502-.129-.51-.15-.931-.66-1.261-.795a.922.922 0 0 1-.541-.707.86.86 0 0 1 .046-.412.801.801 0 0 1 .247-.338c.474-.256 1.193.148 1.802-.09.24.211.488-.045.96.072.15.049.64 0 .753 0 .27.166.27.166.29.385.024.219-.06.271-.18.752-.118.479-.06 1.281-.606 1.262h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    fill: "#E5CFA5",
    d: "m81.868 305.846 2.252-1.066s.098-.053.062-.211a.171.171 0 0 0-.084-.104.177.177 0 0 0-.135-.016 1.756 1.756 0 0 0-.684.053 4.074 4.074 0 0 1-1.809.354m3.438-7.088-.751-2.072s0-.09-.181-.073-.119.188-.119.188a1.646 1.646 0 0 0 0 .602c.181.518.23 1.066.164 1.605",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    fill: "#EF3A3A",
    d: "M76.463 292.686a15.362 15.362 0 0 0-1.402 2.883l3.242 1.804 1.299-1.938s.887-1.439.475-2.506c-.422-1.066-1.959-2.043-3.611-.248l-.003.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    fill: "#D36E46",
    d: "M106.895 301.439a1.5 1.5 0 0 0-.074 1.967c.813.861 1.73 1.617 2.732 2.252v-2.043l-2.65-2.176h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    fill: "#28130F",
    d: "M93.676 311.852c-.2 1.5-.396 3.002-.473 4.239-.24 1.75-2.154 2.146-2.432-.135a158.595 158.595 0 0 0-.608-4.504c1.14.307 2.327.45 3.513.4Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    fill: "#A06E5F",
    d: "m120.805 292.078-.759 1.967-1.554-.908.751-2.604.848.283.601-.493.113 1.755Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    fill: "#B67D69",
    d: "M123.253 290.876a2.513 2.513 0 0 0-.075-.308l-.181-.631v-.119a7.348 7.348 0 0 0-.202-2.252c-.271-.504-1.299-.36-1.299-.36a4.454 4.454 0 0 0-1.135 2.103c-.074-.149-.172-.271-.314-.219a.855.855 0 0 0-.391 1.096c.128.24.354.42.615.48.016.203.054.404.111.602.751 2.041 1.997 1.373 2.133 1.215.239-.412.377-.877.397-1.356l.226-.045c.062 0 .119-.054.137-.112a.26.26 0 0 0-.022-.094Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    fill: "#000",
    d: "M121.376 287.386a14.615 14.615 0 0 1-1.028 2.117c-.119-.157-.203-.353-.391-.255a.738.738 0 0 0-.219 1.018c.018.025.035.049.054.071.045.045.429.263.42.347v.314c0 .105-.045.232-.127.248a.199.199 0 0 1-.136 0 1.272 1.272 0 0 1-.375-.359c0 .111.053.27 0 .314-.053.044-.157 0-.211-.112a4.893 4.893 0 0 1-.705-1.419 3.295 3.295 0 0 1-.157-1.404c.03-.449.285-.854.677-1.08a1.108 1.108 0 0 1 .217-.849c.172-.21.392-.383.64-.495a6.611 6.611 0 0 1 2.896-.466.5.5 0 0 1 .211 0 .209.209 0 0 1 .098.203.28.28 0 0 1-.098.157 3.04 3.04 0 0 1-.429.353 1.91 1.91 0 0 1 1.276.158.25.25 0 0 1 .15.181.302.302 0 0 1-.15.262 4.804 4.804 0 0 1-.871.504c.105.045.21 0 .308 0 .03 0 .062.016.083.029a.21.21 0 0 1 .105.135v.084a.223.223 0 0 1-.174.149 2.588 2.588 0 0 1-2.064-.205Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    fill: "#B67D69",
    d: "M114.62 318.645c1.246-2.574 4.022-7.433 4.504-8.946l-4.864.502c-.436 2.313-1.201 5.209-1.81 7.409-.607 2.199 1.307 2.574 2.17 1.035Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    fill: "#B67D69",
    d: "M112.24 319.402c1.066.412 1.779.473 2.215-.314.51-.916-.277-1.832-4.818-3.68-2.253-.916-4.791-1.711-5.714-2.049-.751-.158-.751.293-.924.557-.353.629-.09.75.054.848 3.543 1.793 6.109 3.519 9.187 4.638Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    fill: "#003948",
    d: "M119.124 310.057s-.871 2.153-1.931 4.442a17.704 17.704 0 0 1-3.646-2.438l1.674-6.006 3.903 4.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    fill: "#FFFFF6",
    d: "M101.633 319.621c-.375-.137-.525-2.523-.449-3.094a4.903 4.903 0 0 1 .75-1.658c.228-.383.045-2.252.428-2.605a.498.498 0 0 1 .488-.053 5.48 5.48 0 0 1 1.313.676c.21.127.157.473.157.473-.074.063-.961.889-1.051 1.322v.098a.667.667 0 0 0-.09.246c-.084.393.75.992.922 1.227-.136.217-.291.42-.457.602l-1.125 1.096-.047.039-.045.045c-.264.24-.226.863-.271 1.059a1.211 1.211 0 0 1-.099.338.277.277 0 0 1-.302.24.401.401 0 0 1-.122-.051Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    fill: "#00B6A5",
    d: "M102.016 319.447a8.68 8.68 0 0 1-.33-3.002 4.925 4.925 0 0 1 .75-1.666c.228-.377.045-2.254.42-2.59a5.52 5.52 0 0 1 1.314.674c.202.129.148.475.148.475-.074.059-.961.885-1.043 1.32v.098c.076.42 1.015.848 1.007.977a1.075 1.075 0 0 1-.181.494 4.528 4.528 0 0 1-.451.609c-.359.389-.734.75-1.125 1.088l-.053.037-.045.045c-.257.24-.227.863-.265 1.059a.922.922 0 0 1-.149.375l.003.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    fill: "#FFFFF6",
    d: "M103.758 317.121a.349.349 0 0 0-.061-.301l-.149-.24c-.075-.127-.188-.346-.346-.322-.157.021-.075.074-.075.135.053.158.12.301.203.449.074.129.148.369.3.377a.13.13 0 0 0 .128-.098Zm-.399.675a.947.947 0 0 0-.098-.524 2.006 2.006 0 0 0-.227-.479c-.083-.112-.248-.054-.227.11.027.173.07.341.127.505.055.149.084.375.195.448.037.039.082.045.129.03.045-.008.073-.038.096-.084v-.006h.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    fill: "#B67D69",
    d: "M124.979 315.957c-.301-1.111-.676-1.727-1.576-1.607-1.034.129-1.307 1.309-.111 6.061.602 2.387 1.439 4.879 1.704 5.824.18.715.396 1.418.651 2.104.57 1.428.97 1.104 1.193 1.072.594-.074.264.354.396-1.098a15.842 15.842 0 0 0-.404-2.032c-.637-3.89-.952-7.156-1.853-10.324Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    fill: "#B67D69",
    d: "M124.604 314.854c-1.66-2.328-4.504-6.396-5.646-7.506l-2.554 5.254c1.824 1.502 4.828 2.688 6.229 3.754 1.849 1.298 2.894-.001 1.971-1.502Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    fill: "#FFFFF6",
    d: "M131.202 328.869c.045.486-1.688 1.561-2.14 1.703a3.01 3.01 0 0 1-1.502-.195c-.375-.105-1.703.818-2.108.518a.843.843 0 0 1-.24-.547 9.559 9.559 0 0 1 0-1.758.418.418 0 0 1 .3-.359c.068.063 1.036.75 1.389.691h.076a.645.645 0 0 0 .232 0c.314-.061.45-1.225.555-1.502.228.074.43.172.631.293l1.246.871a.058.058 0 0 1 .045 0h.045c.285.201.752-.076.901-.105a.852.852 0 0 1 .285 0c.136.037.255.126.285.39Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    fill: "#00B6A5",
    d: "M130.917 328.486a5.558 5.558 0 0 1-2.103 1.5c-.502.061-1.015 0-1.502-.188-.359-.104-1.674.804-2.103.519a9.537 9.537 0 0 1 0-1.756.47.47 0 0 1 .099-.226.455.455 0 0 1 .203-.135c.066.059 1.034.75 1.389.688h.074c.284-.24.248-1.503.346-1.503a.77.77 0 0 1 .451 0c.217.076.428.175.623.293.436.257.854.55 1.246.871h.098c.285.203.75-.073.9-.104.091.002.18.01.279.041Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    fill: "#FFFFF6",
    d: "M128.514 327.404c-.111 0-.15.076-.195.188-.053.084-.09.174-.127.264-.061.15-.188.354-.111.52.02.037.063.053.102.035a.095.095 0 0 0 .034-.035c.099-.121.188-.256.257-.393.073-.127.217-.313.164-.479-.055-.166-.063-.108-.124-.1Zm.675.241c-.157 0-.254.174-.354.31a1.94 1.94 0 0 0-.283.448c-.048.138.059.302.172.228a3.34 3.34 0 0 0 .33-.36c.09-.11.246-.24.264-.403.03-.171-.03-.24-.129-.223Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    fill: "#004D60",
    d: "M121.834 310.296a8.676 8.676 0 0 1-1.456 1.914 12.226 12.226 0 0 1-2.253 1.688c-1.816-1.308-3.625-2.739-4.158-3.604-1.201-1.905 0-4.813 0-4.813l5.143 1.104 2.724 3.711Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    fill: "#A06E5F",
    d: "M121.15 304.126c-.607.488-.908.511-1.396.074-.488-.449-.338-1.353 2.199-3.498 1.275-1.08 2.738-2.117 3.258-2.529.458-.255.503-.06.676.091.383.354.33.601.264.685-1.892 1.92-3.319 3.81-5.001 5.177Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    fill: "#A06E5F",
    d: "M127.576 297.295c-.15.42-.33.826-.549 1.225-.284.375-.824.578-1.035.804a.748.748 0 0 1-.75.239.683.683 0 0 1-.512-.442c-.074-.465.465-.945.451-1.501.238-.127.104-.413.346-.75.074-.113.18-.533.246-.623.219-.182.219-.182.406-.137.188.047.201.137.549.369.344.223 1.029.365.848.816Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    fill: "#FFC13E",
    d: "M121.602 300.072a21.005 21.005 0 0 1-.602 1.779 552.647 552.647 0 0 1-1.861 4.734l-5.143-1.104c.486-1.269 1.381-3.271 1.381-3.271s-.436-5.441-.488-6.419c-.052-.978 1.569-4.039 1.869-4.241.301-.201 1.502 0 1.502 0 1.352.698 2.702 1.907 3.004 2.643.135.557.225 1.119.254 1.683.129 1.396.15 2.799.075 4.196h.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    fill: "#FFFFF6",
    d: "M121.602 300.072a17.147 17.147 0 0 1-.602 1.779 5.698 5.698 0 0 1-2.2-.75l.677-2.188a33.25 33.25 0 0 0-.578-3.002 5.005 5.005 0 0 1 2.566 0c.151 1.384.187 2.78.137 4.161Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    fill: "#A06E5F",
    d: "M110.964 295.043c.826-.676 1.914-1.449 3.003-2.2 1.914-1.298 2.439 1.255 1.141 2.162a19.853 19.853 0 0 1-2.857 1.733c-2.135 1.007-2.616-.449-1.287-1.695Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    fill: "#A06E5F",
    d: "M110.438 297.077c-.345-.826-.271-1.156.369-1.546.637-.391 1.575.06 3.114 3.521.751 1.74 1.448 3.662 1.728 4.367.144.578-.084.572-.293.707-.512.299-.752.181-.842.065-1.5-2.67-3.123-4.832-4.076-7.114Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    fill: "#A06E5F",
    d: "M115.873 306.289a9.796 9.796 0 0 1-1.171-.992 8.372 8.372 0 0 1-.548-1.389.926.926 0 0 1 0-.885.755.755 0 0 1 .646-.422c.541.074.886.816 1.503.982.066.311.42.24.75.623.098.111.524.367.6.475.138.283.13.301 0 .473-.127.18-.209.18-.576.496-.378.314-.768.976-1.204.639Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    fill: "#A06E5F",
    d: "m114.859 303.63 2.478.466s.104 0 .165-.136a.172.172 0 0 0 0-.144.164.164 0 0 0-.104-.082 1.765 1.765 0 0 0-.586-.36 3.957 3.957 0 0 1-1.674-.75",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    fill: "#FFA506",
    d: "M115.678 291.387a17.02 17.02 0 0 0-3.003 1.997l2.117 3.558 2.326-1.141s1.682-.9 1.877-2.146c.194-1.255-.722-3.063-3.312-2.267h-.006v-.001h.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    fill: "#D36E46",
    d: "m105.395 311.58-.24 3.123s3.369 2.846 3.852 2.703c.479-.129 1.924-2.088 1.924-2.088v-2.912l-5.525-.826h-.011Zm-4.85-8.452a67.389 67.389 0 0 1 7.941-3.272l-.412 2.297c-2.006.796-4.579 2.216-6.682 2.726-2.101.507-2.266-.902-.847-1.751Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    fill: "#D36E46",
    d: "M99.629 304.787c-.037-.811.128-1.074.805-1.209.674-.135 1.336.541 1.567 3.994.112 1.734.075 3.596.112 4.293-.074.541-.271.451-.487.504-.541.111-.751-.076-.751-.195-.428-2.778-1.141-5.135-1.246-7.387Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    fill: "#D36E46",
    d: "M101.416 314.38a9.053 9.053 0 0 1-.676-1.2 7.533 7.533 0 0 1-.045-1.367.85.85 0 0 1 .255-.75c.19-.162.45-.22.69-.149.436.226.502.978.998 1.313-.037.285.276.347.428.75.045.127.338.479.375.594 0 .3 0 .3-.149.421-.135.127-.226.073-.638.231-.413.157-.991.594-1.231.166l-.007-.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    fill: "#D36E46",
    d: "m101.37 311.798 1.976 1.17s.074.046.188-.059a.154.154 0 0 0 .014-.214l-.014-.014a1.706 1.706 0 0 0-.392-.494 3.724 3.724 0 0 1-1.201-1.188m13.887 14.739c-.33-1.314-.75-2.041-1.824-1.93-1.238.135-1.576 1.502-.24 7.176.676 2.846 1.916 5.602 2.215 6.758.211.549.813.84 1.375.668.849-.09.314-.383.293-.57-.69-4.693-.78-8.363-1.811-12.102h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    fill: "#FFFFF6",
    d: "m117.779 337.471-.479 1.217-1.606-1.276-.098-.39-.074-.256-.045-.188-.09-.33-.099-.369-.112-.412 2.229-.486.374 2.49Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    fill: "#FFFFF6",
    d: "M121.855 338.582c0 .525-1.922 1.547-2.416 1.666a3.346 3.346 0 0 1-1.646-.33c-.396-.15-1.884.752-2.313.375a.882.882 0 0 1-.227-.6c-.029-.639 0-1.277.098-1.914a.455.455 0 0 1 .338-.375c.076.074 1.082.922 1.502.877h.074a.95.95 0 0 0 .256.039c.354-.047.557-1.293.676-1.607.24.09.475.217.677.367.474.354 1.051.826 1.319 1.045l.047.045c.016 0 .037.014.053.037.293.24.796 0 .977-.045a.723.723 0 0 1 .314 0c.107.022.257.127.271.42Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    fill: "#FF5F5C",
    d: "M121.57 338.146a5.921 5.921 0 0 1-2.356 1.502 3.507 3.507 0 0 1-1.651-.338c-.391-.145-1.859.75-2.305.396-.029-.646 0-1.275.098-1.916a.45.45 0 0 1 .338-.375c.076.076 1.082.924 1.502.879h.074c.33-.238.354-1.592.467-1.629a.748.748 0 0 1 .474.063c.231.09.466.217.677.357.449.311.887.646 1.299.998l.053.055c.016 0 .037.016.053.035.293.24.796 0 .977-.051.098.003.196.003.3.024Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    fill: "#FFFFF6",
    d: "M119.018 336.773c-.119 0-.156.061-.225.18l-.15.277c-.074.148-.218.359-.143.549l.016.037c.01.012.022.02.037.021.029.012.063 0 .082-.021a1.58 1.58 0 0 0 .301-.406c.09-.127.256-.314.211-.502-.015-.06-.061-.151-.129-.135Zm.72.314c-.172 0-.284.166-.404.302a2.51 2.51 0 0 0-.322.465c-.061.144.045.338.172.248a2.27 2.27 0 0 0 .377-.354c.104-.111.276-.24.299-.412.036-.172-.016-.256-.122-.249Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    fill: "#003948",
    d: "M115.828 325.738c-.458-2.252-2.409-5.525-3.514-7.709-.705-1.396-.938-2.426-1.39-3.123l-1.364 3.393c-.195.33-1.098 1.951-1 2.178.826 2.059 2.364 3.662 4.25 5.254a4.904 4.904 0 0 0 .262 1.832l2.764-1.822-.008-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    fill: "#D36E46",
    d: "M100.229 331.518c1.238-.651 1.869-1.261 1.502-2.297-.436-1.209-1.914-1.216-7.252 1.502a47.967 47.967 0 0 0-4.504 2.726c-.75.563-.111 1.065 0 1.411.3.824.24.75.42.677 4.543-1.827 6.335-2.082 9.834-4.019Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    fill: "#FFFFF6",
    d: "m92.88 334.648-.907.211s-1.502.053-1.703-.752c-.121-.547 1.142-1.703 1.225-1.771l.436-.217.149-.068.135-.074.669 2.682-.003-.011Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    fill: "#FFFFF6",
    d: "M90.064 339.807c-.428 0-1.104-2.486-1.155-3.103a5.843 5.843 0 0 1 .397-1.996c.148-.479-.451-2.388-.127-2.883a.585.585 0 0 1 .51-.226c.51.015 1.014.11 1.502.271.24.067.277.442.277.442a5.298 5.298 0 0 0-.813 1.748v.099a1.29 1.29 0 0 0-.053.301c0 .437.998.789 1.246.978a5.042 5.042 0 0 1-.354.795 32.62 32.62 0 0 1-.943 1.502v.104c-.228.345-.047.99-.04 1.199v.397a.347.347 0 0 1-.3.383.48.48 0 0 1-.147-.011Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    fill: "#FF5F5C",
    d: "M90.439 339.49a8.772 8.772 0 0 1-1.012-3.002 5.839 5.839 0 0 1 .395-2.004c.15-.477-.449-2.352-.143-2.869a5.04 5.04 0 0 1 1.5.271c.24.066.278.441.278.441a5.387 5.387 0 0 0-.812 1.75.8.8 0 0 0 0 .098c.166.421 1.27.556 1.274.691.017.192-.015.396-.073.584a5.857 5.857 0 0 1-.359.797 15.613 15.613 0 0 1-.946 1.5v.104c-.218.347-.045.991-.037 1.2 0 .15-.03.302-.075.438l.01.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    fill: "#FFFFF6",
    d: "M91.747 336.359a.298.298 0 0 0-.128-.285l-.21-.209c-.075-.076-.277-.301-.437-.227a.148.148 0 0 0-.054.074.156.156 0 0 0 .017.1c.076.143.18.275.3.396.105.119.24.33.392.299a.157.157 0 0 0 .082-.059.153.153 0 0 0 .038-.089Zm-.302.976a.884.884 0 0 0-.225-.51 1.792 1.792 0 0 0-.347-.451c-.104-.074-.271 0-.218.203.074.172.156.33.256.487.082.144.172.367.314.42l.074.017a.178.178 0 0 0 .074-.03.131.131 0 0 0 .045-.054.19.19 0 0 0 .016-.074l.01-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    fill: "#14475A",
    d: "M110.928 314.906a34.981 34.981 0 0 1-4.505 9.758c-2.012 2.92-4.43 5.848-4.864 5.9a118.326 118.326 0 0 0-1.84-1.779c.443-3.115 3.102-7.318 3.102-7.318s.203-2.852.384-3.807c.181-.961 1.959-3.385 1.959-3.385l5.764.631Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    fill: "#D36E46",
    d: "m109.298 297.266-.256 2.59-2.026-.31.188-1.914.901-1.457.523-.841.676 1.938-.006-.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    fill: "#E57A47",
    d: "M112.105 295.666a2.025 2.025 0 0 0-.113-.354l-.27-.75c-.018-.045-.033-.09-.055-.136 0-.899-.148-1.802-.441-2.649-.375-.547-1.576-.239-1.576-.239a5.59 5.59 0 0 0-1.156 2.657c-.098-.166-.225-.301-.396-.211a1.052 1.052 0 0 0-.361 1.358c.182.271.475.443.789.48.021.239.082.473.172.696 1.09 2.328 2.509 1.359 2.65 1.148a3.604 3.604 0 0 0 .346-1.674.84.84 0 0 0 .271-.09.219.219 0 0 0 .148-.15l-.008-.086Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    fill: "#ADADAD",
    d: "M111.76 292.828a2.512 2.512 0 0 0-.045-.75 4.419 4.419 0 0 0-.285-.842 2.388 2.388 0 0 0-1.291-1.178 3.464 3.464 0 0 0-1.629-.158 7.213 7.213 0 0 0-3.273 1.547c-.448.375-.93.728-1.434 1.035a8.04 8.04 0 0 1-1.727.752 4.757 4.757 0 0 0-2.252.916 3.43 3.43 0 0 0-.752 2.813 3.76 3.76 0 0 0 1.201 2.356 3.339 3.339 0 0 0 3.965.392c.479-.369.976-.698 1.5-.992.549-.225 1.277 0 1.503-.645a6.303 6.303 0 0 1 1.034-1.765c.092-.129.264-.429.361-.557h-.174l-.181-.052a.773.773 0 0 1-.277-.144.903.903 0 0 1-.321-.615c-.045-.474.436-.977.854-.713.211.194.354.459.393.752a6.324 6.324 0 0 0 .51-1.899 2.274 2.274 0 0 0 1.021-.353c-.09.263-.239.494-.428.688a2.84 2.84 0 0 0 1.727-.603v.015Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    fill: "#004D60",
    d: "M113.02 306.348c-.23 1.144-1.838 3.498-1.838 3.498s.111.961.256 2.463a9.114 9.114 0 0 1-6.262-.826c.33-.931.578-1.897.75-2.875-.052-.854-1.021-4.504-.908-5.705.113-1.187.752-3.204 2.043-3.836 0 0 2.739.451 3.047.998.308.54 3.138 5.134 2.912 6.283Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    fill: "#D36E46",
    d: "M108.697 304.164a70.13 70.13 0 0 0 5.906 6.246c1.32 1.006 2.554.352 1.33-1.428-1.231-1.771-3.478-3.678-4.939-5.254-1.84-3.498-4.909-1.996-2.29.436h-.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    fill: "#D36E46",
    d: "M116.721 310.125c-.353.75-.631.877-1.283.676-.651-.203-.916-1.127.525-4.258.75-1.584 1.65-3.205 1.967-3.828.314-.443.442-.285.66-.217.525.172.594.428.557.533-.931 2.649-1.442 5.058-2.426 7.094Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    fill: "#D36E46",
    d: "M119.77 300.846c.037.465.037.932 0 1.396-.099.479-.519.898-.615 1.217a.835.835 0 0 1-.586.557.75.75 0 0 1-.676-.195c-.276-.412 0-1.096-.256-1.637.174-.232-.074-.438 0-.877 0-.139-.066-.588-.045-.699.127-.271.127-.271.322-.301.195-.037.248 0 .684.104.436.103 1.14-.076 1.172.435Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    fill: "#D36E46",
    d: "m118.546 303.121-1.171-1.953s-.053-.09-.203-.045a.2.2 0 0 0-.053.031.15.15 0 0 0-.037.18c0 .211.037.42.111.615.285.496.451 1.051.479 1.613",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    fill: "#003948",
    d: "m72.109 306.326 1.027 3.438-2.986 1.516-.594-1.35.276-3.297 1.509-.307h.768Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    fill: "#14475A",
    d: "M71.411 304.945a8.452 8.452 0 0 1-.12 2.424 221.79 221.79 0 0 1-1.402 4.879l-1.953-1.059-.271-1.5-.429.916-1.215-.348s-.1-2.49 0-3.354a12.96 12.96 0 0 1 1.224-3.004l4.166 1.046Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    fill: "#28130F",
    d: "M66.577 302.947s-3.363-4.549-3.498-5.449c-.136-.9 3.753-4.129 4.31-4.459.555-.338 1.5-.833 1.98-.225.813 1.104.227 1.854-.45 2.537-.683.676-3.558 2.807-3.558 2.807l2.252 3.934-1.036.855Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    fill: "#28130F",
    d: "M67.605 302.091s1.307-.338 1.5-.036c.194.301-.569.532-.569.532s.69.826.668 1.006c-.022.181-.412.556-.646.632 0 0-.459.474-.678.485-.201.017-.638-.336-.795-.485a6.93 6.93 0 0 1-.523-1.276l1.043-.858Zm2.831-11.139-.194 1.959-1.548-.233.137-1.457.689-1.103.397-.646.519 1.48Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    fill: "#3F1E19",
    d: "M72.582 289.729a1.702 1.702 0 0 0-.082-.277l-.21-.549a.812.812 0 0 0-.038-.104c0-.685-.12-1.364-.338-2.012-.285-.42-1.201-.181-1.201-.181a4.202 4.202 0 0 0-.878 2.02c-.075-.127-.173-.227-.3-.165a.799.799 0 0 0-.278 1.036.845.845 0 0 0 .601.368c.022.18.067.358.137.524.824 1.771 1.906 1.035 2.012.877a2.79 2.79 0 0 0 .266-1.274.744.744 0 0 0 .209-.075.213.213 0 0 0 .111-.104l-.011-.084Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    fill: "#FCDEA9",
    d: "M69.887 289.796c-.074.097-.195.323-.27.42a4.81 4.81 0 0 0-.752 1.353 3.003 3.003 0 0 1-2.109-1.411 1.478 1.478 0 0 1-.27-.653c.313-.083.584-.285.75-.57.181-.301.301-.639.354-.982.067-.354.09-.752.188-1.043.15-.467.451-.871.871-1.141a2.843 2.843 0 0 1 1.246-.414c.416-.058.84-.017 1.238.121.428.164.773.486.977.899.1.203.174.42.227.638a2.47 2.47 0 0 1 0 .557l-.906.149-.258-.696v.631c-.21.06-.42.104-.63.135a4.93 4.93 0 0 1-.392 1.441.92.92 0 0 0-.3-.603c-.323-.21-.698.21-.677.57.03.173.12.329.27.436a.689.689 0 0 0 .203.113l.145.038s.09.029.104.015l-.009-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    fill: "#FFFFF6",
    d: "M68.7 292.266s2.088.354 2.32.75c.23.398 2.417 3.948 2.253 4.827a11.865 11.865 0 0 1-1.396 2.657s.354 3.094.563 6.418l-1.236.158a7.237 7.237 0 0 1-5.045-1.854s1.727-5.055 1.688-5.705c-.037-.654-.75-3.455-.688-4.341.056-.884.559-2.43 1.542-2.91Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    fill: "#28130F",
    d: "M76.884 299.171s-4.504 2.703-5.255 2.599c-.751-.104-2.146-5.594-2.252-6.357-.111-.768-.227-2.042.375-2.402 1.098-.66 1.502.248 1.854 1.239.354.991 1.18 5.015 1.18 5.015l3.7-1.576.398 1.482Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    fill: "#28130F",
    d: "M72.402 301.492c-.676.262-.953.188-1.262-.346-.31-.525.09-1.277 2.957-2.455 1.44-.602 3.004-1.096 3.609-1.313.475-.09.458.09.563.271.24.429.127.632 0 .677-2.173 1.16-3.983 2.438-5.867 3.166Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    fill: "#28130F",
    d: "M80.089 297.279c-.263.332-.54.639-.841.924-.354.256-.9.277-1.141.42a.749.749 0 0 1-.752 0 .643.643 0 0 1-.321-.54c.067-.437.69-.706.825-1.224.256-.045.209-.33.533-.578.09-.075.313-.42.396-.488.239-.09.239-.09.392 0 .15.09.149.18.39.488.24.308.782.646.519.998Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    fill: "#28130F",
    d: "m77.837 298.029.437-2.004s0-.09-.104-.149a.149.149 0 0 0-.062-.015.168.168 0 0 0-.053.015.155.155 0 0 0-.053.03.092.092 0 0 0-.021.052 1.87 1.87 0 0 0-.31.474c-.12.495-.351.957-.675 1.352",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cypress",
    className: "cypress"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    fill: "#72493E",
    d: "M180.514 277.305h-1.861v9.924h1.861v-9.924Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    fill: "#A0D755",
    d: "M183.313 274.001c0 3.647-1.666 6.614-3.752 6.614-2.088 0-3.754-2.965-3.754-6.606 0-11.583 1.674-26.469 3.754-26.469 2.078.001 3.752 14.886 3.752 26.461Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    fill: "#8CBE4B",
    d: "M178.652 274.001c0-9.496.84-21.199 1.996-25.11-.338-.854-.69-1.351-1.065-1.351-2.058 0-3.754 14.886-3.754 26.454 0 3.656 1.674 6.621 3.754 6.621.375 0 .758-.105 1.097-.293-1.18-.825-2.028-3.333-2.028-6.321Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bush",
    className: "bush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    fill: "#B8C100",
    d: "M186.195 306.542a3.216 3.216 0 0 1 2.83 2.058 3.006 3.006 0 0 1 2.604-1.847c1.684 0 3.049 1.697 3.049 3.8 0 .651-.136 1.299-.404 1.891 1.785 0 3.233 1.804 3.233 4.031 0 2.229-1.448 4.039-3.233 4.039-1.787 0-8.738-.392-9.969-.392-1.796 0-1.391-7.272-1.391-9.519.002-2.249 1.518-4.061 3.281-4.061Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    fill: "#DBDB03",
    d: "M175.957 313.27h.165v-.313c0-1.502.991-2.748 2.207-2.748a2.007 2.007 0 0 1 1.456.688 2.544 2.544 0 0 1 2.162-1.396c1.5 0 2.673 1.5 2.673 3.34 0 .429-.062.854-.188 1.263 1.354.082 2.44 1.5 2.44 3.188 0 1.688-1.147 3.196-2.562 3.196-.391 0-8.063-.375-8.332-.375-1.5 0-2.717-1.5-2.717-3.407 0-1.897 1.199-3.438 2.701-3.438h-.007l.002.002Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    fill: "#EA4E4E",
    d: "M583.787 326.796h-4.248v-4.805a.753.753 0 0 0-.188-.556.68.68 0 0 0-.232-.183.775.775 0 0 0-.285-.073h-4.24a.723.723 0 0 0-.549.231.618.618 0 0 0-.158.271.717.717 0 0 0-.045.301v4.806H569.6a.748.748 0 0 0-.705.793v4.83c-.016.2.053.397.188.547a.747.747 0 0 0 .229.183c.09.045.195.073.293.073h4.24v4.813c-.01.104 0 .201.045.299a.734.734 0 0 0 .707.496h4.238a.75.75 0 0 0 .705-.793v-4.815h4.248a.751.751 0 0 0 .707-.793v-4.815c0-.098 0-.203-.027-.301a.693.693 0 0 0-.15-.254.739.739 0 0 0-.531-.255Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    fill: "#877373",
    d: "M80.568 527.451s7.846-9.535 17.326 0H80.568Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    fill: "#44AA85",
    d: "M89.434 519.734c.715.143 3.453.447 4.73-3.252a1.726 1.726 0 0 1-1.885.346c-.826-.322-2.027.211-2.635 1.299.201-2.356-.203-3.979-.287-6.117v-.895c.48-.1 3.453-.863 3.281-5.045a1.855 1.855 0 0 1-1.613 1.135c-.96.053-1.989 1.299-1.977 2.762a5.462 5.462 0 0 0-.275 1.779c.053 1.096.18 2.189.375 3.271a4.703 4.703 0 0 0-.525-.916c-1.225-1.656-2.566-1.859-2.822-2.252a3.008 3.008 0 0 0 1.448 3.152 6.227 6.227 0 0 1 2.005 1.967 8.708 8.708 0 0 1-.52 2.703c-1.187 3.303.451 6.756.451 6.756l1.051-.705s-1.592-1.998-.862-5.568c.015-.166.03-.285.06-.42Zm74.069 44.965c.751.143 3.47.448 4.729-3.252a1.731 1.731 0 0 1-1.885.346c-.812-.33-2.013.203-2.627 1.291.193-2.35-.203-3.963-.285-6.109v-.895c.479-.099 3.453-.863 3.271-5.043a1.88 1.88 0 0 1-1.613 1.133c-.969.053-1.98 1.299-1.98 2.754a5.602 5.602 0 0 0-.278 1.779 26.84 26.84 0 0 0 .384 3.281 4.57 4.57 0 0 0-.511-.926c-1.239-1.648-2.583-1.854-2.83-2.252a3.001 3.001 0 0 0 1.44 3.152 6.246 6.246 0 0 1 2.013 1.975 8.964 8.964 0 0 1-.524 2.703c-1.18 3.303.449 6.756.449 6.756l1.051-.713s-1.592-2.004-.863-5.578l.062-.412-.003.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    fill: "#877373",
    d: "M154.637 572.408s7.859-9.533 17.334 0h-17.334Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    fill: "#44AA85",
    d: "m296.738 488.498 1.668 3.799-2.83-2.381a2.776 2.776 0 0 1-1.922-1.275 5.645 5.645 0 0 1-.887-3.754c0-.27.181-.51.428-.6a2.573 2.573 0 0 1 2.636 1.238c.586.881.899 1.914.901 2.973h.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    fill: "#2AD191",
    d: "M296.738 488.498v3.131l1.164-1.713a2.775 2.775 0 0 0 1.93-1.275 5.592 5.592 0 0 0 .871-3.754.647.647 0 0 0-.42-.6 2.553 2.553 0 0 0-2.637 1.238 5.44 5.44 0 0 0-.908 2.973Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    fill: "#44AA85",
    d: "m271.51 488.498.752 3.424-1.931-2.006a2.806 2.806 0 0 1-1.931-1.275 5.685 5.685 0 0 1-.869-3.754c0-.27.173-.518.428-.605a2.572 2.572 0 0 1 2.627 1.246c.592.876.914 1.909.924 2.97Zm12.603 0 .75 3.002-1.891-1.576a2.843 2.843 0 0 1-1.932-1.273 5.601 5.601 0 0 1-.871-3.754c0-.277.166-.525.421-.615a2.56 2.56 0 0 1 2.628 1.246c.585.88.895 1.913.895 2.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    fill: "#2AD191",
    d: "M284.113 488.498v3.295l1.164-1.877a2.768 2.768 0 0 0 1.92-1.275 5.649 5.649 0 0 0 .88-3.754.663.663 0 0 0-.429-.6 2.556 2.556 0 0 0-2.635 1.238 5.39 5.39 0 0 0-.9 2.973Zm-12.611 0v3.656l1.171-2.252a2.82 2.82 0 0 0 1.931-1.277 5.703 5.703 0 0 0 .871-3.752.648.648 0 0 0-.43-.604 2.558 2.558 0 0 0-2.635 1.238 5.406 5.406 0 0 0-.9 2.988l-.008.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    fill: "#E19974",
    d: "M304.758 490.839v5.945c0 .504-.303.916-.646.916H264.1c-.346 0-.631-.412-.631-.916v-5.945c0-.51.285-.924.639-.924h40.004c.353.001.646.415.646.924Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    fill: "#D77F4A",
    d: "M266.127 497.701H264.1c-.346 0-.631-.412-.631-.916v-5.945c0-.51.285-.924.639-.924h2.021c-.375 0-.675.43-.675.955v5.885c-.002.525.298.945.673.945Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    fill: "#44AA85",
    d: "m255.482 488.498 1.666 3.799-2.83-2.381a2.79 2.79 0 0 1-1.93-1.275 5.673 5.673 0 0 1-.869-3.754.644.644 0 0 1 .42-.6 2.573 2.573 0 0 1 2.635 1.238c.586.881.898 1.914.9 2.973h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    fill: "#2AD191",
    d: "M255.475 488.498v3.131l1.164-1.713a2.784 2.784 0 0 0 1.938-1.275 5.673 5.673 0 0 0 .869-3.754.624.624 0 0 0-.428-.605 2.574 2.574 0 0 0-2.635 1.246 5.382 5.382 0 0 0-.9 2.973l-.008-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    fill: "#44AA85",
    d: "m230.223 488.498.75 3.424-1.93-2.006a2.772 2.772 0 0 1-1.921-1.275 5.592 5.592 0 0 1-.871-3.754c0-.27.165-.518.42-.6a2.575 2.575 0 0 1 2.628 1.238c.592.879.914 1.912.924 2.973Zm12.625 0 .752 3.002-1.898-1.584a2.82 2.82 0 0 1-1.93-1.275 5.686 5.686 0 0 1-.871-3.754c0-.27.164-.518.42-.605a2.584 2.584 0 0 1 2.644 1.246c.578.88.885 1.913.883 2.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    fill: "#2AD191",
    d: "M242.842 488.498v3.295l1.172-1.877a2.788 2.788 0 0 0 1.928-1.275 5.62 5.62 0 0 0 .871-3.754.64.64 0 0 0-.428-.605 2.574 2.574 0 0 0-2.635 1.246 5.382 5.382 0 0 0-.9 2.973l-.008-.003Zm-12.619 0v3.656l1.17-2.252a2.777 2.777 0 0 0 1.922-1.277 5.572 5.572 0 0 0 .871-3.752.648.648 0 0 0-.42-.604 2.55 2.55 0 0 0-2.636 1.238 5.428 5.428 0 0 0-.907 2.991Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    fill: "#E19974",
    d: "M263.484 490.839v5.945c0 .504-.277.916-.639.916h-39.994c-.354 0-.646-.412-.646-.916v-5.945c0-.51.3-.924.646-.924h39.994c.359 0 .646.414.646.924h-.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    fill: "#D77F4A",
    d: "M224.87 497.701h-2.026c-.346 0-.638-.412-.638-.916v-5.945c0-.51.292-.924.646-.924h2.021c-.375 0-.677.43-.677.955v5.885c-.001.525.299.945.674.945Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    fill: "#44AA85",
    d: "m214.219 488.498 1.674 3.799-2.838-2.381a2.77 2.77 0 0 1-1.921-1.275 5.654 5.654 0 0 1-.879-3.754c0-.27.173-.51.429-.6a2.582 2.582 0 0 1 2.627 1.238c.584.881.897 1.916.9 2.973h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    fill: "#2AD191",
    d: "M214.219 488.498v3.131l1.163-1.713a2.779 2.779 0 0 0 1.931-1.275 5.577 5.577 0 0 0 .869-3.754.634.634 0 0 0-.42-.6 2.549 2.549 0 0 0-2.635 1.238 5.361 5.361 0 0 0-.908 2.973Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    fill: "#44AA85",
    d: "m188.936 488.498.75 3.424-1.929-2.006a2.8 2.8 0 0 1-1.93-1.275 5.674 5.674 0 0 1-.871-3.754c0-.27.173-.518.429-.605a2.574 2.574 0 0 1 2.627 1.246c.593.876.916 1.909.924 2.97Zm12.657 0 .75 3.002-1.899-1.576c-.795-.135-1.5-.6-1.92-1.273a5.635 5.635 0 0 1-.871-3.754c0-.277.164-.525.42-.615a2.546 2.546 0 0 1 2.629 1.246 5.37 5.37 0 0 1 .891 2.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    fill: "#2AD191",
    d: "M201.593 488.498v3.295l1.163-1.877a2.776 2.776 0 0 0 1.922-1.275 5.642 5.642 0 0 0 .879-3.754.67.67 0 0 0-.429-.6 2.572 2.572 0 0 0-2.635 1.238 5.374 5.374 0 0 0-.9 2.973Zm-12.657 0v3.656l1.164-2.252a2.822 2.822 0 0 0 1.93-1.277 5.673 5.673 0 0 0 .869-3.752.643.643 0 0 0-.428-.604 2.558 2.558 0 0 0-2.635 1.238 5.426 5.426 0 0 0-.9 2.991Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    fill: "#E19974",
    d: "M222.234 490.839v5.945c0 .504-.299.916-.646.916h-40.003c-.358 0-.646-.412-.646-.916v-5.945c0-.51.285-.924.646-.924h39.996c.375 0 .646.414.646.924h.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    fill: "#D77F4A",
    d: "M183.605 497.701h-2.013c-.358 0-.646-.412-.646-.916v-5.945c0-.51.283-.924.646-.924h2.013c-.375 0-.676.43-.676.955v5.885c.001.525.301.945.676.945Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    fill: "#44AA85",
    d: "m172.954 488.498 1.674 3.799-2.83-2.381a2.802 2.802 0 0 1-1.929-1.275 5.68 5.68 0 0 1-.871-3.754c0-.27.165-.518.421-.605a2.581 2.581 0 0 1 2.642 1.246c.586.881.898 1.916.901 2.973l-.008-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    fill: "#2AD191",
    d: "M172.954 488.498v3.131l1.171-1.713a2.817 2.817 0 0 0 1.93-1.275 5.686 5.686 0 0 0 .871-3.754.64.64 0 0 0-.429-.6 2.574 2.574 0 0 0-2.636 1.238 5.382 5.382 0 0 0-.899 2.973h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    fill: "#44AA85",
    d: "m147.702 488.498.75 3.424-1.929-2.006a2.812 2.812 0 0 1-1.922-1.275 5.592 5.592 0 0 1-.871-3.754c0-.27.164-.51.42-.6a2.525 2.525 0 0 1 2.627 1.238c.594.879.914 1.912.925 2.973Zm12.626 0 .751 3.002-1.899-1.584a2.774 2.774 0 0 1-1.922-1.275 5.642 5.642 0 0 1-.878-3.754.63.63 0 0 1 .429-.6 2.574 2.574 0 0 1 2.627 1.238c.58.883.891 1.916.892 2.973Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    fill: "#2AD191",
    d: "M160.328 488.498v3.303l1.163-1.877a2.856 2.856 0 0 0 1.93-1.273 5.652 5.652 0 0 0 .871-3.756.639.639 0 0 0-.421-.6 2.558 2.558 0 0 0-2.635 1.23 5.33 5.33 0 0 0-.908 2.973Zm-12.626 0v3.656l1.163-2.252a2.798 2.798 0 0 0 1.922-1.277 5.59 5.59 0 0 0 .871-3.752.65.65 0 0 0-.422-.604 2.557 2.557 0 0 0-2.635 1.238 5.442 5.442 0 0 0-.899 2.991Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    fill: "#E19974",
    d: "M180.971 490.839v5.945c0 .504-.285.916-.646.916H140.33c-.354 0-.646-.412-.646-.916v-5.945c0-.51.301-.924.646-.924h39.996c.352.001.645.415.645.924Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    fill: "#D77F4A",
    d: "M142.35 497.701h-2.026c-.347 0-.64-.412-.64-.916v-5.945c0-.51.301-.924.646-.924h2.02c-.375 0-.676.43-.676.955v5.885c0 .525.301.945.676.945Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    fill: "#44AA85",
    d: "m237.52 455.73 1.666 3.807-2.83-2.379a2.779 2.779 0 0 1-1.922-1.277 5.662 5.662 0 0 1-.879-3.752c0-.271.174-.52.428-.602a2.528 2.528 0 0 1 2.629 1.236c.586.879.9 1.91.908 2.969v-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    fill: "#2AD191",
    d: "M237.512 455.73v3.131l1.17-1.703a2.807 2.807 0 0 0 1.93-1.277 5.654 5.654 0 0 0 .871-3.752.645.645 0 0 0-.42-.609 2.566 2.566 0 0 0-2.635 1.246 5.35 5.35 0 0 0-.908 2.967l-.008-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    fill: "#44AA85",
    d: "m212.26 455.73.75 3.424-1.929-1.996a2.849 2.849 0 0 1-1.931-1.277 5.693 5.693 0 0 1-.869-3.752c0-.271.164-.52.428-.602a2.552 2.552 0 0 1 2.627 1.236c.592.877.913 1.908.924 2.969v-.002Zm12.625 0 .752 3.004-1.894-1.576a2.84 2.84 0 0 1-1.929-1.277 5.623 5.623 0 0 1-.871-3.752.66.66 0 0 1 .42-.609 2.583 2.583 0 0 1 2.643 1.246c.575.882.881 1.913.879 2.964Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    fill: "#2AD191",
    d: "M224.885 455.73v3.305l1.163-1.877a2.813 2.813 0 0 0 1.931-1.277 5.65 5.65 0 0 0 .877-3.752.652.652 0 0 0-.428-.602 2.566 2.566 0 0 0-2.635 1.236 5.389 5.389 0 0 0-.9 2.969l-.008-.002Zm-12.625 0v3.654l1.163-2.252a2.808 2.808 0 0 0 1.931-1.273 5.726 5.726 0 0 0 .869-3.754.633.633 0 0 0-.428-.607 2.56 2.56 0 0 0-2.635 1.246 5.39 5.39 0 0 0-.9 2.986Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    fill: "#E19974",
    d: "M245.536 458.074v5.943c0 .512-.3.916-.646.916h-40.01c-.345 0-.638-.404-.638-.916v-5.943c0-.504.293-.916.646-.916h40.002c.346 0 .646.412.646.916Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    fill: "#D77F4A",
    d: "M206.907 464.935h-2.027c-.345 0-.638-.404-.638-.916v-5.943c0-.504.3-.916.646-.916h2.02c-.376 0-.676.42-.676.943v5.887c-.002.523.299.945.675.945Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    fill: "#44AA85",
    d: "m196.262 455.73 1.666 3.807-2.83-2.379a2.843 2.843 0 0 1-1.929-1.277 5.657 5.657 0 0 1-.871-3.752c0-.271.165-.52.421-.602a2.561 2.561 0 0 1 2.643 1.236c.584.882.896 1.91.9 2.969v-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    fill: "#2AD191",
    d: "M196.262 455.73v3.131l1.163-1.703a2.813 2.813 0 0 0 1.931-1.277 5.724 5.724 0 0 0 .871-3.752.65.65 0 0 0-.43-.602 2.544 2.544 0 0 0-2.635 1.236 5.413 5.413 0 0 0-.9 2.969v-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    fill: "#44AA85",
    d: "m170.995 455.73.751 3.424-1.93-1.996a2.812 2.812 0 0 1-1.922-1.277 5.657 5.657 0 0 1-.879-3.752c0-.264.174-.512.428-.602a2.55 2.55 0 0 1 2.627 1.236c.593.877.914 1.908.925 2.969v-.002Zm12.634 0 .751 3.004-1.899-1.576a2.794 2.794 0 0 1-1.93-1.277 5.717 5.717 0 0 1-.869-3.752c0-.271.164-.52.428-.602a2.525 2.525 0 0 1 2.627 1.236 5.42 5.42 0 0 1 .895 2.969l-.003-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    fill: "#2AD191",
    d: "M183.629 455.73v3.305l1.163-1.877a2.813 2.813 0 0 0 1.931-1.277 5.726 5.726 0 0 0 .87-3.752.649.649 0 0 0-.429-.602 2.566 2.566 0 0 0-2.635 1.236 5.402 5.402 0 0 0-.9 2.969v-.002Zm-12.634 0v3.654l1.163-2.252a2.804 2.804 0 0 0 1.93-1.273 5.644 5.644 0 0 0 .871-3.754.64.64 0 0 0-.421-.602 2.552 2.552 0 0 0-2.636 1.238 5.43 5.43 0 0 0-.907 2.989Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    fill: "#E19974",
    d: "M204.271 458.074v5.943c0 .512-.285.916-.646.916H163.63c-.36 0-.646-.404-.646-.916v-5.943c0-.504.285-.916.646-.916h39.996c.36 0 .645.412.645.916Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    fill: "#D77F4A",
    d: "M165.665 464.935h-2.019c-.36 0-.646-.404-.646-.916v-5.943c0-.504.286-.916.646-.916h2.012c-.36 0-.661.42-.661.943v5.887c0 .523.301.945.661.945h.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    fill: "#44AA85",
    d: "m154.998 455.73 1.667 3.807-2.83-2.379a2.814 2.814 0 0 1-1.922-1.277 5.667 5.667 0 0 1-.878-3.752c0-.271.172-.512.428-.602a2.536 2.536 0 0 1 2.627 1.236c.583.882.896 1.91.901 2.969l.007-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    fill: "#2AD191",
    d: "M154.998 455.73v3.131l1.164-1.703a2.807 2.807 0 0 0 1.929-1.277 5.617 5.617 0 0 0 .871-3.752.648.648 0 0 0-.421-.609 2.584 2.584 0 0 0-2.643 1.246 5.434 5.434 0 0 0-.9 2.964Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    fill: "#44AA85",
    d: "m129.738 455.73.75 3.424-1.93-1.996a2.815 2.815 0 0 1-1.93-1.277 5.73 5.73 0 0 1-.871-3.752c0-.271.165-.512.43-.602a2.552 2.552 0 0 1 2.627 1.236 5.41 5.41 0 0 1 .924 2.969v-.002Zm12.657 0 .75 3.004-1.892-1.576a2.824 2.824 0 0 1-1.93-1.277 5.617 5.617 0 0 1-.871-3.752.65.65 0 0 1 .421-.609 2.549 2.549 0 0 1 2.627 1.246c.581.88.891 1.911.895 2.964Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    fill: "#2AD191",
    d: "M142.395 455.73v3.305l1.164-1.877a2.792 2.792 0 0 0 1.92-1.277 5.657 5.657 0 0 0 .879-3.752.663.663 0 0 0-.428-.602 2.567 2.567 0 0 0-2.636 1.236 5.396 5.396 0 0 0-.899 2.969v-.002Zm-12.657 0v3.654l1.164-2.252a2.806 2.806 0 0 0 1.929-1.273 5.734 5.734 0 0 0 .871-3.754.65.65 0 0 0-.429-.607 2.559 2.559 0 0 0-2.635 1.246 5.414 5.414 0 0 0-.9 2.986Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    fill: "#E19974",
    d: "M163.016 458.074v5.943c0 .512-.302.916-.646.916h-40.013c-.346 0-.631-.404-.631-.916v-5.943c0-.504.285-.916.641-.916h40.003c.353 0 .646.412.646.916Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    fill: "#D77F4A",
    d: "M124.379 464.935h-2.027c-.345 0-.631-.404-.631-.916v-5.943c0-.504.286-.916.639-.916h2.021c-.376 0-.676.42-.676.943v5.887c-.002.523.298.945.674.945Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    fill: "#44AA85",
    d: "m113.741 455.73 1.667 3.807-2.83-2.379a2.811 2.811 0 0 1-1.93-1.277 5.724 5.724 0 0 1-.871-3.752c0-.271.166-.52.429-.602a2.535 2.535 0 0 1 2.627 1.236c.583.882.896 1.91.901 2.969l.007-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    fill: "#2AD191",
    d: "M113.734 455.73v3.131l1.17-1.703a2.807 2.807 0 0 0 1.93-1.277 5.712 5.712 0 0 0 .871-3.752.64.64 0 0 0-.428-.602 2.552 2.552 0 0 0-2.635 1.236 5.412 5.412 0 0 0-.901 2.967h-.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    fill: "#44AA85",
    d: "m88.473 455.73.752 3.424-1.93-1.996a2.834 2.834 0 0 1-1.93-1.277 5.618 5.618 0 0 1-.863-3.752c0-.271.165-.512.421-.602a2.535 2.535 0 0 1 2.627 1.236 5.41 5.41 0 0 1 .923 2.969v-.002Zm12.634 0 .75 3.004-1.898-1.576a2.779 2.779 0 0 1-1.922-1.277 5.662 5.662 0 0 1-.878-3.752c0-.271.165-.52.428-.602a2.528 2.528 0 0 1 2.628 1.236c.579.882.891 1.912.893 2.969v-.002h-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    fill: "#2AD191",
    d: "M101.107 455.73v3.305l1.164-1.877a2.811 2.811 0 0 0 1.929-1.277 5.668 5.668 0 0 0 .87-3.752.646.646 0 0 0-.428-.602 2.567 2.567 0 0 0-2.636 1.236 5.401 5.401 0 0 0-.899 2.969v-.002Zm-12.634 0v3.654l1.172-2.252a2.814 2.814 0 0 0 1.922-1.273 5.624 5.624 0 0 0 .87-3.754.648.648 0 0 0-.42-.602 2.542 2.542 0 0 0-2.635 1.238 5.503 5.503 0 0 0-.91 2.989Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    fill: "#E19974",
    d: "M121.751 458.074v5.943c0 .512-.285.916-.646.916H81.109c-.354 0-.646-.404-.646-.916v-5.943c0-.504.3-.916.646-.916h39.996c.361 0 .646.412.646.916Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    fill: "#D77F4A",
    d: "M83.13 464.935h-2.026c-.347 0-.639-.404-.639-.916v-5.943c0-.504.301-.916.646-.916h2.02c-.376 0-.676.42-.676.943v5.887c0 .523.3.945.674.945Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sea-wave-small",
    fill: "#AFCCEF",
    d: "M404.271 563.888c-.961 1.5-2.154 3.406-4.428 3.406-2.275 0-3.471-1.891-4.432-3.406-.961-1.518-1.584-2.516-3.049-2.516-1.463 0-2.176 1.104-3.055 2.516-.887 1.41-2.154 3.406-4.43 3.406s-3.469-1.891-4.43-3.406c-.961-1.518-1.574-2.516-3.055-2.516s-2.17 1.111-3.055 2.516c-.889 1.402-2.154 3.406-4.432 3.406-2.268 0-3.461-1.891-4.422-3.406-.953-1.518-1.592-2.516-3.049-2.516-1.463 0-2.176 1.104-3.055 2.516-.885 1.41-2.154 3.406-4.43 3.406-2.273 0-3.469-1.891-4.43-3.406-.943-1.518-1.584-2.516-3.047-2.516-1.465 0-2.178 1.111-3.055 2.516-.889 1.402-2.154 3.406-4.432 3.406-2.275 0-3.469-1.891-4.43-3.406-.961-1.518-1.576-2.516-3.055-2.516-1.473 0-2.162 1.104-3.057 2.516-.895 1.41-2.146 3.406-4.422 3.406-2.273 0-3.469-1.891-4.43-3.406-.959-1.518-1.576-2.516-3.055-2.516-1.473 0-2.162 1.111-3.049 2.516-.887 1.402-2.152 3.406-4.43 3.406-2.275 0-3.469-1.891-4.43-3.406-.961-1.518-1.576-2.516-3.047-2.516-1.473 0-2.162 1.104-3.057 2.516-.887 1.41-2.154 3.406-4.43 3.406-2.274 0-3.467-1.891-4.428-3.406-.955-1.518-1.578-2.516-3.05-2.516-1.472 0-2.177 1.104-3.056 2.516-.887 1.41-2.146 3.406-4.43 3.406-.524 0-.953-.668-.953-1.5 0-.826.429-1.502.961-1.502 1.502 0 2.162-1.104 3.049-2.514.886-1.412 2.154-3.408 4.429-3.408 2.275 0 3.47 1.891 4.431 3.408.953 1.516 1.575 2.514 3.047 2.514 1.473 0 2.178-1.104 3.057-2.514.887-1.412 2.154-3.408 4.43-3.408 2.266 0 3.453 1.951 4.428 3.453.977 1.5 1.584 2.514 3.049 2.514 1.465 0 2.178-1.104 3.055-2.514.881-1.412 2.146-3.408 4.432-3.408 2.268 0 3.498 1.906 4.43 3.408.916 1.5 1.584 2.514 3.047 2.514 1.465 0 2.162-1.104 3.057-2.514.893-1.412 2.146-3.408 4.428-3.408 2.268 0 3.461 1.891 4.422 3.408.961 1.516 1.592 2.514 3.057 2.514 1.467 0 2.17-1.104 3.057-2.514.887-1.412 2.152-3.408 4.43-3.408 2.275 0 3.469 1.891 4.422 3.408.953 1.516 1.592 2.514 3.055 2.514 1.465 0 2.17-1.104 3.057-2.514.885-1.412 2.154-3.408 4.428-3.408 2.271 0 3.461 1.891 4.422 3.408.953 1.516 1.592 2.514 3.049 2.514 1.467 0 2.18-1.104 3.057-2.514.887-1.412 2.152-3.408 4.43-3.408 2.275 0 3.469 1.891 4.43 3.408.961 1.516 1.584 2.514 3.055 2.514 1.473 0 2.178-1.111 3.057-2.514.885-1.404 2.154-3.408 4.428-3.408 2.275 0 3.453 1.891 4.422 3.408.963 1.516 1.594 2.514 3.059 2.514 1.463 0 2.17-1.111 3.055-2.514",
    className: "sea-wave-small"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sailing-boat",
    className: "sailing-boat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    fill: "#444",
    d: "M364.201 548.798h-11.59v-61.51h-1.674v61.51h-8.678l-4.691 5.863H364.3l-.102-5.855v-.008h.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    fill: "#CCC",
    d: "M375.574 554.669h-53.207l1.65 4.174h51.557v-4.182.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    fill: "#444",
    d: "m324.012 558.843 1.611 4.174h49.943v-4.174h-51.554Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    fill: "#342E2C",
    d: "M375.574 548.798h-8.979v5.871h8.979v-5.871Zm-25.297 1.803h-6.98v2.051h6.98v-2.051Zm10.036 0h-6.98v2.051h6.98v-2.051Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    fill: "#7D8696",
    d: "M354.219 531.72v-39.68l-1.613-4.752v44.438h1.613v-.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    fill: "#FFDF5A",
    d: "m371.461 541.968-17.266-49.941v39.682c6.928.298 13.092 4.253 17.266 10.259Zm-20.516-10.111v-36.033l-17.604 49.604c3.755-7.43 10.157-12.61 17.604-13.571Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    fill: "#CCC",
    d: "M354.219 541.968V531.72h-1.605v10.248h1.605Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    fill: "#7D8696",
    d: "M354.219 531.72v10.248h17.266c-4.206-6.006-10.362-9.961-17.266-10.248Zm-3.281 13.942v-13.805c-7.432.951-13.834 6.133-17.596 13.549l-.09.256h17.691-.005Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ship",
    className: "ship"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    fill: "#444",
    d: "M503.084 448.396h-3.701v26.352h3.701v-26.352Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    fill: "#44AA85",
    d: "M604.693 483.64h-16.289l-16.619-12.295h-75.037v12.295h-18.873v16.365l132.238 2.365-5.428-18.73h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    fill: "#7D8696",
    d: "m534.025 494.841-74.314-9.232 19.434 24.117h145.781v-14.885h-90.901Zm-11.785-33.42h-10.705v9.803h10.705v-9.803Zm-10.705-6.56v6.561h10.705l-5.352-6.561h-5.353Zm52.127 6.56h-10.705v9.803h10.705v-9.803Zm-10.705-6.56v6.561h10.697l-5.352-6.561h-5.345Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    fill: "#CCC",
    d: "M488.137 496.003h-6.08v3.318h6.08v-3.318Zm9.123 0h-6.082v3.318h6.082v-3.318Zm9.111 0h-6.08v3.318h6.08v-3.318Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    fill: "#fff",
    d: "M582.443 483.205h-70.908v3.305h70.916v-3.305h-.008Zm-10.132-6.561h-60.775v3.313h60.77v-3.303l.005-.01Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "sea-wave",
    fill: "#AFCCEF",
    d: "M581.82 516.656c-.961 1.5-2.154 3.408-4.428 3.408-2.275 0-3.469-1.895-4.43-3.408-.961-1.52-1.576-2.518-3.051-2.518-1.471 0-2.178 1.111-3.055 2.518-.887 1.4-2.154 3.408-4.43 3.408s-3.469-1.895-4.43-3.408c-.961-1.52-1.576-2.518-3.055-2.518s-2.17 1.111-3.057 2.518c-.889 1.4-2.154 3.408-4.432 3.408-2.271 0-3.451-1.895-4.42-3.408-.961-1.52-1.592-2.518-3.057-2.518-1.463 0-2.168 1.111-3.055 2.518-.887 1.4-2.154 3.408-4.43 3.408-2.268 0-3.461-1.895-4.422-3.408-.953-1.52-1.584-2.518-3.047-2.518-1.465 0-2.178 1.111-3.057 2.518-.877 1.4-2.154 3.408-4.432 3.408-2.271 0-3.467-1.895-4.428-3.408-.961-1.52-1.584-2.518-3.057-2.518-1.471 0-2.162 1.111-3.055 2.518-.895 1.4-2.146 3.408-4.422 3.408s-3.469-1.895-4.43-3.408c-.961-1.52-1.576-2.518-3.055-2.518-1.48 0-2.162 1.111-3.049 2.518-.889 1.4-2.154 3.408-4.432 3.408-2.271 0-3.467-1.895-4.42-3.408-.955-1.52-1.592-2.518-3.057-2.518-1.463 0-2.168 1.111-3.055 2.518-.887 1.4-2.154 3.408-4.43 3.408-2.268 0-3.461-1.895-4.43-3.408-.953-1.52-1.576-2.518-3.047-2.518-1.475 0-2.18 1.111-3.059 2.518-.885 1.4-2.145 3.408-4.43 3.408-.525 0-.953-.662-.953-1.503 0-.843.428-1.503.961-1.503 1.502 0 2.162-1.104 3.059-2.514.887-1.412 2.139-3.408 4.422-3.408 2.271 0 3.467 1.893 4.428 3.408.961 1.517 1.592 2.514 3.049 2.514 1.463 0 2.176-1.104 3.055-2.514.887-1.412 2.154-3.408 4.43-3.408s3.469 1.893 4.43 3.408c.945 1.517 1.584 2.514 3.047 2.514 1.465 0 2.18-1.104 3.059-2.514.887-1.412 2.145-3.408 4.43-3.408 2.266 0 3.461 1.893 4.428 3.408.953 1.517 1.584 2.514 3.049 2.514 1.463 0 2.176-1.104 3.057-2.514.885-1.412 2.145-3.408 4.42-3.408s3.469 1.893 4.43 3.408c.961 1.517 1.592 2.514 3.057 2.514 1.465 0 2.17-1.104 3.057-2.514.887-1.412 2.154-3.408 4.43-3.408s3.467 1.893 4.428 3.408c.953 1.517 1.576 2.514 3.049 2.514 1.465 0 2.168-1.104 3.049-2.514.893-1.412 2.152-3.408 4.428-3.408 2.277 0 3.469 1.893 4.43 3.408.887 1.402 1.584 2.514 3.049 2.514 1.465 0 2.178-1.104 3.057-2.514.887-1.412 2.154-3.408 4.43-3.408s3.467 1.893 4.428 3.408c.961 1.517 1.592 2.514 3.057 2.514 1.465 0 2.178-1.109 3.055-2.514.961-1.502 2.154-3.408 4.43-3.408 2.277 0 3.453 1.893 4.424 3.408.887 1.402 1.592 2.514 3.057 2.514 1.463 0 2.168-1.109 3.055-2.514",
    className: "sea-wave"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    fill: "#D36E46",
    d: "M124.634 525.867s.24.357.368.403c.127.046.27.302.375.36.105.066.443.119.525.232.061.172.135.338.226.494.075.074.247.227.188.301-.063.076-.256 0-.256 0a.227.227 0 0 1 0 .166c-.074.164-.182.164-.182.164a.288.288 0 0 1 0 .188c-.104.139-.201.129-.201.129a.343.343 0 0 1-.113.164.232.232 0 0 1-.231 0s-.112.15-.21.113a.934.934 0 0 1-.203-.18 3.475 3.475 0 0 1-.593-1.285 2.716 2.716 0 0 0-.413-.975l.72-.274Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    fill: "#EEA886",
    d: "m123.223 549.812-.264-.977h-.977v1.037c.002.001 1.481.69 1.241-.06Zm-8.334-2.305a2.14 2.14 0 0 0-.24.512c-.045.188-.396.264-.688-.143a.772.772 0 0 1-.075-.391c.055-.285.145-.559.258-.818l.745.84Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    fill: "#E57A47",
    d: "M126.037 527.578s-.359-.549-.57-.558a.466.466 0 0 0-.354.084c-.156.081-.127.188-.254.339a.525.525 0 0 0-.188.492.943.943 0 0 0 .451.662s.104.074.218-.092c0 0 .247.129.346-.188 0 0 .314-.061.248-.33-.002.003.321-.095.103-.409Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    fill: "#212121",
    d: "m113.156 547.935 2.025.752c2.096-4.277 3.432-7.711 3.664-8.393.246-.805.404-1.629.473-2.463a2.454 2.454 0 0 1 0-.42c.037-.752.148-2.104.314-3.168 0-.203.067-.393.098-.563.182-1.967.248-3.947.211-5.932v-1.381l-.045-.045c-.347-.302-2.582-2.133-3.362-.412a5.748 5.748 0 0 0-.421 1.447 19.095 19.095 0 0 0 0 5.066c.173 1.365.75 3.129.841 4.564.075.576.038 1.17-.12 1.727-1.148 2.518-3.678 9.221-3.678 9.221Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    fill: "#C6C6C6",
    d: "m119.995 514.742.886 1.576.811 1.5s-.061-.227-.148-.869c0-.121-.037-.256-.055-.414v-.135a3.991 3.991 0 0 0-1.5-1.621v-.037h.006Zm4.879 11.424a1.464 1.464 0 0 0-.677.541 6.838 6.838 0 0 0-.449-.586l.796-.391.33.436Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    fill: "#A6A6A6",
    d: "m121.488 523.201.412.568s-.284-2.643-.271-3.002a20.281 20.281 0 0 0-.148 2.434h.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    fill: "#EEA886",
    d: "M116.766 522.128c.393.148.789.285 1.201.383.586.148 0 .938 0 .938l-1.501-.15c-.187-.022.3-1.171.3-1.171Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    fill: "#C6C6C6",
    d: "M117.232 517.646a11.28 11.28 0 0 0-1.696-.555s.202-2.582 1.501-2.32c1.299.264.195 2.875.195 2.875Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    fill: "#23344A",
    d: "M118.223 522.562a1.31 1.31 0 0 0-.121.902s.053.074.228 0a2.275 2.275 0 0 1 .149-.895.388.388 0 0 0-.256 0v-.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    fill: "#C6C6C6",
    d: "M140.878 518c-.36-1.428.751-3.063.751-3.063a3.955 3.955 0 0 0-1.975-1.098c-.391-.074-1.465-.338-1.465-.338h-1.74l-1.502.324a4.161 4.161 0 0 0-1.846 1.063s1.012 1.922.646 3.352c0 0 .3 2.326.474 3.188.053.75.053 1.502 0 2.252 0 .525-.076 2.027-.174 3.318a6.522 6.522 0 0 0 3.273.75 9.042 9.042 0 0 0 3.316-.75c-.144-1.539-.226-2.83-.291-3.334-.039-.359 0-1.756.051-2.252.107-.621.482-3.412.482-3.412Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    fill: "#212121",
    d: "M133.116 549.902c-.104.301-.24.602-.413.861-.188.248-.908.691-.915 1.43-.009.719 1.224.555 1.703.523.479-.032.511-.451.751-.895.227-.443.391-.375.436-.75a5.35 5.35 0 0 0-.15-1.164h-1.409l-.003-.005Zm7.236-.014c.105.299.24.592.414.863.188.246.916.674.924 1.41 0 .729-1.225.57-1.705.549-.479-.023-.523-.451-.75-.902-.231-.447-.404-.375-.449-.75.007-.396.061-.787.148-1.17h1.418Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    fill: "#2F80ED",
    d: "M142.072 539.205c0 .977-.797 10.766-.797 10.766l-2.521-.045c0-.346.227-9.826.174-10.811-.054-.982-1.578-7.836-1.824-7.809-.248.029-1.015 8.746-1.201 9.496-.202.75-.752 9.324-.752 9.324-1.455-.143-2.572-.195-2.572-.195s.119-9.145.165-9.855c0-.277.053-1.801.194-3.828.099-1.354.75-6.756 1.027-9.285v-.264l.12-1.051v-.105l.255-.119c2.072-.854 6.088 0 6.088 0v.301c0 .227.061.563.098.953.15 1.391.348 3.422.324 3.634-.017.212 1.224 7.921 1.224 8.89l-.002.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    fill: "#C6C6C6",
    d: "M141.141 519.103c.188 1.18.314 2.363.383 3.553-.066.518-1.027 6.004-1.027 6.004l1.097.586s1.456-5.721 1.501-6.59a32.6 32.6 0 0 0-.428-5.145 5.854 5.854 0 0 0-1.201-2.83 3.335 3.335 0 0 0-1.621-.834l1.296 5.256Zm-7.53.014a32.978 32.978 0 0 0-.375 3.551c.074.521.99 5.631.99 5.631l-1.027.99s-1.502-5.713-1.502-6.582c.008-1.727.15-3.439.412-5.143a5.804 5.804 0 0 1 1.201-2.84 3.195 3.195 0 0 1 1.605-.834l-1.304 5.227Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    fill: "#2F80ED",
    d: "m137.432 530.978 3.528-.75-.255-3.234c-.03-.404-.338-3.754-.277-5.563a5.127 5.127 0 0 1-.871-2.215h-2.185l-2.162.063a4.708 4.708 0 0 1-.931 2.197c0 1.923-.166 5.212-.188 5.563-.022.354-.435 3.131-.435 3.131l3.716.848h.073l-.021-.036.008-.004Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    fill: "#2F80ED",
    d: "M139.557 519.207c.067-1.732.45-3.438 1.125-5.035a.862.862 0 0 0-.584-.227 19.434 19.434 0 0 0-1.052 5.256c-.044 2.528.511.006.511.006Zm-4.362.031s-.104-3.318-1.082-5.082c0 0 .24-.285.504-.211a19.541 19.541 0 0 1 1.074 5.256c.06 2.558-.496.037-.496.037Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    fill: "#E5CFA5",
    d: "M141.366 529.626a1.386 1.386 0 0 1-1.179.586c-.879-.053-1.135-.488-1.074-.676.061-.203 2.141-.374 2.253.09Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    fill: "#E5CFA5",
    d: "M141.096 529.898s.652-.24.541-.438c-.113-.195-.488.098-.488.098l-.053.346v-.006Zm-7.657-.256c.27.383.711.602 1.179.586.878-.061 1.133-.494 1.073-.689-.06-.198-2.132-.362-2.252.103Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    fill: "#E5CFA5",
    d: "M133.693 529.919s-.637-.262-.524-.451c.104-.201.479.105.479.105l.054.346h-.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    fill: "#C44A4A",
    d: "M142.049 524.47a1.261 1.261 0 0 1-2.199.668 1.263 1.263 0 0 1 .113-1.779c.229-.199.521-.313.825-.314a1.348 1.348 0 0 1 1.261 1.425Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    fill: "#CF4D4D",
    d: "M140.42 523.974a1.26 1.26 0 1 1-1.261-1.426 1.352 1.352 0 0 1 1.261 1.426Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    fill: "#C44A4A",
    d: "M139.58 523.291a1.263 1.263 0 0 1-1.416 1.086 1.261 1.261 0 0 1 .162-2.512 1.352 1.352 0 0 1 1.254 1.426Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    fill: "#D85151",
    d: "M137.898 523.05a1.272 1.272 0 0 1-1.459 1.047 1.27 1.27 0 0 1-1.041-1.021 1.264 1.264 0 0 1 1.247-1.452 1.344 1.344 0 0 1 1.253 1.426Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    fill: "#D85151",
    d: "M139.58 524.626a1.268 1.268 0 0 1-1.438 1.076 1.294 1.294 0 0 1-.765-.406 1.265 1.265 0 0 1 .113-1.781c.231-.203.53-.314.84-.313.738.051 1.295.69 1.25 1.424Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    fill: "#C44A4A",
    d: "M138.184 523.974a1.253 1.253 0 1 1-1.246-1.418 1.346 1.346 0 0 1 1.246 1.428v-.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    fill: "#D85151",
    d: "M136.675 524.289a1.279 1.279 0 0 1-.886 1.053 1.262 1.262 0 1 1-.359-2.471 1.338 1.338 0 0 1 1.245 1.426v-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    fill: "#C44A4A",
    d: "M135.376 524.373a1.265 1.265 0 0 1-1.412 1.09 1.262 1.262 0 0 1-.989-1.766c.209-.451.66-.752 1.155-.744a1.34 1.34 0 0 1 1.246 1.428v-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    fill: "#6B4528",
    d: "m142.372 524.373-10.044.021.008 5.158 10.044-.021-.008-5.158Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    fill: "#E5CFA5",
    d: "M137.5 515.064c-1.275.098-1.328-1.503-1.328-1.503s.09-.054.135-.313a5.065 5.065 0 0 0-.074-1.127c-.231-1.27 1.951-.697 1.951-.697.008.722.104 1.436.301 2.125-.003-.001.299 1.425-.985 1.515Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    fill: "#F7E1AE",
    d: "M138.416 510.988c-.157.383-.354.75-.586 1.104-.75 1.125-2.807 1.097-2.553-1.914 0-.479.061-.961.15-1.426.359-1.367 1.2-1.592 1.2-1.592a2.083 2.083 0 0 1 2.116 1.072c.208.93.092 1.9-.327 2.756Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    fill: "#FFC655",
    d: "M138.416 510.988s-.09 0-.42-.75c-.075-.15-.12-.045-.15-.113l-.525-.225s.525-.992-.148-1.264a3.07 3.07 0 0 0-1.74.082c.359-1.355 1.2-1.576 1.2-1.576a2.068 2.068 0 0 1 2.116 1.066 4.218 4.218 0 0 1-.333 2.78Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    fill: "#F7E1AE",
    d: "M137.74 509.689c.045-.203.398-.385.548.061.149.443-.353.908-.487.811-.136-.099-.121-.526-.061-.872Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    fill: "#2F80ED",
    d: "M138.859 509.718a4.656 4.656 0 0 0-3.635-.84s.111-2.793 2.326-2.32c2.104.467 1.378 2.854 1.309 3.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    fill: "#2F80ED",
    d: "M137.777 509.126a17.267 17.267 0 0 1-3.836.09c-1.065-.256 1.313-.631 1.313-.631s.887-.322 2.523.541Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    fill: "#C6C6C6",
    d: "m121.421 523.126.062.074.276.383a21.718 21.718 0 0 0 2.808 3.334c.42.262.48-.557.062-1.051-.412-.496-1.815-3.396-2.379-4.031-.265-.301-.64-3.213-.64-3.213s-.338 2.424-.301 2.701c.045.277-.119 1.465.121 1.803h-.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    fill: "#FACE87",
    d: "M129.266 532.757h-6.93v-.18c0-.105-.09-2.666 1.171-4.166a3.04 3.04 0 0 1 4.601 0c1.263 1.5 1.188 4.053 1.181 4.158l-.017.188h-.006Zm-6.614-.361h6.306c0-.6-.112-2.551-1.097-3.715a2.752 2.752 0 0 0-3.889-.238 2.074 2.074 0 0 0-.24.238c-.982 1.17-1.08 3.115-1.08 3.715Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    fill: "#FACE87",
    d: "M123.545 528.921a2.836 2.836 0 0 1 2.492-1.172v-.367a3.003 3.003 0 0 0-2.627 1.148l.135.391Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    fill: "#9CCC9B",
    d: "M123.732 531.218c-1.365 0-1.412 1.502-1.412 1.502h2.613c.001 0 .196-1.502-1.201-1.502Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    fill: "#CA595B",
    d: "M125.204 531.955c-.638-.068-.705.75-.705.75h1.381a.75.75 0 0 0-.676-.75Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    fill: "#EC686B",
    d: "M125.88 531.955c-.638-.068-.706.75-.706.75h1.366a.748.748 0 0 0-.66-.75Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    fill: "#9A6FA0",
    d: "M129.182 531.376c.467-1.314-1.396-1.502-1.5-.676-.104.826-1.39 1.996-1.39 1.996l2.252.496.638-1.816Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    fill: "#82C07E",
    d: "M128.289 530.152c-.75 0-1.109.861-1.109.861s1.088-.563 1.162-.301c.075.279.233 1.066.233 1.066s.18-1.217.231-1.027c.053.188.602.51.602.51a1.102 1.102 0 0 0-.602-1.021s.219-.055-.524-.09l.007.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    fill: "url(#paint0_linear_5616_44294)",
    d: "M126.991 537.05h-2.455c-3.003 0-2.529-4.879-2.529-4.879h7.507c-.002 0 .472 4.834-2.523 4.879Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    fill: "url(#paint1_linear_5616_44294)",
    d: "M126.991 537.05h-2.455c-3.003 0-2.529-4.879-2.529-4.879h2.718c-.002 0-.234 4.879 2.266 4.879Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    fill: "#C6C6C6",
    d: "M115.559 517.255c0 .992.989 3.342 1.142 4.068.247.602.321 1.262.194 1.898a63.116 63.116 0 0 0-.805 4.354c.021.285 5.689 1.291 6.531 1.104 0 0-1.036-4.441-1.126-4.955 0-.988.037-1.979.135-2.957 0-.541.511-1.703.496-2.252a3.463 3.463 0 0 0-.586-1.611l-.315-.55a12.13 12.13 0 0 0-.877-1.308 2.594 2.594 0 0 0-.714-.533l-1.502-.275c-.495.203-.989.391-1.501.541.001 0-1.059.187-1.072 2.476Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    fill: "#C6C6C6",
    d: "M121.458 516.354c.046.181.075.366.075.556l-.309-.547s-.578-.934-.75-1.172a4.378 4.378 0 0 0-.467-.449 3.442 3.442 0 0 1 1.451 1.612Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    fill: "url(#paint2_linear_5616_44294)",
    d: "M122.127 521.039v.361a2.874 2.874 0 0 1-1.613 2.189 3.26 3.26 0 0 1-4.183-1.035 2.251 2.251 0 0 1-.3-.639 2.588 2.588 0 0 1-.135-.863v-.293c.028-.338.127-.668.285-.969a3.242 3.242 0 0 1 5.621-.074c.066.119.119.256.174.393.073.225.135.447.148.688l.003.242Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    fill: "#3C6B4A",
    d: "M121.977 520.109a2.009 2.009 0 0 1-.569 0 3.634 3.634 0 0 0-1.201-.15 4.556 4.556 0 0 0-1.201 0 3.878 3.878 0 0 1-.978.203c-.465 0-.75-.158-1.262 0-.353.111-.652.188-.795.225.045-.193.119-.375.202-.557.308-.148.812-.383 1.052-.299.359.119.646-.076 1.133-.137a3.74 3.74 0 0 1 1.367 0c.271.111.989 0 1.381.156.227.1.449.166.689.203.076.116.129.226.182.356Zm.15.93v.361h-.607c-.467 0-.805.117-1.021.117-.22 0-.834-.135-1.074-.148-.239-.014-.915 0-1.187 0h-1.854l-.486-.188v-.473h2.365a4.2 4.2 0 0 1 1.5 0c.314.15.66.256 1.014.285.195 0 .854-.217 1.322-.248.028.137.028.227.028.301v-.007Zm-.227 1.134a2.053 2.053 0 0 1-.227.404 5.431 5.431 0 0 0-1.306.396c-.36.127-.729.203-1.104.227l-1.291-.053a4.252 4.252 0 0 0-.662-.256 5.329 5.329 0 0 1-.99-.338 2.31 2.31 0 0 1-.301-.639 9.935 9.935 0 0 0 1.922.563c.256 0 .9.076 1.457.076.404 0 .817-.053 1.201-.166.293-.09.172-.301.75-.238l.551.024Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    fill: "#C6C6C6",
    d: "M115.701 516.347s.232-1.846 1.426-1.547c1.18.301.075 2.719 0 3.004-.074.285-.932 2.627-1.006 2.93-.227.975 0 .997.338 1.223 1.027.676 3.085.789 3.333.977.248.188.276.602-.135.623-.525 0-3.566-.301-3.994-.346-.429-.045-1.229-.082-1.015-1.75.145-1.128 1.053-5.114 1.053-5.114Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    fill: "#D36E46",
    d: "M119.657 522.789a.763.763 0 0 1-.601.188.626.626 0 0 1 .473-.557l.9-.24h.045l.021.018.016.021c0 .055-.062.1-.062.1a.549.549 0 0 1-.202.148 1.63 1.63 0 0 0-.602.322h.012Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    fill: "#D36E46",
    d: "M119.875 522.623c.75-.082 1.501.227 1.501.436 0 .211-.901.514-1.576.525-.676.016-.879-.262-.879-.473 0-.211.285-.412.954-.488Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    fill: "#212121",
    d: "M123.223 549.812s.217.686.524.844c.321.154 1.021.906 1.306.961.286.051.961.109 1 .518.036.404-.039.75-1.404.57a9.134 9.134 0 0 1-2.656-.933 4.57 4.57 0 0 1 .165-2.362c.442-.754 1.065.402 1.065.402Zm-8.566-1.793c.038.314.12.623.247.914.15.211.367 1.232.677 1.557.321.32 1.073 1.051.841 1.412-.24.357-1.854-.1-2.434-1.227-.577-1.125-.75-1.254-.705-1.561.046-.301.623-1.502.601-1.629-.007-.128.773.534.773.534Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    fill: "#2F80ED",
    d: "m116.121 527.578 3.363.75.358 10.584-2.14 4.955-2.124 4.918-2.401-.887s1.237-3.619 1.711-4.799c.43-1.051 1.848-4.166 1.848-4.166a56.526 56.526 0 0 1-.825-7.02c-.112-3.578.21-4.335.21-4.335Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    fill: "#2B73D3",
    d: "m118.846 528.14 3.754.533s.539 3.588.652 4.781c.135 1.404.33 5.615.33 5.615l.232 11.26-2.199.15s-1.073-6.307-.998-8.406c.052-1.428.18-2.779.18-2.779l-2.434-11.184.483.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    fill: "#D36E46",
    d: "M117.473 512.062c.148.787.262 1.576.314 2.381 0 0 2.16.924 1.938.396a2.457 2.457 0 0 1-.137-.816v-.578c.001-.002-2.274-1.715-2.115-1.383Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    fill: "#212121",
    d: "M116.699 507.925a1.05 1.05 0 0 0-1.246.592c-.405.844 1.216 3.453.54 4.504-.601.947-1.147.477-1.147.477a1.198 1.198 0 0 0 1.666.326c.211-.143.37-.346.459-.582.592-1.016.338-2.109.299-3.002a9.419 9.419 0 0 0-.571-2.315Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    fill: "#E57A47",
    d: "M118.674 507.542s1.727.074 1.801 2.928c.068 2.859-.465 3.477-2.019 2.883-1.547-.594-2.026-3.59-2.072-4.055-.045-.465-.09-2.093 2.29-1.756Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    fill: "#212121",
    d: "M119.124 509.351a2.777 2.777 0 0 1-2.327 1.824s-1.554-3.002.639-3.678c2.191-.676 2.892 1.275 2.957 2.252-.373-.262-.82-.4-1.274-.398h.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    fill: "#212121",
    d: "M120.332 509.359s-.878-3.604-3.564-1.594c0 0-1.367 1.029.104 3.553a9.867 9.867 0 0 0 3.468-1.951l-.008-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    fill: "#D36E46",
    d: "M117.45 511.115a1.591 1.591 0 0 0-.24.961s-.451-.525-.421-.9c.038-.368.661-.061.661-.061Zm2.177 3.416s1.021 1.787.676 1.938c-.345.151-2.199-.203-3.003-1.893a2.193 2.193 0 0 1 2.327-.045Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    fill: "#CCC",
    d: "M389.178 205.053h-39.215v10.51h39.215v-10.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    fill: "#686868",
    d: "M570.283 112.007v245.859h34.006V151.809l-34.014-39.801.008-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    fill: "#919191",
    d: "m611.924 160.718-7.619-8.911v206.061h7.619v-197.15Zm-174.735-35.695h-34.568v232.67h34.568v-232.67Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    fill: "#686868",
    d: "M521.768 125.023h-35.057v232.67h35.057v-232.67Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    fill: "#919191",
    d: "M529.791 125.023h-8.031v232.67h8.031v-232.67Zm-62.875-27.052v260.332h8.926V88.676a127.752 127.752 0 0 0-8.934 9.286l.008.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    fill: "#686868",
    d: "M417.266 264.34v93.954h49.648V97.971C414.1 158.586 417.266 264.34 417.266 264.34Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    fill: "#F2F2F2",
    d: "M443.391 214.917H343.385v179.726h100.006V214.917Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    fill: "#CCC",
    d: "M443.391 231.716H343.385v11.71h100.006v-11.71Zm0 21.47H343.385v11.695h100.006v-11.703.008Zm0 21.446H343.385v11.71h100.006v-11.71Zm0 21.454H343.385v11.71h100.006v-11.71Zm0 21.471H343.385v11.694h100.006v-11.703.009Zm0 21.444H343.385v11.711h100.006v-11.711Zm0 21.47H343.385v11.696h100.006v-11.696Zm180.31-149.593H507.068v81.996h116.646v-81.996h-.013Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    fill: "#F3EEEC",
    d: "M528.621 228.43h-11.574v20.207h11.574V228.43Zm21.274 0H538.32v20.207h11.574V228.43h.001Zm21.275 0h-11.576v20.207h11.576V228.43Zm21.273 0h-11.576v20.207h11.576V228.43Zm21.282 0h-11.584v20.207h11.584V228.43Zm-85.104 25.829h-11.574v20.208h11.574v-20.208Zm21.274 0H538.32v20.208h11.574v-20.208h.001Zm21.275 0h-11.576v20.208h11.576v-20.208Zm21.273 0h-11.576v20.208h11.576v-20.208Zm21.282 0h-11.584v20.208h11.584v-20.208Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    fill: "#CCC",
    d: "M580.748 194.775h-30.732v16.108h30.732v-16.108Zm-37.857 10.323h-22.76v5.789h22.76v-5.789Zm67.748 0h-22.76v5.789h22.76v-5.789Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    fill: "#2B478B",
    d: "M561.725 201.104c-1.357 0-2.461 1.533-2.461 3.438a3.773 3.773 0 0 0 1.291 3.003.715.715 0 0 1 .248.458v6.854h1.846v-6.854a.668.668 0 0 1 .248-.451 3.773 3.773 0 0 0 1.275-3.002c-.021-1.913-1.125-3.452-2.447-3.452v.006Zm8.574 0v3.754a.263.263 0 0 1-.092.195.305.305 0 0 1-.209.082h-.615c-.037 0-.074 0-.113-.015a.31.31 0 0 1-.096-.06.413.413 0 0 1-.076-.1.234.234 0 0 1-.021-.111v-3.752h-1.229v3.752l-.023.111-.066.1a.335.335 0 0 1-.219.073h-.615c-.037 0-.074 0-.111-.015a.235.235 0 0 1-.098-.061.491.491 0 0 1-.076-.099.266.266 0 0 1-.021-.112v-3.752h-1.229v4.016a2.36 2.36 0 0 0 .541 1.427c.338.403.803.676 1.313.788.074.021.15.061.203.128a.39.39 0 0 1 .098.226v7.207h1.848v-7.207a.375.375 0 0 1 .098-.226.382.382 0 0 1 .201-.128 2.332 2.332 0 0 0 1.85-2.215v-4.016h-1.23v.006h-.01v.004h-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "car-2",
    className: "car-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    fill: "#2B478B",
    d: "m563.52 280.016 50.084-.879 1.336-5.427v-1.021a.88.88 0 0 0-.75-.896l-3.58-.548a12.287 12.287 0 0 1-3.078-.9l-5.518-2.463a15.95 15.95 0 0 0-6.486-1.389h-8.166a6.487 6.487 0 0 0-4.768 2.115l-5.457 5.834-6.906.164c-2.814 0-4.504.826-5.449 1.689l-1.262 3.721Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    fill: "#2B478B",
    d: "M563.52 280.016v3.609a1.75 1.75 0 0 0 1.688 1.802H608.2l6.428-2.297c.346-.128.645-.36.85-.676.209-.3.322-.668.307-1.036v-3.167a.676.676 0 0 0-.059-.345.882.882 0 0 0-.826-.557l-5.51.293a2.256 2.256 0 0 1-1.291-.309 6.288 6.288 0 0 0-7.109.375 2.23 2.23 0 0 1-1.238.43l-20.777 1.079a1.605 1.605 0 0 1-1.277-.532 6.427 6.427 0 0 0-10.209.517 1.63 1.63 0 0 1-1.229.668l-2.732.148v-.006h-.006v.004h-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    fill: "#ECEAEC",
    d: "M568.121 279.947v-1.411a1.785 1.785 0 0 0-1.133-1.704l-1.449-.541-.428.428a3.615 3.615 0 0 0-.863 2.41v.887l3.873-.069Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    fill: "#FF8086",
    d: "M614.926 278.213v-4.504h-.85a2.563 2.563 0 0 0-1.822.826 2.582 2.582 0 0 0-.697 1.876v1.802h3.369Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    fill: "#9B959D",
    d: "m582.047 271.75 2.252 1.275 19.09-1.928c0-.182-.037-.361-.127-.513a.857.857 0 0 0-.393-.358l-1.5-.677a15.968 15.968 0 0 0-.752-.321l-1.688-.526a14.513 14.513 0 0 0-3.379-.405h-3.361l-.865.338-.824-.338h-3.107a4.88 4.88 0 0 0-3.572 1.584l-1.77 1.876v-.007h-.004Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    fill: "#857E87",
    d: "M580.469 273.432a.496.496 0 0 0-.135.271.538.538 0 0 0 .021.308c.076.195.264.33.479.346l9.641-.226.854-.338.826.292 6.756-.157 1.695-.067a3.407 3.407 0 0 0 2.521-1.951l.211-.443c.053-.113.074-.24.092-.367l-21.373.652-1.576 1.682h-.014.002v-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    fill: "#676775",
    d: "M592.164 268.313h-1.688v5.832l1.688-.045v-5.787Zm8.432.916a15.49 15.49 0 0 0-1.689-.525v5.255h1.275c.135 0 .271-.017.414-.038v-4.692Zm4.203 19.8c2.801 0 5.066-2.416 5.066-5.404 0-2.98-2.266-5.404-5.059-5.404-2.801 0-5.063 2.424-5.063 5.404 0 2.988 2.27 5.404 5.063 5.404h-.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    fill: "#fff",
    d: "M604.807 287.229c1.854 0 3.363-1.612 3.363-3.604s-1.504-3.604-3.363-3.604c-1.861 0-3.379 1.614-3.379 3.604s1.517 3.604 3.379 3.604Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    fill: "#DAD8DB",
    d: "M604.807 285.427c.924 0 1.688-.811 1.688-1.802s-.766-1.801-1.688-1.801c-.924 0-1.689.811-1.689 1.801-.001.999.749 1.802 1.689 1.802Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    fill: "#676775",
    d: "M572.775 289.029c2.793 0 5.061-2.416 5.061-5.404 0-2.98-2.275-5.404-5.061-5.404-2.787 0-5.061 2.424-5.061 5.404.003 2.988 2.268 5.404 5.061 5.404Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    fill: "#fff",
    d: "M572.775 287.229c1.861 0 3.371-1.612 3.371-3.604s-1.51-3.604-3.379-3.604c-1.855 0-3.363 1.614-3.363 3.604s1.502 3.604 3.371 3.604Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    fill: "#DAD8DB",
    d: "M572.775 285.427c.932 0 1.689-.811 1.689-1.802s-.762-1.801-1.689-1.801c-.932 0-1.688.811-1.688 1.801.001.999.751 1.802 1.688 1.802Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "car-1",
    className: "car-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    fill: "#67D3CB",
    d: "m521.775 280.016 50.084-.879 1.336-5.427v-1.021a.967.967 0 0 0-.203-.594.897.897 0 0 0-.547-.301l-3.588-.548a12.533 12.533 0 0 1-3.078-.899l-5.523-2.464a15.924 15.924 0 0 0-6.486-1.389h-8.168a6.547 6.547 0 0 0-4.766 2.116l-5.459 5.834-6.898.164c-2.822 0-4.504.826-5.457 1.688l-1.247 3.72Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    fill: "#ECEAEC",
    d: "M525.641 279.947v-1.411a1.802 1.802 0 0 0-1.133-1.704l-1.449-.541-.428.428a3.671 3.671 0 0 0-.855 2.41v.887l3.865-.069Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    fill: "#FF8086",
    d: "M573.195 278.213v-4.504h-.84a2.621 2.621 0 0 0-2.531 2.702v1.802h3.371Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    fill: "#67D3CB",
    d: "M521.775 280.016v3.609a1.74 1.74 0 0 0 1.68 1.802h42.992l6.434-2.297a1.764 1.764 0 0 0 1.148-1.712v-3.167a.888.888 0 0 0-.538-.833.916.916 0 0 0-.344-.075l-5.518.3a2.147 2.147 0 0 1-1.277-.308 6.29 6.29 0 0 0-7.123.375 2.257 2.257 0 0 1-1.246.429l-20.748 1.08a1.636 1.636 0 0 1-.688-.119 1.552 1.552 0 0 1-.578-.414 6.451 6.451 0 0 0-10.229.52c-.281.396-.73.646-1.223.668l-2.742.142Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    fill: "#9B959D",
    d: "m540.316 271.75 2.252 1.275 19.09-1.928c0-.182-.037-.361-.127-.513a.862.862 0 0 0-.391-.358l-1.502-.677-.75-.321-1.689-.526a14.5 14.5 0 0 0-3.379-.405h-3.363l-.861.338-.826-.338h-3.107a4.88 4.88 0 0 0-3.57 1.584l-1.771 1.876v-.007h-.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    fill: "#857E87",
    d: "M538.748 273.432a.558.558 0 0 0-.15.271.553.553 0 0 0 .518.656l9.633-.227.855-.338.826.292 6.756-.157 1.695-.066a3.404 3.404 0 0 0 2.529-1.952l.203-.443a.768.768 0 0 0 .09-.368l-21.371.653-1.576 1.683h-.008v-.004Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    fill: "#676775",
    d: "M550.436 268.313h-1.697v5.832l1.689-.045v-5.787h.008Zm8.429.916a14.76 14.76 0 0 0-1.688-.525v5.255h1.273c.137 0 .271-.017.412-.038v-4.691h.003v-.001Zm4.203 19.8c2.801 0 5.068-2.416 5.068-5.404 0-2.98-2.275-5.404-5.063-5.404s-5.061 2.424-5.061 5.404c0 2.988 2.268 5.404 5.061 5.404h-.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    fill: "#fff",
    d: "M563.076 287.229c1.861 0 3.371-1.612 3.371-3.604s-1.51-3.604-3.379-3.604c-1.854 0-3.361 1.614-3.361 3.604s1.5 3.604 3.369 3.604Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    fill: "#DAD8DB",
    d: "M563.076 285.427c.932 0 1.689-.811 1.689-1.802s-.758-1.801-1.689-1.801c-.93 0-1.688.811-1.688 1.801-.001.999.751 1.802 1.688 1.802Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    fill: "#676775",
    d: "M531.047 289.029c2.793 0 5.059-2.416 5.059-5.404 0-2.98-2.266-5.404-5.059-5.404s-5.061 2.424-5.061 5.404c0 2.988 2.268 5.404 5.061 5.404Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    fill: "#fff",
    d: "M531.047 287.229c1.861 0 3.369-1.612 3.369-3.604s-1.508-3.604-3.379-3.604c-1.869 0-3.361 1.614-3.361 3.604s1.502 3.604 3.371 3.604Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    fill: "#DAD8DB",
    d: "M531.047 285.427c.93 0 1.688-.811 1.688-1.802s-.758-1.801-1.688-1.801c-.932 0-1.689.811-1.689 1.801-.001.999.749 1.802 1.689 1.802Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    fill: "#BCBCDD",
    d: "M634.834 404.632H395.813s15.111-69.397 54.213-95.521c38.037-25.411 140.691-18.842 184.811-14.646",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    fill: "#9292B7",
    d: "m401.082 392.253-9.156-2.058c.238-1.026 5.854-25.521 22.277-50.405 22.02-33.33 52.969-50.963 89.504-50.963v9.383c-33.615 0-61.045 15.651-81.523 46.541a161.344 161.344 0 0 0-21.102 47.504v-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    fill: "#9292B7",
    d: "M634.834 288.887H500.568v9.264h134.266v-9.264Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    fill: "#CCC",
    d: "M562.4 379.119h-18.016v25.688h18.027v-25.688h-.011Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    fill: "#fff",
    d: "M576.229 394.891a.286.286 0 0 1 .016-.149.535.535 0 0 1 .074-.13.296.296 0 0 1 .121-.09.427.427 0 0 1 .143-.045c.201.03.355.203.359.414 0 .2-.158.375-.359.403a.42.42 0 0 1-.264-.127.403.403 0 0 1-.09-.276Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    fill: "#CCE1FF",
    d: "M587.826 381.009h.037l-.037.203v-.203Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    fill: "#98BAF4",
    d: "M478.018 332.38h-6.756v12.356h6.756V332.38Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    fill: "#fff",
    d: "M477.695 336.525h-6.246v.6h6.246v-.6Zm0 4.105h-6.246v.603h6.246v-.603Zm0 38.254h-6.246v.603h6.246v-.603Zm0 4.116h-6.246v.6h6.246v-.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    fill: "#fff",
    d: "M474.844 387.113v-12.416h-.525v12.416h.525Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    fill: "#98BAF4",
    d: "M497.527 374.755h-6.756v12.356h6.756v-12.356Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    fill: "#fff",
    d: "M497.205 378.884h-6.236v.603h6.229v-.603h.007Zm0 4.116h-6.236v.6h6.229v-.6h.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    fill: "#98BAF4",
    d: "M517.039 374.755h-6.758v12.356h6.758v-12.356Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    fill: "#CCC",
    d: "M525.107 318.314h-60.992v39.189h60.992v-39.189Zm0 47.352h-60.992v39.193h60.992v-39.193Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    fill: "#919191",
    d: "M525.115 357.514h-52.547v8.151h52.547v-8.151Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    fill: "#fff",
    d: "M478.303 345.143h-7.445v-13.158h7.445v13.158Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    fill: "#fff",
    d: "M474.836 344.744v-12.416h-.525v12.416h.525Zm22.971.399h-7.439v-13.158h7.445v13.158h-.006Zm19.517 0h-7.447v-13.158h7.447v13.158Zm-39.021 42.366h-7.445V374.36h7.445v13.149Zm19.51 0h-7.445V374.36h7.445v13.149Zm19.511 0h-7.447V374.36h7.447v13.149Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    fill: "#fff",
    d: "M516.717 378.884h-6.246v.603h6.246v-.603Zm0 4.116h-6.246v.6h6.246v-.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    fill: "#fff",
    d: "M513.863 387.113v-12.416h-.525v12.416h.525Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    fill: "#FFE5C2",
    d: "M451.67 375.169h-36.781l-.145.099.145.09h4.42v2.252l.076.144a4.914 4.914 0 0 1 6.959 2.76 2.386 2.386 0 0 1 .518-1.914 2.437 2.437 0 0 1 1.801-.841c.697 0 1.357.306 1.813.832a2.42 2.42 0 0 1 .518 1.923 2.454 2.454 0 0 1 .039-1.021 2.356 2.356 0 1 1 4.602 1.021 2.454 2.454 0 0 1 .037-1.021 2.358 2.358 0 0 1 2.813-1.791 2.354 2.354 0 0 1 1.789 2.812 2.454 2.454 0 0 1 .039-1.021 2.356 2.356 0 1 1 4.602 1.021 2.367 2.367 0 0 1 .52-1.914 2.43 2.43 0 0 1 1.803-.84 2.403 2.403 0 0 1 1.809.832c.441.536.631 1.237.52 1.922a2.61 2.61 0 0 0 1.727-.908c.43-.519.646-1.187.596-1.86v-2.478l-.22-.099Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    fill: "#F3EEEC",
    d: "M418.063 380.223a1.983 1.983 0 0 1-1.029.299 2.111 2.111 0 0 1-1.426-.586v3.655h2.455v-3.368Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    fill: "#fff",
    d: "M429.398 385.003h5.404v12.82h-5.404v-12.82Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    fill: "#CCC",
    d: "M426.777 397.727h9.211v6.897h-9.211v-6.897Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    fill: "#F3EEEC",
    d: "M449.523 380.416a2.476 2.476 0 0 1-2.252-2.664h-.158a2.252 2.252 0 1 1-4.504 0h-.158a2.25 2.25 0 0 1-3.844 1.592 2.251 2.251 0 0 1-.66-1.592h-.164a2.253 2.253 0 0 1-4.504 0h-.166a2.252 2.252 0 1 1-4.504 0h-.15a2.252 2.252 0 1 1-4.504 0h-.061a2.25 2.25 0 0 1-3.844 1.592 2.251 2.251 0 0 1-.66-1.592h-.172a2.48 2.48 0 0 1-2.252 2.664 1.993 1.993 0 0 1-1.412-.6v3.865h19.383c.264.021.51.148.676.359.18.203.271.465.24.732v19.85h15.014v-24.814a2.043 2.043 0 0 1-1.412.605l.068.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    fill: "#fff",
    d: "M416.283 397.824h19.119v-13.047a.45.45 0 0 0-.404-.48h-19.367v13.514l.652.013Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    fill: "#CCC",
    d: "M421.643 397.824h1.193v-12.82h5.404v12.82h1.188v-12.82h5.404v12.82h1.193v-13.047a1.114 1.114 0 0 0-.998-1.193h-19.391v1.428h6.006v12.812h.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    fill: "#A44F3E",
    d: "m419.609 391.541.051.068.063-.074c.135-.166.322-.301.539-.383v-.752a.61.61 0 0 0-.016-.262.652.652 0 0 0-.119-.229.61.61 0 0 0-.713-.146.594.594 0 0 0-.322.375.506.506 0 0 0-.016.262v.752c.201.09.375.225.525.389h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    fill: "#FD6930",
    d: "m417.057 394.078.045.061.061-.061a1.374 1.374 0 0 1 1.043-.502h.129c.813.17 1.393.895 1.375 1.727l.104.105h.061c-.029-.42.092-.842.34-1.18.254-.338.621-.57 1.035-.652h.135c.346 0 .676.15.932.391v-1.127a1.763 1.763 0 0 0-1.576-1.883 1.437 1.437 0 0 0-1.098.518 1.45 1.45 0 0 0-1.096-.523 1.757 1.757 0 0 0-1.584 1.891v1.127l.094.108Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    fill: "#A44F3E",
    d: "m421.861 393.792.053.067.061-.073c.135-.166.322-.302.541-.384v-.752a.644.644 0 0 0-.137-.49.613.613 0 0 0-.713-.147.596.596 0 0 0-.322.375.508.508 0 0 0-.016.262v.752c.203.091.375.226.525.39h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    fill: "#FD6930",
    d: "m419.309 396.33.045.061.061-.061a1.374 1.374 0 0 1 1.043-.502h.131c.813.17 1.391.895 1.373 1.727l.104.105h.059c-.027-.42.094-.842.342-1.18.254-.338.623-.57 1.033-.652h.137c.346 0 .676.15.932.391v-1.127a1.763 1.763 0 0 0-1.576-1.883 1.433 1.433 0 0 0-1.096.518 1.453 1.453 0 0 0-1.098-.523 1.758 1.758 0 0 0-1.584 1.891v1.127l.094.108Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    fill: "#A44F3E",
    d: "m417.357 393.792.051.067.063-.073c.135-.166.32-.302.539-.384v-.752a.61.61 0 0 0-.135-.49.613.613 0 0 0-.713-.147.596.596 0 0 0-.322.375.508.508 0 0 0-.016.262v.752c.201.091.375.226.525.39h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    fill: "#FD6930",
    d: "m414.805 396.33.045.061.061-.061a1.374 1.374 0 0 1 1.043-.502h.127c.814.17 1.395.895 1.375 1.727l.105.105h.061c-.029-.42.092-.842.338-1.18a1.72 1.72 0 0 1 1.035-.652h.137c.346 0 .676.15.932.391v-1.127a1.763 1.763 0 0 0-1.576-1.883 1.437 1.437 0 0 0-1.098.518 1.45 1.45 0 0 0-1.096-.523 1.758 1.758 0 0 0-1.584 1.891v1.127l.095.108Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    fill: "#FFBD86",
    d: "M426.477 395.535h-13.145a.433.433 0 0 0-.389.451v8.197c0 .104.029.225.104.299a.355.355 0 0 0 .285.148h13.514V396a.423.423 0 0 0-.371-.465h-.004.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    fill: "#73D578",
    d: "m428.707 375.373-.074-.105h-4.641l-.074.111v2.254l.074.135c-.059.338-.053.689.045 1.021a2.358 2.358 0 0 0 4.596-1.022l.074-.135v-2.259Zm18.496-.105h-4.652l-.076.09v2.252l.076.158a2.588 2.588 0 0 0 2.318 2.762c.15 0 .293-.021.428-.053h.105c.119-.037.24-.074.354-.136h.037a2.866 2.866 0 0 0 1.418-2.528l.074-.129v-2.252l-.082-.164Zm-9.285 0h-4.639l-.084.127v2.252l.076.121a2.584 2.584 0 0 0 2.326 2.763c.143 0 .275-.021.414-.054h.104c.227-.062.439-.162.631-.302.367-.276.66-.629.855-1.051.203-.403.301-.854.285-1.313l.074-.121v-2.252l-.042-.17Zm-18.602-.017h-4.641v2.492a2.692 2.692 0 0 0 1.854 2.702c.158.046.33.074.496.074.428-.008.84-.149 1.188-.396.359-.277.645-.631.848-1.045.193-.41.289-.857.277-1.313l.082-.144v-2.252l-.104-.118Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    fill: "#FFBD86",
    d: "M421.727 375.268h-2.336v2.483a2.578 2.578 0 0 0 2.32 2.763c.135 0 .277-.015.412-.054h.111c.227-.065.439-.168.631-.299a2.83 2.83 0 0 0 1.143-2.365v-2.483l-2.281-.045Zm9.279 0h-2.373v2.483a2.585 2.585 0 0 0 2.326 2.763c.143 0 .277-.015.412-.054h.105c.225-.063.438-.166.631-.299a2.874 2.874 0 0 0 1.148-2.365v-2.483l-2.249-.045Zm9.283 0h-2.371v2.483a2.58 2.58 0 0 0 2.318 2.763c.145 0 .285-.015.422-.054h.104c.227-.063.438-.166.631-.299a2.88 2.88 0 0 0 1.143-2.365v-2.483l-2.252-.045h.005Zm9.287 0h-2.373v2.483a2.58 2.58 0 0 0 2.32 2.763c.135 0 .277-.015.412-.054h.104c.227-.063.439-.164.633-.299a2.924 2.924 0 0 0 1.141-2.365v-2.483l-2.244-.045h.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    fill: "#26AA77",
    d: "m414.715 375.268 2.672-7.509h31.807l2.65 7.509s-37.25.11-37.129 0Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    fill: "#FFBD86",
    d: "M423.506 371.064c2.648 0 4.789-2.555 4.789-5.699 0-3.144-2.141-5.697-4.789-5.697-2.645 0-4.789 2.553-4.789 5.705 0 3.138 2.144 5.691 4.789 5.691Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    fill: "#A44F3E",
    d: "M423.506 365.328a.67.67 0 0 1-.602-.713v-2.125a.61.61 0 0 1 .016-.262.554.554 0 0 1 .119-.24.63.63 0 0 1 .211-.166.611.611 0 0 1 .811.291c.055.117.07.25.045.377v2.125a.675.675 0 0 1-.6.713Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    fill: "#FD5426",
    d: "M424.818 362.949a1.847 1.847 0 0 1-2.627 0 1.927 1.927 0 0 0-1.539 2.049v.361a2.523 2.523 0 0 0 2.252 2.717h1.143a2.541 2.541 0 0 0 2.252-2.717v-.361a1.954 1.954 0 0 0-1.481-2.049Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    fill: "#CCC",
    d: "M448.135 383.412h-9.607v21.221h9.607v-21.221Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    fill: "#73D578",
    d: "m452.264 394.98-.039-.018a.078.078 0 0 1-.029-.036l-.008-.046v-.045a1.86 1.86 0 0 0 .15-.752h-.227l-.428.414-.75.1-.33.479v1.133l-.121.09 1.09.506h.27c.15-.055.301-.145.422-.248a1.09 1.09 0 0 0 .42-1.336.54.54 0 0 0-.393-.24h-.027v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    fill: "#4BCE5B",
    d: "M450.648 395.934c-.059-.646.211-1.201.594-1.246.074 0 .15 0 .227.037a.453.453 0 0 1 .193.127l.037.022a.128.128 0 0 0 .039 0c.016 0 .029-.017.037-.022.008-.013.016-.022.021-.037.098-.301.283-.563.541-.75a.608.608 0 0 0-.266-.569c-.293-.158-.75.194-.945.75 0 .016-.016.022-.027.028h-.076a.086.086 0 0 1-.029-.028.478.478 0 0 0-.193-.127.53.53 0 0 0-.227-.039c-.391.047-.654.603-.602 1.246.02.182.061.36.137.526l.156.285.512.239a1.794 1.794 0 0 1-.129-.442Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    fill: "#CB6C35",
    d: "M450.102 401.557h1.455v11.446h-1.447v-11.446h-.008Zm-13.543 0h1.502v11.446h-1.502v-11.446Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    fill: "#FF7F87",
    d: "M449.268 405.068h-.188l-.586.57s-.314.854-.314.938c0 .225.037.438.076.646a.756.756 0 0 0 .127.23c.104.104.193.229.27.346h.805l.404-.248c.166-.283.248-.605.248-.938a2.04 2.04 0 0 0-.211-.889 1.841 1.841 0 0 0-.631-.655Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    fill: "#E39B74",
    d: "M448.594 405.361a.385.385 0 0 1-.113-.037.465.465 0 0 1-.09-.076.499.499 0 0 1-.053-.096c-.016-.039-.016-.076-.016-.113v-.256a1.7 1.7 0 0 1 .182-.848c.135-.266.328-.488.568-.654a.249.249 0 0 1 .219-.014.159.159 0 0 1 .098.061.252.252 0 0 1 .061.09.308.308 0 0 1 .021.232.37.37 0 0 1-.143.195 1.023 1.023 0 0 0-.338.402 1.05 1.05 0 0 0-.104.52v.256c0 .037 0 .076-.02.113a.211.211 0 0 1-.053.104.323.323 0 0 1-.209.098l-.016.016v.008h.006v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    fill: "#FF636E",
    d: "M448.434 406.615a1.798 1.798 0 0 1 .826-1.547 1.298 1.298 0 0 0-.676-.188c-.42.037-.824.231-1.096.563a1.602 1.602 0 0 0-.398 1.172c0 .33.074.652.24.938l.219.248h1.352l-.227-.248a1.957 1.957 0 0 1-.232-.938h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    fill: "#FF7F87",
    d: "M446.25 405.068h-.188l-.586.57s-.314.854-.322.938c0 .225.037.438.074.646a.698.698 0 0 0 .135.23c.1.111.189.229.264.346h.805l.412-.248a1.945 1.945 0 0 0 .029-1.822 1.825 1.825 0 0 0-.623-.66Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    fill: "#E39B74",
    d: "M445.574 405.354c-.074 0-.148-.045-.211-.099a.301.301 0 0 1-.074-.217v-.256a1.736 1.736 0 0 1 .75-1.503l.113-.036c.037 0 .074 0 .113.022.02.008.064.028.082.053a.255.255 0 0 1 .061.099.364.364 0 0 1 .016.231.324.324 0 0 1-.137.194 1.08 1.08 0 0 0-.441.925v.254c0 .037 0 .076-.016.112a.298.298 0 0 1-.053.099.537.537 0 0 1-.09.074.296.296 0 0 1-.113.03v.018Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    fill: "#FF636E",
    d: "M445.41 406.615a1.773 1.773 0 0 1 .84-1.547 1.307 1.307 0 0 0-.676-.188 1.631 1.631 0 0 0-1.502 1.734c-.006.329.076.651.24.938l.211.248h1.352l-.225-.248a1.93 1.93 0 0 1-.234-.938l-.006.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    fill: "#FF7F87",
    d: "M443.225 405.068h-.188l-.586.57s-.314.854-.314.938c0 .225.037.438.074.646a.72.72 0 0 0 .129.23c.104.104.193.229.27.346h.803l.398-.248c.172-.283.248-.605.248-.938a1.706 1.706 0 0 0-.211-.889 1.851 1.851 0 0 0-.623-.655Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    fill: "#E39B74",
    d: "M442.551 405.361a.405.405 0 0 1-.113-.037.465.465 0 0 1-.09-.076.239.239 0 0 1-.053-.096c-.016-.039-.016-.076-.016-.113v-.256a1.751 1.751 0 0 1 .75-1.502.274.274 0 0 1 .105-.029.264.264 0 0 1 .27.166.312.312 0 0 1 .018.232.308.308 0 0 1-.137.193 1.072 1.072 0 0 0-.441.924v.256c0 .037 0 .076-.018.111a.192.192 0 0 1-.059.105.225.225 0 0 1-.09.072.317.317 0 0 1-.113.023l-.016.014v.01h.002v.003h.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    fill: "#FF636E",
    d: "M442.393 406.615a1.792 1.792 0 0 1 .824-1.547 1.298 1.298 0 0 0-.676-.188 1.63 1.63 0 0 0-1.502 1.728c0 .338.092.66.248.944l.211.248h1.352l-.211-.248a1.959 1.959 0 0 1-.24-.938l-.006.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    fill: "#FF7F87",
    d: "M440.207 405.068h-.188l-.584.57s-.316.854-.324.938c0 .225.039.438.076.646a.775.775 0 0 0 .135.23c.098.111.189.229.264.346h.803l.414-.248a1.94 1.94 0 0 0 .029-1.822 1.83 1.83 0 0 0-.625-.66Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    fill: "#E39B74",
    d: "M439.531 405.354a.293.293 0 0 1-.203-.099.293.293 0 0 1-.074-.217v-.256a1.72 1.72 0 0 1 .752-1.503.23.23 0 0 1 .301.048.146.146 0 0 1 .059.09.367.367 0 0 1 .018.231.324.324 0 0 1-.137.194 1.096 1.096 0 0 0-.338.404 1.14 1.14 0 0 0-.098.524v.248a.356.356 0 0 1-.076.219.3.3 0 0 1-.201.099v.017h-.003v.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    fill: "#FF636E",
    d: "M439.367 406.615a1.754 1.754 0 0 1 .219-.887c.135-.271.359-.494.621-.66a1.307 1.307 0 0 0-.676-.188 1.609 1.609 0 0 0-1.104.563c-.277.324-.42.744-.398 1.172 0 .33.076.652.24.938l.211.248h1.352l-.225-.248a1.936 1.936 0 0 1-.234-.938h-.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    fill: "#FFE02F",
    d: "m451.303 396.279-.301-.166h-.211l-.24.346s-.563 2.297-.75 3.107h1.051l.188-.285.75-1.314a1.27 1.27 0 0 0-.447-1.695h-.029l-.011.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    fill: "#FBC700",
    d: "M450.611 396.751c.045-.248.195-.474.391-.64l-.225-.111a1.01 1.01 0 0 0-1.225.33.946.946 0 0 0-.172.422l-.615 2.529.291.285h1.225l-.301-.285.631-2.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    fill: "#EAB900",
    d: "m451.58 398.291-.803-.422a.27.27 0 0 0-.314.068.36.36 0 0 0-.063.33c.031.074.076.148.15.18l.752.377.273-.527v-.006h.005Zm-1.666-1a.228.228 0 0 0 .104 0 .245.245 0 0 0 .15-.045.28.28 0 0 0 .105-.135.32.32 0 0 0 0-.232.336.336 0 0 0-.137-.188l-.615-.314a1.556 1.556 0 0 0-.143.352l-.055.24.591.322Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    fill: "#73D578",
    d: "M448.143 394.98a.077.077 0 0 1-.039-.018.086.086 0 0 1-.037-.036v-.091c.105-.232.15-.496.146-.752h-.229l-.428.414-.752.1-.33.479v1.133l-.111.09 1.088.506h.271c.154-.061.299-.145.428-.248.211-.145.367-.354.443-.604.074-.23.059-.494-.031-.732a.554.554 0 0 0-.383-.248l-.036.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    fill: "#4BCE5B",
    d: "M446.498 395.934c-.053-.646.209-1.201.594-1.246a.491.491 0 0 1 .42.164l.037.022h.045l.029-.022c.018-.009.023-.021.023-.037.098-.301.293-.563.541-.75a.61.61 0 0 0-.264-.569c-.303-.158-.75.194-.945.75a.071.071 0 0 1-.031.022l-.037.015c-.014 0-.025-.007-.037-.015l-.029-.022a.528.528 0 0 0-.42-.166c-.385.047-.652.603-.602 1.246.021.182.068.36.135.526l.15.285.518.239a2.581 2.581 0 0 1-.127-.524v.082Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    fill: "#FFE02F",
    d: "m447.166 396.279-.309-.166h-.225l-.232.346s-.57 2.297-.75 3.107h1.043l.195-.285.75-1.314a1.243 1.243 0 0 0-.451-1.695h-.021v.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    fill: "#FBC700",
    d: "M446.461 396.751c.061-.248.195-.474.396-.64l-.222-.111a1 1 0 0 0-1.396.752l-.623 2.529.293.285h1.23l-.301-.285.623-2.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    fill: "#EAB900",
    d: "m447.428 398.291-.803-.422a.306.306 0 0 0-.219 0 .26.26 0 0 0-.143.166.381.381 0 0 0-.018.232.317.317 0 0 0 .15.18l.75.375.277-.525v-.006h.006Zm-1.666-1h.104c.057 0 .113-.014.15-.051a.29.29 0 0 0 .105-.129.432.432 0 0 0 .016-.232.358.358 0 0 0-.15-.188l-.605-.314a1.276 1.276 0 0 0-.15.352l-.053.24.583.322Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    fill: "#73D578",
    d: "M443.969 394.98a.071.071 0 0 1-.037-.018.06.06 0 0 1-.029-.036l-.008-.046v-.045c.104-.238.15-.496.15-.752h-.227l-.428.414-.789.1-.338.479v1.133l-.111.09 1.088.506h.271c.146-.055.299-.145.42-.248a1.13 1.13 0 0 0 .428-1.336.565.565 0 0 0-.39-.241Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    fill: "#4BCE5B",
    d: "M442.354 395.934c-.059-.646.203-1.201.594-1.246.074 0 .15 0 .229.037a.447.447 0 0 1 .191.127l.037.022h.039c.014 0 .021-.017.037-.022.014-.008.014-.021.021-.037a1.5 1.5 0 0 1 .541-.75.71.71 0 0 0-.061-.315.632.632 0 0 0-.203-.254c-.301-.158-.75.194-.945.75 0 .016-.016.022-.029.022l-.037.015a.073.073 0 0 1-.039-.015c-.012-.006-.021-.015-.029-.022a.522.522 0 0 0-.188-.127.59.59 0 0 0-.232-.039c-.383.047-.645.603-.6 1.246.029.182.066.36.135.526l.166.285.51.239a1.285 1.285 0 0 1-.137-.442Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    fill: "#FFE02F",
    d: "m443.014 396.279-.309-.166h-.209l-.24.346s-.563 2.297-.75 3.107h1.051l.188-.285.75-1.314c.35-.584.15-1.35-.447-1.695h-.029l-.005.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    fill: "#FBC700",
    d: "M442.316 396.751c.053-.248.195-.474.391-.64l-.225-.111a1 1 0 0 0-1.396.752l-.623 2.529.301.285h1.223l-.299-.285.628-2.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    fill: "#EAB900",
    d: "m443.285 398.291-.803-.422a.307.307 0 0 0-.227 0 .753.753 0 0 0-.092.068.383.383 0 0 0-.061.33.317.317 0 0 0 .15.18l.75.377.277-.527v-.006h.006Zm-1.674-1h.111a.277.277 0 0 0 .148-.051c.055-.031.074-.076.105-.129a.343.343 0 0 0-.15-.42l-.602-.314a1.276 1.276 0 0 0-.15.352l-.051.24.589.322Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    fill: "#73D578",
    d: "M439.816 394.98c-.01-.004-.02-.008-.029-.018a.078.078 0 0 1-.029-.036.096.096 0 0 1-.023-.046l.023-.045c.09-.232.143-.496.135-.752h-.227l-.428.414-.787.1-.33.479v1.133l-.113.09 1.09.506h.262a1.5 1.5 0 0 0 .439-.248 1.09 1.09 0 0 0 .439-.604c.074-.23.063-.494-.027-.729a.563.563 0 0 0-.385-.248h-.01v.004Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    fill: "#4BCE5B",
    d: "M438.203 395.934c-.061-.646.209-1.201.594-1.246a.52.52 0 0 1 .42.164l.037.022h.045l.029-.022c.018-.009.023-.021.023-.037a1.5 1.5 0 0 1 .541-.75.523.523 0 0 0-.053-.321.609.609 0 0 0-.211-.248c-.293-.158-.75.194-.945.75 0 .017-.018.022-.031.028h-.074a.086.086 0 0 1-.029-.028.522.522 0 0 0-.188-.127.562.562 0 0 0-.232-.039c-.385.047-.652.603-.594 1.246.016.182.061.36.127.526l.158.285.51.239a1.564 1.564 0 0 1-.127-.442Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    fill: "#FFE02F",
    d: "m438.871 396.279-.309-.166h-.18l-.232.346-.75 3.107h1.051l.18-.285.752-1.314a1.24 1.24 0 0 0-.443-1.695h-.074l.005.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    fill: "#FBC700",
    d: "M438.166 396.751c.061-.256.195-.479.391-.64l-.227-.111a.991.991 0 0 0-1.389.752l-.623 2.529.293.285h1.23l-.301-.285.626-2.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    fill: "#EAB900",
    d: "m439.135 398.291-.805-.422a.296.296 0 0 0-.216 0 .353.353 0 0 0-.098.068.383.383 0 0 0-.061.33c.029.074.074.148.15.18l.75.377.277-.527v-.006h.003Zm-1.666-1h.111a.27.27 0 0 0 .248-.18.32.32 0 0 0 0-.232.332.332 0 0 0-.135-.188l-.609-.314a1.213 1.213 0 0 0-.148.352l-.053.24.586.322Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    fill: "#E39B74",
    d: "M442.176 407.552h-4.506l-.209.248v2.043l.322.24h4.43l.283-.442v-1.804l-.32-.285Zm10.597 0h-6.832l-.172.451v1.894l.18.188h6.824a.435.435 0 0 0 .301-.149.496.496 0 0 0 .111-.33v-1.576a.428.428 0 0 0-.111-.323.452.452 0 0 0-.301-.155Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    fill: "#DD8858",
    d: "M437.52 409.604v-1.576a.455.455 0 0 1 .414-.476h-2.553a.471.471 0 0 0-.303.15.453.453 0 0 0-.111.323v1.576a.426.426 0 0 0 .111.321.434.434 0 0 0 .303.158h2.582a.47.47 0 0 1-.174-.039.347.347 0 0 1-.148-.104.456.456 0 0 1-.1-.158.627.627 0 0 1-.021-.175Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    fill: "#DBEDFF",
    d: "m444.066 407.552-.092.166v2.125l.092.24h1.875v-2.531h-1.875Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    fill: "#B5DCFF",
    d: "M442.176 407.552h1.891v2.531h-1.891v-2.531Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    fill: "#7B6C79",
    d: "M444.502 409.13h-.945a.363.363 0 0 1-.113-.03.265.265 0 0 1-.09-.074.292.292 0 0 1-.061-.09c-.016-.039-.016-.076-.016-.121 0-.037 0-.073.016-.112.016-.037.029-.074.061-.104a.227.227 0 0 1 .09-.076.294.294 0 0 1 .113-.021h.945a.32.32 0 0 1 .201.104.202.202 0 0 1 .045.097.2.2 0 0 1 .023.112c0 .037 0 .076-.023.113a.235.235 0 0 1-.045.104.295.295 0 0 1-.09.073.309.309 0 0 1-.111.025Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    fill: "#E39B74",
    d: "M438.33 412.727h-.75l-.18.135v1.283l.148.256h.752a.365.365 0 0 0 .256-.121.37.37 0 0 0 .09-.271v-.899a.32.32 0 0 0-.016-.137.335.335 0 0 0-.074-.127.289.289 0 0 0-.113-.074.327.327 0 0 0-.135-.045h.022Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    fill: "#E39B74",
    d: "M437.506 414.001v-.899c0-.045 0-.099.016-.144a.356.356 0 0 1 .314-.24h-1.6a.41.41 0 0 0-.135.037.31.31 0 0 0-.113.082.41.41 0 0 0-.082.265v.899a.377.377 0 0 0 .33.392h1.6a.354.354 0 0 1-.24-.129.375.375 0 0 1-.09-.263Zm14.389-1.274h-.75l-.18.135v1.283l.164.256h.752a.363.363 0 0 0 .338-.392v-.899c0-.045 0-.092-.018-.137a.29.29 0 0 0-.074-.127.268.268 0 0 0-.111-.074.327.327 0 0 0-.135-.045h.014Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    fill: "#E39B74",
    d: "M451.047 414.001v-.899a.387.387 0 0 1 .098-.265.356.356 0 0 1 .248-.119h-1.598a.42.42 0 0 0-.145.037.31.31 0 0 0-.104.082.364.364 0 0 0-.076.121.404.404 0 0 0-.018.149v.899a.382.382 0 0 0 .34.384h1.6a.5.5 0 0 1-.145-.037.358.358 0 0 1-.117-.084.386.386 0 0 1-.083-.268Zm-8.871-14.712h-4.506l-.209.248v2.033l.322.24h4.43l.283-.443v-1.801l-.32-.285v.008Zm10.597 0h-6.832l-.172.449v1.885l.18.188h6.824a.434.434 0 0 0 .301-.148.421.421 0 0 0 .111-.322v-1.574a.42.42 0 0 0-.119-.322.414.414 0 0 0-.301-.15h.008v-.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    fill: "#DD8858",
    d: "M437.52 401.337v-1.575a.451.451 0 0 1 .414-.474h-2.553a.45.45 0 0 0-.414.474v1.575a.448.448 0 0 0 .414.479h2.582a.476.476 0 0 1-.174-.045.406.406 0 0 1-.148-.104.462.462 0 0 1-.121-.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    fill: "#DBEDFF",
    d: "m444.066 399.281-.092.166v2.123l.092.24h1.875v-2.529h-1.875Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    fill: "#B5DCFF",
    d: "M442.176 399.281h1.891v2.529h-1.891v-2.529Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    fill: "#7B6C79",
    d: "M444.502 400.865h-.945a.307.307 0 0 1-.195-.105.31.31 0 0 1-.082-.211.36.36 0 0 1 .074-.209.305.305 0 0 1 .203-.113h.945a.384.384 0 0 1 .193.113.348.348 0 0 1 .076.209.315.315 0 0 1-.269.316Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    fill: "#33BC00",
    d: "M464.303 391.421h-.674c-.377.021-.73.195-.984.474a1.444 1.444 0 0 0-.375 1.028v.75c0 2.125 1.502 3.853 3.393 3.853h.68a1.453 1.453 0 0 0 1.355-1.539v-.752c-.001-2.079-1.518-3.814-3.395-3.814Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    fill: "#79D60D",
    d: "M468.381 391.421h-.676a1.438 1.438 0 0 0-.982.474 1.446 1.446 0 0 0-.377 1.028v.75c0 2.125 1.502 3.853 3.395 3.853h.674c.395-.039.744-.211.992-.504.256-.285.393-.651.375-1.035v-.752c-.009-2.079-1.524-3.814-3.401-3.814Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    fill: "#025902",
    d: "M462.93 396.052h-.676a1.451 1.451 0 0 0-1.357 1.539v.752c0 2.123 1.5 3.851 3.393 3.851h.678c.375-.021.732-.194.988-.473.258-.285.393-.652.375-1.027v-.752c-.001-2.163-1.509-3.89-3.401-3.89Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    fill: "#008100",
    d: "M467.021 396.052h-.676a1.451 1.451 0 0 0-1.359 1.539v.752c0 2.123 1.502 3.851 3.395 3.851h.676a1.445 1.445 0 0 0 1.365-1.5v-.752c.016-2.163-1.486-3.89-3.401-3.89Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    fill: "#33BC00",
    d: "M471.098 395.707h-.676a1.443 1.443 0 0 0-.998.488 1.478 1.478 0 0 0-.361 1.051v.752c0 2.123 1.502 3.85 3.393 3.85h.68a1.458 1.458 0 0 0 1.355-1.5v-.752c0-2.162-1.516-3.887-3.393-3.887v-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    fill: "#444",
    d: "M493.512 402.216H458.23v-18.495h1.352v16.956h32.609v-16.956h1.357l-.036 18.495Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    fill: "#EB5757",
    d: "M473.814 370.613h4.076v10.795h-4.076v-10.795Zm-4.076 10.795v-10.795h-3.002l-1.059 10.795h4.061Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    fill: "#F3EEEC",
    d: "M477.891 370.613h4.076v10.795h-4.076v-10.795Zm-8.153 0h4.076v10.795h-4.076v-10.795Zm-4.076 10.795 1.053-10.795h-3.004l-2.109 10.795h4.06Zm24.457 0-2.115-10.795H485l1.051 10.795h4.068Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    fill: "#EB5757",
    d: "M463.68 370.613h-2.115l-4.076 9.256v1.502h4.076l2.115-10.758Zm22.363 10.795-1.059-10.795h-3.002v10.795h4.061Zm4.076-10.795h-2.115l2.115 10.795h4.068v-1.502l-4.068-9.293Zm-32.609 10.795v2.313a2.11 2.11 0 0 0 .066.863 2.057 2.057 0 0 0 4.009-.863v-2.313h-4.075Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    fill: "#F3EEEC",
    d: "M461.588 381.408v2.313a2.045 2.045 0 0 0 1.74 2.314c.393.057.789-.002 1.148-.168a2.17 2.17 0 0 0 .697-.518 2.112 2.112 0 0 0 .486-1.631v-2.313h-4.084l.013.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    fill: "#EB5757",
    d: "M465.662 381.408v2.313a2.078 2.078 0 0 0 1.188 2.146 2.055 2.055 0 0 0 2.723-1.021c.162-.352.219-.742.168-1.125v-2.313h-4.079Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    fill: "#F3EEEC",
    d: "M469.738 381.408v2.313a2.108 2.108 0 0 0 .488 1.629 2.058 2.058 0 0 0 2.902.197 2.07 2.07 0 0 0 .686-1.826v-2.313h-4.076Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    fill: "#EB5757",
    d: "M473.814 381.408v2.313a2.09 2.09 0 0 0 .488 1.629 2.054 2.054 0 0 0 2.898.197 2.067 2.067 0 0 0 .689-1.826v-2.313h-4.075Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    fill: "#F3EEEC",
    d: "M477.891 381.408v2.313a2.09 2.09 0 0 0 .488 1.629 2.049 2.049 0 0 0 3.588-1.629v-2.313h-4.076Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    fill: "#EB5757",
    d: "M481.969 381.408v2.313a2.107 2.107 0 0 0 .486 1.629 2.066 2.066 0 0 0 3.59-1.629v-2.313h-4.076Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    fill: "#F3EEEC",
    d: "M486.043 381.408v2.313a2.116 2.116 0 0 0 .488 1.629c.76.852 2.064.924 2.914.164a2.06 2.06 0 0 0 .674-1.793v-2.313h-4.076Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    fill: "#EB5757",
    d: "M490.111 383.721a2.048 2.048 0 1 0 4.076 0v-2.313h-4.068v2.313h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    fill: "#008100",
    d: "m480.639 390.416.676-2.313 1.299.486-.684 2.313-1.291-.486Zm2.716-.008.676-2.313 1.299.486-.684 2.313-1.299-.487.008.001Zm2.717 0 .676-2.313 1.301.486-.686 2.313-1.291-.486Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    fill: "#F80",
    d: "M481.283 389.919a2.176 2.176 0 0 0-2.033 2.312v3.86h4.076v-3.92a2.193 2.193 0 0 0-2.043-2.252Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    fill: "#FF6536",
    d: "M484.002 389.919a2.178 2.178 0 0 0-2.033 2.314v3.858h4.074v-3.92a2.207 2.207 0 0 0-2.041-2.252Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    fill: "#FF421D",
    d: "M486.719 389.919a2.19 2.19 0 0 0-2.025 2.252v3.859h4.082v-3.859a2.193 2.193 0 0 0-2.057-2.252Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    fill: "#FFA900",
    d: "M477.891 395.279h12.229v6.164h-12.232v-6.164h.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    fill: "#E47700",
    d: "M479.926 397.591h8.152v1.502h-8.152v-1.502Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    fill: "#DBD8D5",
    d: "M456.836 400.677h38.035v15.41h-38.035v-15.41Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    fill: "#33BC00",
    d: "m480.803 405.527 2.043-2.313.961 1.089-2.043 2.313-.961-1.089Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    fill: "#33BC00",
    d: "M481.969 406.074h2.025v1.539h-2.025v-1.539Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    fill: "#FF6536",
    d: "M479.865 404.535h-.225a2.724 2.724 0 0 0-2.252 1.322l-2.568 4.084c-.262.426-.369.93-.301 1.426.076.496.324.953.699 1.283.273.225.631.359.988.359h.092c.264 0 .523-.074.752-.211l4.053-2.297a3.346 3.346 0 0 0 1.246-4.232 2.785 2.785 0 0 0-2.484-1.74v.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    fill: "#79D60D",
    d: "M472.455 405.3h-.676a1.466 1.466 0 0 0-1.357 1.502v.75c0 3.005 2.125 5.392 4.752 5.398h.676c.375-.037.729-.22.982-.505.248-.293.385-.659.375-1.051v-.75c-.014-2.926-2.123-5.344-4.752-5.344Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    fill: "#98BAF4",
    d: "M547.484 394.402h-5.854v10.703h5.854v-10.703Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    fill: "#fff",
    d: "M541.879 404.753h5.254v-10.006h-5.254v10.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    fill: "#fff",
    d: "M547.207 397.975h-5.404v.519h5.404v-.519Zm0 3.566h-5.404v.518h5.404v-.518Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    fill: "#fff",
    d: "M544.73 405.1v-10.75h-.451v10.75h.451Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    fill: "#233862",
    d: "M557.822 392.007a.219.219 0 0 1-.121-.045.2.2 0 0 1-.074-.099l-.75-1.778h-2.365a.59.59 0 0 1-.09-.022c-.025-.017-.053-.033-.074-.054a.154.154 0 0 1-.037-.073l-.008-.099v-.082l.053-.075a.204.204 0 0 1 .15-.074h2.514c.09 0 .166.054.195.136l.75 1.913a.358.358 0 0 1 .016.188.275.275 0 0 1-.113.15l-.046.014Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    fill: "#233862",
    d: "M556.299 390.212h-1.787a.303.303 0 0 1-.135-.037.344.344 0 0 1-.171-.202c-.016-.043-.02-.091-.016-.136a.344.344 0 0 1 .322-.366h1.824c.045 0 .09.014.129.036.045.017.074.046.111.074.021.037.053.076.066.121a.39.39 0 0 1 .016.135.287.287 0 0 1-.016.149.374.374 0 0 1-.201.203c-.049.021-.1.026-.15.021l.008.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    fill: "#505356",
    d: "M553.408 392.171a.248.248 0 0 1-.121-.037.235.235 0 0 1-.074-.098l-.75-1.779h-2.371a.226.226 0 0 1-.174-.073.231.231 0 0 1-.074-.175.224.224 0 0 1 .074-.172.243.243 0 0 1 .174-.073h2.506c.045 0 .076.014.121.045.037.021.061.06.074.099l.752 1.92c.021.06.027.121.014.183a.287.287 0 0 1-.111.149c-.014.004-.026.009-.04.011Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    fill: "#636B77",
    d: "M555.969 405.145c.203 0 .99-.862 2.252-.817 1.262.045 8.145 0 8.145 0a.938.938 0 0 1 .361.021c.23.067.426.231.531.45.053.104.074.226.092.347h-11.381v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    fill: "#28130F",
    d: "M547.291 372.264c.314.137.57.36.75.653.248.519.367 1.088.33 1.666 0 0 .525-1.44-.053-2.252-.578-.81-1.027-.067-1.027-.067Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    fill: "#AFAFAF",
    d: "M624.15 306.587h-99.035v98.271h99.035v-98.271Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    fill: "#919191",
    d: "M624.15 302.992h-99.035v3.604h99.035v-3.604Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    fill: "#CCC",
    d: "M610.475 361.854h-71.014v42.976h71.014v-42.976Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    fill: "#fff",
    d: "M608.418 364.855h-66.563v40.115h66.563v-40.115Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    fill: "#CCC",
    d: "M606.037 367.393h-61.658v9.219h61.658v-9.219Zm-19.742 11.726h-22.166v25.688h22.166v-25.688Zm19.742 0h-18.219v25.688h18.219v-25.688Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    fill: "#F3EEEC",
    d: "M571.387 379.119h14.908v9.502l-2.658 16.178h-16.469l4.219-25.674v-.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    fill: "#fff",
    d: "M583.615 384.005h-16.59v20.822h16.59v-20.822Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    fill: "#CCC",
    d: "M582.818 384.943H567.82v19.893h15.006v-19.893h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    fill: "#fff",
    d: "M575.598 384.943h-.557v19.893h.557v-19.893Zm-1.891 9.948a.336.336 0 0 1 .074-.183.382.382 0 0 1 .375-.104.415.415 0 0 1 .166.104.35.35 0 0 1 .053.375.273.273 0 0 1-.129.149.323.323 0 0 1-.188.062.366.366 0 0 1-.256-.127.37.37 0 0 1-.095-.276Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    fill: "#F3EEEC",
    d: "M550.113 379.119h9.127l-2.912 25.68h-9.129l2.914-25.674v-.006Zm10.457-11.726-1.053 9.219h-9.119l1.043-9.219h9.129Zm31.559 11.726h9.127l-2.912 25.68h-9.129l2.914-25.674v-.006Zm10.457-11.726-1.053 9.219h-9.121l1.045-9.219h9.129Zm-12.809 0-1.516 9.219H571.8l1.516-9.219h16.461Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    fill: "#919191",
    d: "M624.15 348.574h-99.035v4.309h99.035v-4.309Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    fill: "#505356",
    d: "M551.951 389.71h-1.877a.427.427 0 0 0-.42.429v.163c0 .232.195.429.428.429h1.869a.427.427 0 0 0 .422-.429v-.163a.423.423 0 0 0-.412-.429h-.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    fill: "#79869B",
    d: "m567.16 405.796-10.135.121-4.541-16.192 6.869-.091 7.807 16.162Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    fill: "#212121",
    d: "M568.625 413.251s-.15 2.776.225 2.822h4.332a1.127 1.127 0 0 0-.75-.992 3.434 3.434 0 0 1-2.252-2.146c-.438-1.307-1.555.316-1.555.316Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    fill: "#2B73D3",
    d: "M559.67 399.207s-.834 3.303.262 4.504c1.275 1.35 8.311.494 8.213 1.275-.172 1.352.428 8.895.428 8.895.74.174 1.514.174 2.252 0 0 0 1.037-10.861-.146-12.258-1.734-2.041-7.566-3.424-7.566-3.424l-3.438 1v.008h-.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    fill: "#212121",
    d: "M566.094 413.257s-.15 2.777.227 2.816h4.33a1.106 1.106 0 0 0-.75-.992 3.457 3.457 0 0 1-2.252-2.154c-.452-1.291-1.555.33-1.555.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    fill: "#2F80ED",
    d: "M557.191 399.207s-.834 3.303.264 4.504c1.275 1.35 8.303.494 8.211 1.275-.262 2.252.322 9.082.322 9.082a6.938 6.938 0 0 0 2.396-.148s1.344-10.314-.15-12.268c-.961-1.27-6.906-2.926-6.906-2.926l-4.137.473v.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    fill: "#FFB27D",
    d: "M561.635 383.089a5.334 5.334 0 0 0-.309 2.627l-.75 3.234-2.162-3.259a9.433 9.433 0 0 0 1.035-3.332l2.178.729.008.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    fill: "#FFB27D",
    d: "M562.018 383.914s-2.402.902-2.807-.93c-.406-1.832-1.314-2.854.473-3.596 1.502-.604 2.125 0 2.379.6.255.601.857 3.53-.045 3.926Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    fill: "#ADADAD",
    d: "M562.477 381.88s.938 2.252.203 2.813c-.736.563-2.928.998-3.498-1.922a4.07 4.07 0 0 0 1.814.31c.533-.195.795-.69 1.352-.549 0 .001.181-.066.129-.652Zm-3.664-1.621a.535.535 0 0 1 .166-.36 2.229 2.229 0 0 1 2.387-.676c-1.127-1.162-3.094-.226-3.266 1.2-.277 2.328 1.08 2.351 1.08 2.351s1.143-1.071.227-1.688a1.444 1.444 0 0 1-.541-.623.989.989 0 0 1-.053-.204Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    fill: "#fff",
    d: "M561.365 384.027a.852.852 0 0 0 .322.18.801.801 0 0 0 .383.008c.271-.045.42-.428.42-.428a1.762 1.762 0 0 0-1.125.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    fill: "#F29A7E",
    d: "M571.025 394.125a.704.704 0 0 1-.27.209.684.684 0 0 1-.322.076.656.656 0 0 1 .09-.383.747.747 0 0 1 .301-.264l.887-.398s.053 0 .09.045-.045.098-.045.098a.7.7 0 0 1-.174.182 1.559 1.559 0 0 0-.557.435Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    fill: "#F29A7E",
    d: "M571.207 393.951c.75-.211 1.5 0 1.576.203.074.203-.826.676-1.502.795-.676.129-.938-.111-.982-.33-.045-.225.225-.473.9-.668h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    fill: "#999",
    d: "M563.34 387.203c0 .09 2.553 6.561 3.355 6.695 1.215.061 2.432 0 3.641-.182l.33 1.504a9.173 9.173 0 0 1-4.504.861c-2.146-.293-3.393-3.229-3.393-3.229l.571-5.649Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    fill: "#B7B7B7",
    d: "M558.572 401.061a4.32 4.32 0 0 1-1.742-.136c-.299-.112-.51-3.108-.613-6.307-.121-3.527-.105-7.312.09-7.656.375-.698 2.125-1.313 2.178-1.321.533.489 1.23.771 1.951.789a.902.902 0 0 0 .893-.75 8.48 8.48 0 0 1 1.201.493c1.051.451 1.037 2.492 1.037 2.492s.105 7.627.436 9.422c.298 1.638-3.079 2.793-5.431 2.974Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    fill: "#F29A7E",
    d: "M561.65 399.355a.902.902 0 0 1-.639-.119.672.672 0 0 1 .697-.301l.951.193c.02 0 .031.018.039.029 0 .016.018.039 0 .053 0 .055-.084.063-.084.063a.576.576 0 0 1-.248 0 1.65 1.65 0 0 0-.713.076l-.003.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    fill: "#F29A7E",
    d: "M561.922 399.326c.75.27 1.262.887 1.164 1.08-.1.195-1.061.061-1.697-.24-.639-.299-.691-.645-.602-.84.092-.195.48-.24 1.125 0h.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    fill: "#999",
    d: "M556.531 386.669s-1.336.961-1.313 5.254c.02 4.295-.195 5.062.42 5.632.615.555 4.137 2.313 5.42 2.418.135-.175.225-.377.27-.595a1.438 1.438 0 0 0-.008-.646s-3.963-3.295-4.016-3.482c-.053-.187 1.906-6.254 2.023-7.379a1.472 1.472 0 0 0-1.043-1.637 1.749 1.749 0 0 0-1.756.428v.007h.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    fill: "#7D8696",
    d: "M548.777 413.664c0-3.754 2.627-6.809 5.877-6.809 3.242 0 5.869 3.055 5.869 6.809s-2.635 6.809-5.869 6.809-5.877-3.056-5.877-6.809Zm.623 0c0 3.355 2.355 6.08 5.254 6.08 2.899 0 5.254-2.725 5.254-6.08s-2.355-6.08-5.254-6.08c-2.899 0-5.254 2.732-5.254 6.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    fill: "#505356",
    d: "M565.584 416.876h8.49v-.795h-8.49v.795Zm-10.479-10.66h11.357v-1.034h-11.357v1.034Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    fill: "#505356",
    d: "m565.592 416.876.811-.549-5.555-11.146-.826.541 5.57 11.154Zm-11.186-2.703h.705v-13.577h-.705v13.577Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    fill: "#505356",
    d: "M565.479 417.988h.705V400.97h-.705v17.018Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    fill: "#505356",
    d: "M553.965 401.458h13.24a1.609 1.609 0 0 0-1.508-1.713h-10.885a.992.992 0 0 0-.654.33.964.964 0 0 0-.225.69l.032.693Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    fill: "#212121",
    d: "M567.078 419.031a1.253 1.253 0 0 0-2.199-.646 1.341 1.341 0 0 0-.301.654 1.252 1.252 0 0 0 1.254 1.434 1.368 1.368 0 0 0 1.246-1.442Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    fill: "#B7B7B7",
    d: "M565.404 419.031a.344.344 0 0 1 .016-.18.37.37 0 0 1 .09-.15.385.385 0 0 1 .148-.121.456.456 0 0 1 .166-.045c.119.016.24.076.314.166.084.09.129.211.111.33a.458.458 0 0 1-.425.496.458.458 0 0 1-.42-.492v-.004Zm-12.131.75c-.053-.27 2.59-11.057 2.896-12.279h.072c-.811 3.303-2.912 11.936-2.895 12.234l-.073.045Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    fill: "#B7B7B7",
    d: "M549.445 411.945c.225-.063 9.533 3.002 10.592 3.354v.105c-2.838-.939-10.283-3.381-10.547-3.355l-.045-.104Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    fill: "#B7B7B7",
    d: "M550.412 409.714c.24.045 7.809 7.035 8.664 7.83l-.053.082c-2.313-2.14-8.377-7.717-8.633-7.808l.022-.104Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    fill: "#B7B7B7",
    d: "M560.256 412.837c-.227-.098-9.813 1.449-10.9 1.621v.104c2.928-.474 10.6-1.694 10.854-1.629l.046-.096Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    fill: "#B7B7B7",
    d: "M552.664 407.816c.182.18 3.756 10.6 4.145 11.785l-.082.037c-1.088-3.189-3.947-11.521-4.129-11.748l.066-.074Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    fill: "#B7B7B7",
    d: "M559.076 409.85c-.24.047-7.883 6.914-8.754 7.694l.053.074c2.344-2.103 8.469-7.58 8.709-7.673l-.008-.095Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    fill: "#B7B7B7",
    d: "M554.01 413.693a.749.749 0 1 1 1.48.24.752.752 0 0 1-.73.631.836.836 0 0 1-.557-.277.817.817 0 0 1-.193-.586v-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    fill: "#EDC472",
    d: "M532.074 404.289h-32.549l-1.502-8.709h32.482l1.569 8.709Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    fill: "#7D8696",
    d: "M537.961 404.294h-38.436v1.065h38.436v-1.065Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    fill: "#ADADAD",
    d: "M518.008 383.766a2.177 2.177 0 0 0 1.32 1.396c1.027.301.826 1.209.75 2.088-.074.871 1.502 2.215-.18 3.424-1.682 1.216-3.852-2.553-3.852-2.553l.09-3.095 1.872-1.26Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    fill: "#EAC3A2",
    d: "M520.094 396.992c-.18-.227-.33-.48-.428-.752a19.69 19.69 0 0 1-.871-2.252c-.09-.293-.143-.48-.111-.51.09-.15.172-.303.24-.451.127-.277.299-.652.465-1.043a9.684 9.684 0 0 0 .623-1.637c.074.293 1.463 5.357 1.502 6.059.037.691-1.006.938-1.428.586h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    fill: "#999",
    d: "M510.439 387.225a9.364 9.364 0 0 1 1.629 1.502c.855.924 2.146 3.002 2.717 3.416.572.412 3.619.75 3.619.75v.752s-2.74 1.051-4.557.629a8.055 8.055 0 0 1-3.355-2.012l-.053-5.037Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    fill: "#F2A470",
    d: "M524.508 411.486c0-.104.066-.24.105-.396.066-.879.232-4.205.486-5.504.879.654 1.953.053 2.252.053-.359 1.262-1.336 4.67-1.576 5.383-.129.541-.18 1.1-.15 1.652.1.615.303 1.207.602 1.756a4.328 4.328 0 0 1-1.824-.602c-.539-.428-.953-.832-.75-1.207.074-.135.18-.264.293-.375.256-.189.451-.451.564-.752v-.008h-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    fill: "#212121",
    d: "M524.381 413.973c.586.313.352.375 1.117.938.768.563 1.188.45 1.291.354.105-.099-.225-.451-.563-.851a2.339 2.339 0 0 1-1.254-.578c-.486-.428-.877-1.051-1.215-1.351a1.688 1.688 0 0 0-.258.384c-.192.421.286.772.882 1.104Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    fill: "#FFB27D",
    d: "M522.359 412.042v-.414c-.074-.877-.449-4.188-.404-5.522.969.457 1.922-.377 2.199-.429-.148 1.313-.555 4.871-.676 5.621-.037.558 0 1.111.121 1.652.188.586.484 1.125.877 1.598a4.065 4.065 0 0 1-1.895-.2c-.6-.302-1.07-.603-.896-1.037.059-.144.143-.285.225-.412.225-.241.375-.542.449-.857Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    fill: "#212121",
    d: "M522.631 414.498c.631.188.414.291 1.254.674.842.398 1.238.203 1.328.076.092-.127-.301-.391-.689-.75a2.27 2.27 0 0 1-1.328-.285c-.541-.316-1.029-.85-1.404-1.082-.072.143-.146.285-.193.436-.124.501.401.742 1.032.931Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    fill: "#F99746",
    d: "M518.576 399.033s.826-1.246 1.391-1.066c.578.182 4.406 1.029 6.365 3.439 1.764 2.154 1.711 6.178 1.711 6.178s-2.643.826-4.354.473c-1.705-.361-1.939.074-2.732.227-.563.098-1.006-3.4-1.396-3.693-.607-.473-5.328-.357-5.426-2.771-.1-2.4 4.441-2.775 4.441-2.775v-.012Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    fill: "#ADADAD",
    d: "M516.686 385.664s2.379-1.951.893-3.904a1.241 1.241 0 0 0-.529-.404c-.564-.225-1.832-.602-2.563.15-.729.75-1.135 1.449-.631 2.334.502.9 2.838 1.832 2.838 1.832l-.008-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    fill: "#FFB27D",
    d: "M514.779 385.395v2.28l.486 3.003 2.043-3.003s-.375-.437-.705-2.61v-.039l-1.824.369Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    fill: "#F9DDBF",
    d: "M520.063 398.71c.137.293-.555 1.015-.9 1.229-.346.211-.473.369-3.15.563l-.824.063c-1.73.104-2.65.104-2.65.104s1.098-2.326.563-7.883a4.942 4.942 0 0 1 .752-2.408c.367-.623.072-.805.164-1.547 0-.211-.42-.523-.375-.75 0 0 1.088-.523 1.141-.523.412.457.998.732 1.621.75a.892.892 0 0 0 .871-.75c.24.09.48.199.705.33a3.42 3.42 0 0 1 2.035 2.414s-.623 5.092-.676 5.813c.094.899.34 1.769.723 2.595Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    fill: "#FFB27D",
    d: "M514.357 386.503s2.096.354 2.252-1.17c.15-1.517.564-2.483-.75-2.776-1.313-.302-1.658.239-1.832.75-.156.504-.209 3.062.33 3.196Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    fill: "#FFFFF6",
    d: "M515.064 382.48a2.683 2.683 0 0 0-1.135 1.27s-.713-1.479 1.127-1.275l.008.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    fill: "#EDA16E",
    d: "M515.801 399.207c.422-.043.85-.029 1.268.045.301.104.559.33.699.629 0 .182-.752.285-.9.195-.137-.09-.496.09-.752 0a2.458 2.458 0 0 1-.457-.285l.142-.584Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    fill: "#EAC3A2",
    d: "M513.637 388.096a3.23 3.23 0 0 0-1.645 1.569c-.6 1.026-.916 5.688-.832 6.446.074.75.877 2.103 4.33 3.853a.597.597 0 0 0 .414-.271.445.445 0 0 0 .074-.232.456.456 0 0 0-.016-.248l-2.627-3.512 1.088-4.543s.639-2.461-.787-3.055v-.007h.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    fill: "#212121",
    d: "M516.551 413.041s-.158 2.424.24 2.463h4.52a.968.968 0 0 0-.75-.871 3.442 3.442 0 0 1-2.373-1.877c-.473-1.133-1.637.285-1.637.285Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    fill: "#213F7C",
    d: "M507.182 399.537s-.871 3.168.277 4.277c1.336 1.299 8.678.486 8.58 1.225-.174 1.291.449 8.52.449 8.52a5.826 5.826 0 0 0 2.396 0s1.088-10.396-.15-11.73c-1.816-1.951-7.912-3.281-7.912-3.281l-3.64.989Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    fill: "#212121",
    d: "M513.908 413.041s-.156 2.424.227 2.463h4.541a.975.975 0 0 0-.752-.871 3.41 3.41 0 0 1-2.371-1.877c-.48-1.133-1.652.285-1.652.285h.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    fill: "#2B478B",
    d: "M504.6 399.537s-.871 3.168.277 4.277c1.328 1.299 8.678.475 8.58 1.225-.277 2.176.338 8.693.338 8.693a7.849 7.849 0 0 0 2.508-.15s1.402-9.857-.158-11.727c-1.006-1.209-7.221-2.799-7.221-2.799l-4.324.473v.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    fill: "#FFB27D",
    d: "M509.238 384.141a4.803 4.803 0 0 0-.322 2.506l-.75 3.103-2.252-3.115a8.655 8.655 0 0 0 1.072-3.198l2.252.704Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    fill: "#B7B7B7",
    d: "M506.041 401.33a4.8 4.8 0 0 1-1.824-.127c-.301-.113-.525-3.002-.646-6.006-.127-3.395-.104-6.996.092-7.342.393-.652 2.252-1.238 2.252-1.246a3.417 3.417 0 0 0 2.051.752.901.901 0 0 0 .924-.752c.439.129.871.285 1.273.479 1.105.42 1.074 2.381 1.074 2.381s.105 7.305.449 9.01c.353 1.576-3.19 2.679-5.645 2.851Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    fill: "#FFB27D",
    d: "M509.658 384.906s-2.52.863-2.949-.9c-.42-1.75-1.357-2.727.512-3.432 1.5-.586 2.252 0 2.477.57.24.568.887 3.379-.037 3.754v.008h-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    fill: "#ADADAD",
    d: "M510.117 382.977s.977 2.133.219 2.694c-.768.563-3.057.953-3.656-1.832a4.66 4.66 0 0 0 1.898.285c.549-.181.826-.66 1.412-.524 0 0 .188-.061.127-.623Zm-3.828-1.561a.526.526 0 0 1 .18-.338 2.5 2.5 0 0 1 2.484-.654 2.124 2.124 0 0 0-3.406 1.149c-.303 2.254 1.125 2.254 1.125 2.254s1.193-1.035.248-1.631a1.316 1.316 0 0 1-.57-.592 1.37 1.37 0 0 1-.061-.188Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_515",
    fill: "#FFB27D",
    d: "M518.832 399.529s-.961 0-1.148.188c-.187.188-.465.75-.33.879.137.127.691-.195 1.037-.104a.906.906 0 0 0 .9-.271c.322-.287-.459-.692-.459-.692Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_516",
    fill: "#EAC3A2",
    d: "m519.447 395.025-.637 4.459c.063.332.291.611.6.75 0 0 2.252-2.619 2.117-3.701-.15-1.08-2.08-1.5-2.08-1.5v-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_517",
    fill: "#fff",
    d: "M508.953 384.792c.105.09.227.149.361.188a.72.72 0 0 0 .396 0c.264-.045.402-.43.402-.43a1.774 1.774 0 0 0-1.152.24l-.007.002Zm6.486.901a.813.813 0 0 1-.713.195c-.264-.055-.414-.438-.414-.438.391-.042.79.042 1.127.243Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_518",
    fill: "#FFB27D",
    d: "M509.246 399.619a.789.789 0 0 1-.652 0 .717.717 0 0 1 .24-.316.6.6 0 0 1 .375-.111h1.006l.016.018.016.021v.022c0 .054-.072.074-.072.074a.632.632 0 0 1-.24.098 1.481 1.481 0 0 0-.689.194Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_519",
    fill: "#FFB27D",
    d: "M509.502 399.529c.752.111 1.41.615 1.352.826-.045.201-1.021.27-1.703.104-.684-.164-.813-.486-.752-.697.063-.203.406-.322 1.105-.225v-.008h-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_520",
    fill: "#999",
    d: "M503.926 387.525s-1.391.924-1.359 5.029c.029 4.092-.211 4.85.438 5.391.646.541 4.322 2.252 5.668 2.326a1.41 1.41 0 0 0 .275-.563c.05-.204.055-.42 0-.631 0 0-4.148-3.152-4.205-3.324-.051-.183 1.156-3.492 1.393-4.506.938-4.397-2.199-3.729-2.199-3.729l-.011.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_521",
    fill: "#7D8696",
    d: "M504.771 405.136h-1.373v11.269h1.373v-11.269Zm29.706 0h-1.375v11.269h1.375v-11.269Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_522",
    fill: "#FFB27D",
    d: "M554.137 389.042c.053.051 1.109-.104 1.447.144.338.246.676.938.525 1.187-.151.249-.887-.496-1.096-.488a3.749 3.749 0 0 1-.826-.202l-.05-.641Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_523",
    fill: "#28130F",
    d: "M543.049 381.189c-.156-.354 3.477-1.639 3.527 1.877 0 0 6.811-.195 3.561-4.586a5.486 5.486 0 0 1-.977-3.957c0-1.17-.707-4.578-3.229-4.232a1.63 1.63 0 0 0-1.502.188c-1.848 1.125-6.043 12.012-1.381 10.721v-.011h.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_524",
    fill: "#EAC3A2",
    d: "M554.459 388.945a.954.954 0 0 1 0 .893c-.887.061-1.777.021-2.656-.113a5.517 5.517 0 0 1-2.178-.75c-.848-.578-1.313-2.951-1.898-4.91-.623-2.068-1.014-4.053-1.014-4.053.285-.803.75-.977 1.373-.848.346.066.969-.045 1.352.66.256.449 1.225 5.367 1.854 7.244.142.375 3.167 1.877 3.167 1.877Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_525",
    fill: "#212121",
    d: "M538.439 416.636s-.75.804-.615 1.373c.135.57.84.961.932 1.66.09.705.465 1.08.795 1.08h1.6a.41.41 0 0 0 .053-.203.409.409 0 0 0-.053-.209.445.445 0 0 0-.15-.149.457.457 0 0 0-.191-.076c-.604-.147-.826-.976-.752-1.728.016-.6 0-1.198-.063-1.793l-1.262-.338-.299.383h.005Zm6.456.346s-.27 3.453.061 3.646h4.324a.846.846 0 0 0-.24-.512.826.826 0 0 0-.51-.24c-.688-.127-1.896-.602-2.102-1.629-.203-1.035-1.533-1.273-1.533-1.273v.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_526",
    fill: "#FFB27D",
    d: "M541.832 392.464c.895-2.252 1.428-2.94 1.33-3.655-.074-.533.225-9.871.225-9.871l.436-.104c.361-.106.645-.392.752-.75a7.425 7.425 0 0 0 .271-2.117h.111l1.893.437s-.045.69-.045 1.353a1.254 1.254 0 0 0 .75 1.224l.451.149c.436 1.524.713 3.086.824 4.67.143 2.371-1.262 3.399 0 8.138 1.275 4.744-7.477 1.803-6.988.524l-.01.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_527",
    fill: "#E8945B",
    d: "M546.893 376.378s-.045.688-.045 1.345c-1.066-.039-1.629-1.156-1.855-1.779l1.9.434Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_528",
    fill: "#FFB27D",
    d: "M547.238 377.016s-2.508.045-2.508-1.771c0-1.816-.33-3.002 1.275-3.138 1.604-.149 1.922.578 2.043 1.192.135.601-.15 3.648-.807 3.709l-.003.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_529",
    fill: "#28130F",
    d: "M547.154 372.063s-.689 2.131-1.748 2.446a1.777 1.777 0 0 1-1.502 0 3.608 3.608 0 0 0 .977-2.051s1.75-1.41 2.273-.395Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_530",
    fill: "#F9DDBF",
    d: "m548.559 388.389-2.5.862-.787-.226-2.252-.646s-.301-.109-.549-.803a9.02 9.02 0 0 1-.232-.998 35.106 35.106 0 0 1-.264-1.563c-.09-.638-.271-1.427-.42-2.252a20.676 20.676 0 0 1-.256-1.937 1.613 1.613 0 0 1 1.254-1.759l.834-.104c2.648 2.508 4.691.195 4.691.195.51 1.125.9 2.305 1.148 3.504.473 2.025-.676 5.722-.676 5.722h.008v.005h.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_531",
    fill: "#ED7D2B",
    d: "M548.4 388.938c.563 1.974 1 3.979 1.314 6.004.072 1.502-2.252 22.521-2.537 23.22-.15.375-2.646-.347-2.646-.347s-.674-14.217-.082-19.321c.361-3.168.564-6.343.604-9.533l3.347-.023Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_532",
    fill: "#F99746",
    d: "M543.162 388.809s-1.893 2.928-2.057 4.909c-.174 1.982-.279 8.935-.654 10.861a84.386 84.386 0 0 0-2.176 11.508s2.371.888 2.461.752c1.051-2.116 3.859-9.521 4.01-10.976.111-1.028 1.043-7.829 3.076-11.815.496-.952-.299-4.766-.299-4.766l-4.361-.473Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_533",
    fill: "#233862",
    d: "M548.59 388.246a2.29 2.29 0 0 1-1.502.473c-1.164 0-4.084-.346-4.084-.346a3.477 3.477 0 0 0-.119.863s3.559 1.053 5.623.148c.162-.354.193-.756.09-1.133l-.008-.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_534",
    fill: "#EAC3A2",
    d: "M541.6 382.421s1.705 5.328 3.453 6.517c1.742 1.187 4.842.899 4.842.899.076-.149.113-.33.113-.496a1.047 1.047 0 0 0-.113-.403s-3.002-.978-3.828-2.802c-1.689-3.641-2.492-7.243-2.68-7.206-.922.239-1.36 2.275-1.787 3.491Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_535",
    fill: "#FFB27D",
    d: "M550.375 389.357a.805.805 0 0 1-.652 0 .649.649 0 0 1 .623-.438h.992l.021.018v.021c.014.008.014.017.014.03 0 .046-.074.074-.074.074a.679.679 0 0 1-.24.09 1.43 1.43 0 0 0-.684.205Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_536",
    fill: "#FFB27D",
    d: "M550.631 389.268c.752.11 1.41.601 1.352.817-.045.209-1.02.276-1.703.11-.684-.163-.811-.485-.752-.696.06-.21.404-.322 1.103-.231Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_537",
    fill: "#fff",
    d: "M546.33 376.085c.201.188.48.254.75.194.264-.053.412-.437.412-.437a1.828 1.828 0 0 0-1.162.243Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_538",
    fill: "#EAC3A2",
    d: "m544.58 382.382-1.186-3.459s-2.764-.631-2.035 2.447c0 .045.076.51.277 1.178.193.668.549 1.44.578 1.502.766-.631 1.593-.984 2.366-1.668Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_539",
    fill: "#FFB27D",
    d: "m581.438 411.689.428 2.049.266 1.277.879 4.23a2.596 2.596 0 0 0 1.502 0c.188-1.035.283-2.086.293-3.146a12.57 12.57 0 0 0-.266-2.912 8.767 8.767 0 0 0-.377-1.127c-1.231-2.9-2.725-.371-2.725-.371Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_540",
    fill: "#212121",
    d: "M580.719 420.473h4.111c.039-.474 0-.945-.111-1.412 0-.104-.061-.201-.098-.308a3.442 3.442 0 0 1-1.711 0 8.016 8.016 0 0 1-1.201.97c-.451.224-.924.097-.99.75Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_541",
    fill: "#FFB27D",
    d: "m584.727 411.689.42 2.049.27 1.277.863 4.23a2.596 2.596 0 0 0 1.502 0c.203-1.035.301-2.086.301-3.146a12.01 12.01 0 0 0-.301-2.883 6.876 6.876 0 0 0-.357-1.125c-1.201-2.936-2.703-.406-2.703-.406h.008v.004h-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_542",
    fill: "#212121",
    d: "M587.9 418.753a3.442 3.442 0 0 1-1.711 0 6.997 6.997 0 0 1-1.201.97c-.449.226-.945.098-.99.75h4.121a4.35 4.35 0 0 0-.225-1.72h.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_543",
    fill: "#EAC3A2",
    d: "M588.848 413.244s-.316-2.74-.422-3.896a6.11 6.11 0 0 1-.053-1.051c.676-5.119 1.238-11.141 1.172-12.289v-.248s-.488-.045-1.209-.074c-2.133-.104-6.381-.074-7.078 1.502-.705 1.576-.75 11.186-.75 11.186 0 2.611.344 5.613.344 5.613l7.996-.743Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_544",
    fill: "#F9DDBF",
    d: "M585.477 375.785c.016-.15 0-.301-.037-.428a1.048 1.048 0 0 0-1.328-.72.994.994 0 0 0-.707.924c0 .66.467 1.426 1.037 1.426a1.128 1.128 0 0 0 1.035-1.202Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_545",
    fill: "#F9DDBF",
    d: "M584.592 380.589s2.5-2.612.578-4.608a1.388 1.388 0 0 0-.652-.392c-.676-.172-2.178-.412-2.928.558-.76.968-1.135 1.83-.459 2.776.676.961 3.453 1.666 3.453 1.666h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_546",
    fill: "#FFB27D",
    d: "M582.34 380.559s0 .43.098 1.015c0 .278.066.602.113.924l.104.69.855 3.332 1.996-3.754s-.473-.449-1.109-2.89l-2.057.683Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_547",
    fill: "#E8945B",
    d: "M582.436 381.572c0 .279.068.602.113.924 2.178-.982 1.906-2.365 1.848-2.619a28.562 28.562 0 0 0-1.961 1.695Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_548",
    fill: "#FFB27D",
    d: "M581.986 381.902s2.447.092 2.469-1.674c.023-1.766.361-2.941-1.199-3.076-1.563-.137-1.877.531-2.006 1.117-.127.586.098 3.559.736 3.633Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_549",
    fill: "#F9DDBF",
    d: "M581.768 376.889s.15 3.362 3.139 3.047c-.001 0-.077-4.497-3.139-3.047Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_550",
    fill: "#F9DDBF",
    d: "M582.34 377.158c-.541.41-.945.977-1.156 1.623 0 0-.985-1.563 1.156-1.623Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_551",
    fill: "#fff",
    d: "M581.865 380.867c.068.113.15.211.264.277a.82.82 0 0 0 .359.129c.264 0 .525-.285.525-.285a1.786 1.786 0 0 0-1.148-.121Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_552",
    fill: "#F29A7E",
    d: "M574.861 397.18a.784.784 0 0 1 .586-.294.709.709 0 0 1-.082.384.7.7 0 0 1-.301.271l-.885.392s-.053 0-.09-.046c-.039-.045.045-.098.045-.098a.688.688 0 0 1 .172-.181c.217-.099.412-.248.563-.437l-.008.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_553",
    fill: "#F29A7E",
    d: "M574.666 397.337c-.75.209-1.5 0-1.574-.194-.076-.194.824-.677 1.502-.806.674-.127.938.121.975.338.052.22-.225.473-.903.662Zm13.889 1.261a.697.697 0 0 1-.031-.33.754.754 0 0 1 .121-.313.621.621 0 0 1 .27.293.653.653 0 0 1 .045.39l-.172.961s0 .053-.072.045c-.094-.006-.068-.09-.068-.09a.71.71 0 0 1-.045-.246c.032-.24.016-.48-.048-.71Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_554",
    fill: "#F29A7E",
    d: "M588.576 398.861c-.246.75-.861 1.273-1.051 1.186-.188-.089-.09-1.051.195-1.703.285-.646.631-.707.826-.617.194.089.257.45.03 1.134Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_555",
    fill: "#C6C6C6",
    d: "M575.605 397.343c.818 0 3.49-2.077 4.391-2.911l.227-.226a29.481 29.481 0 0 0 2.313-4.093c.41-.771.701-1.603.863-2.463a15.275 15.275 0 0 0-.75-4.504 4.38 4.38 0 0 0-2.764 3.326l-1.283 5.532a1.555 1.555 0 0 1-.428.75l-3.395 3.267c-.016.276.053.556.203.795.135.234.362.424.623.527Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_556",
    fill: "#EAEAEA",
    d: "M581.168 396.992c0 .375.066.449.066.449s1.225.512 4.316.33l.943-.061c1.99-.137 3.059-.277 3.059-.277s1.629-4.354-1.438-9.76a15.936 15.936 0 0 0-1.229-1.859 5.903 5.903 0 0 1-.797-2.365c-.045-.232.098-.293 0-.51 0 0-.563-.188-.607-.188a2.621 2.621 0 0 1-1.779 1.08.943.943 0 0 1-1.08-.646c-.26.127-.51.271-.752.428a4.271 4.271 0 0 0-2.057 3.078s1.73 6.599 1.84 7.425a25.806 25.806 0 0 0-.479 2.875l-.006.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_557",
    fill: "#C6C6C6",
    d: "M585.508 382.766a3.868 3.868 0 0 1 3.416 1.981c1.064 1.771 1.688 6.373 1.688 7.252 0 .877-.826 5.254-1.352 6.133a.19.19 0 0 1-.061.062.154.154 0 0 1-.09.021l-1.336-.172a.437.437 0 0 1-.084-.029.229.229 0 0 1-.059-.061l-.031-.076a.189.189 0 0 1 0-.082l.75-5.631-2.627-5.391s-1.545-2.102-.227-4.01h.012v.003h.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_558",
    fill: "#686868",
    d: "M197.553 175.559h156.064l-.227-20.508a278.65 278.65 0 0 0-155.837 20.508Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_559",
    fill: "#CCC",
    d: "M358.414 366.664H197.141v52.262h161.271v-52.262h.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_560",
    fill: "#CFCFE2",
    d: "M353.264 175.634H197.216v191.481h156.05V175.634h-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_561",
    fill: "#686868",
    d: "M246.055 263.26c0-.218.127-.398.293-.398.164 0 .291.182.291.398 0 .216-.135.391-.3.391-.165 0-.284-.18-.284-.391Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_562",
    fill: "#CCC",
    d: "M252.262 248.523h-11.83c-.652 0-1.18.429-1.18.953v13.106c0 .524.525.953 1.18.953h11.83c.646 0 1.172-.429 1.172-.953v-13.106c0-.524-.526-.953-1.172-.953Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_563",
    fill: "#F3EEEC",
    d: "M251.744 249.177h-10.811c-.594 0-1.072.392-1.072.871v11.966c0 .479.479.877 1.072.877h10.811c.586 0 1.074-.396 1.074-.877v-11.966c0-.479-.488-.871-1.082-.871h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_564",
    fill: "#686868",
    d: "M246.055 250.543c0-.172.127-.314.293-.314.164 0 .291.144.291.314 0 .18-.135.323-.3.323-.165 0-.284-.143-.284-.323Zm2.364.451c.075-.15.263-.21.397-.12.066.052.119.12.144.203a.426.426 0 0 1-.022.233.261.261 0 0 1-.061.09.272.272 0 0 1-.105.06.305.305 0 0 1-.238-.03.387.387 0 0 1-.149-.203.34.34 0 0 1 .037-.225l-.003-.008Zm2.072 1.764a.294.294 0 0 1 .225-.037c.046 0 .075.021.113.045.028.029.052.053.067.09a.341.341 0 0 1 .037.226.392.392 0 0 1-.129.218.299.299 0 0 1-.338-.015.264.264 0 0 1-.074-.075.335.335 0 0 1-.037-.24.374.374 0 0 1 .136-.212Zm.968 2.732c.15 0 .293.135.293.314a.31.31 0 0 1-.3.314c-.158 0-.293-.137-.293-.314 0-.179.135-.314.3-.314Zm-.729 3.701a.311.311 0 0 0 .301-.315c0-.181-.135-.323-.301-.323-.164 0-.293.15-.293.323 0 .173.135.315.301.315h-.008Zm-1.628 1.479a.356.356 0 0 1 0 .452.24.24 0 0 1-.09.066.303.303 0 0 1-.24 0 .262.262 0 0 1-.09-.076.345.345 0 0 1-.082-.225c0-.076.028-.15.073-.226a.23.23 0 0 1 .099-.067.303.303 0 0 1 .24 0 .312.312 0 0 1 .09.076Zm-4.842-9.669c-.074-.149-.256-.226-.398-.127a.35.35 0 0 0-.148.203.36.36 0 0 0 .038.233.174.174 0 0 0 .054.09.306.306 0 0 0 .346.029.347.347 0 0 0 .143-.195.331.331 0 0 0-.035-.233Zm-2.028 1.757a.299.299 0 0 0-.343.008.234.234 0 0 0-.068.09.426.426 0 0 0-.045.226c.022.09.068.157.129.218.074.045.15.061.232.045.045-.007.074-.029.112-.053a.195.195 0 0 0 .067-.09.338.338 0 0 0 .037-.227.398.398 0 0 0-.129-.226l.008.009Zm-1.005 2.732a.304.304 0 0 0-.299.314c0 .178.135.314.299.314.166 0 .293-.137.293-.314a.303.303 0 0 0-.301-.314h.008Zm.712 3.701a.312.312 0 0 0 .302-.315c0-.181-.136-.323-.302-.323-.156 0-.291.15-.291.323 0 .173.135.315.299.315h-.008Zm1.646 1.479a.338.338 0 0 0-.09.225.34.34 0 0 0 .09.227.211.211 0 0 0 .09.066.315.315 0 0 0 .226 0 .275.275 0 0 0 .1-.076.322.322 0 0 0 .074-.225.359.359 0 0 0-.074-.226.214.214 0 0 0-.091-.067.303.303 0 0 0-.24 0 .21.21 0 0 0-.085.076Zm3.009-8.865h-.074v4h.074v-4Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_565",
    fill: "#686868",
    d: "M246.257 255.805c0-.18.136-.313.302-.313.164 0 .293.135.293.313 0 .18-.129.323-.302.323-.165 0-.293-.135-.293-.323Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_566",
    fill: "#686868",
    d: "m246.594 255.902-.15-.209 1.953-1.668.144.211-1.951 1.666h.004Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_567",
    fill: "#CCC",
    d: "M299.51 299.615h-1.861c-.193 0-.354-.219-.354-.488 0-.264.165-.488.354-.488h1.869c.203 0 .359.225.359.488 0 .269-.164.488-.367.488Zm12.941 0h-1.854c-.195 0-.361-.219-.361-.488 0-.264.166-.488.361-.488h1.854c.201 0 .367.225.367.488-.029.27-.166.488-.375.488h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_568",
    fill: "#F3EEEC",
    d: "M299.111 295.538h12.107v12.417c0 .977-.787 1.771-1.766 1.771h-8.563a1.767 1.767 0 0 1-1.771-1.766v-12.424l-.007.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_569",
    fill: "#CCC",
    d: "M311.295 296.034h-12.229c-.127 0-.225-.136-.225-.3 0-.166.098-.293.225-.293h12.213c.121 0 .227.127.227.3-.016.18-.121.3-.227.3l.016-.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_570",
    fill: "#F3EEEC",
    d: "M298.34 202.035v32.879h-14.361v-32.609c12.543-.27 0 0 14.354-.27h.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_571",
    fill: "#CCC",
    d: "M301.49 234.914h-20.68v7.896h20.68v-7.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_572",
    fill: "#F3EEEC",
    d: "m271.87 257.066 9.413-14.256h20.682l8.482 14.264h-38.586l.009-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kitchen-light",
    className: "kitchen-light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_573",
    fill: "#FCF3A6",
    d: "M270.009 309.972 275.523 260h29.904L309 310h-39l.009-.028Z",
    className: "Vector",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_574",
    fill: "#CCC",
    d: "M314.154 257.066H269.16v4.016h44.994v-4.016Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_575",
    fill: "#F3EEEC",
    d: "M315.844 311.294H229.18V368h86.664v-56.706Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_576",
    fill: "#CCC",
    d: "M229.404 311.294h86.627c.578 0 1.051.474 1.051 1.052v.812a1.05 1.05 0 0 1-1.051 1.051h-86.702v-2.836c0-.047.038-.079.075-.079Zm41.948 28.655h-38.465v-22.678h38.465v22.678Zm-38.021-.594h37.578v-21.492h-37.578v21.492Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_577",
    fill: "#7792E0",
    d: "M271.352 365.164h-38.465v-22.672h38.465v22.672Zm-38.021-.586h37.578v-21.492h-37.578v21.492Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_578",
    fill: "#CCC",
    d: "M312.467 339.949h-38.473v-22.678h38.465v22.678h.008Zm-38.024-.594h37.604v-21.492h-37.609v21.492h.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_579",
    fill: "#7792E0",
    d: "M312.467 365.164h-38.473v-22.672h38.465v22.672h.008Zm-38.024-.586h37.604v-21.492h-37.609v21.492h.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_580",
    fill: "#CCC",
    d: "M254.928 321.361h-5.615c-.256 0-.467-.277-.467-.615a.548.548 0 0 1 .467-.6h5.621a.537.537 0 0 1 .45.6c0 .338-.202.615-.45.615h-.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_581",
    fill: "#7792E0",
    d: "M254.928 346.201h-5.615c-.256 0-.467-.277-.467-.615 0-.338.211-.615.467-.615h5.621c.24 0 .45.277.45.615 0 .338-.202.615-.45.615h-.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_582",
    fill: "#CCC",
    d: "M296.387 321.361h-5.623c-.256 0-.451-.277-.451-.615 0-.338.203-.6.451-.6h5.631a.537.537 0 0 1 .449.6c0 .338-.203.615-.449.615h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_583",
    fill: "#7792E0",
    d: "M296.387 346.201h-5.623c-.256 0-.451-.277-.451-.615 0-.338.203-.615.451-.615h5.631c.246 0 .449.277.449.615 0 .338-.203.615-.449.615h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_584",
    fill: "#F3EEEC",
    d: "M356.703 229.584h-38.135v137.38h38.135v-137.38Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_585",
    fill: "#CCC",
    d: "M329.58 302.227v-.772c0-.57-.457-1.035-1.033-1.035h-6.787c-.57 0-1.035.465-1.035 1.035v.772a1.04 1.04 0 0 0 1.035 1.037h6.787c.576 0 1.033-.468 1.033-1.037Zm12.416-60.354h-8.736a1.327 1.327 0 0 0-1.336 1.32v5.593c0 .735.602 1.329 1.328 1.329h8.744a1.34 1.34 0 0 0 1.338-1.329v-5.593c0-.735-.602-1.328-1.338-1.328v.008Zm14.707 64.242h-38.135v.646h38.135v-.646Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_586",
    fill: "#F3EEEC",
    d: "M244.876 285.667h-10.733c-.524 0-.97.578-.97 1.299v23.075c0 .752.437 1.307.976 1.307h10.735c.525 0 .96-.586.96-1.307v-23.075c0-.691-.428-1.299-.968-1.299Zm-3.108 2.252h-4.504c-.248 0-.451-.278-.451-.601 0-.338.195-.603.451-.603h4.504c.24 0 .45.265.45.603 0 .322-.202.631-.45.631v-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_587",
    fill: "#686868",
    d: "M250.018 291.432h-8.332c-.406 0-.752.45-.752 1.014v17.889c0 .563.346 1.016.752 1.016h8.332c.412 0 .75-.451.75-1.016v-17.889c0-.555-.338-1.014-.75-1.014Zm-2.424 1.772h-3.498c-.188 0-.346-.21-.346-.465s.157-.474.346-.474h3.498c.194 0 .354.211.354.474a.417.417 0 0 1-.354.465Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_588",
    fill: "#F3EEEC",
    d: "M268.665 285.502H251.55v2.553h17.115v-2.553Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_589",
    fill: "#CCC",
    d: "M267.299 301.109v-3.252a.816.816 0 0 0-.136-.45l-.271-.45a1.63 1.63 0 0 0-1.353-.826 1.646 1.646 0 0 0-1.366.887l-.238.397a.768.768 0 0 0-.105.428v3.267c0 .322.195.584.436.584h2.598c.232-.001.434-.262.435-.585Zm-2.403-.317c0 .135-.076.248-.188.248-.104 0-.188-.113-.188-.248v-2.821c0-.136.084-.248.188-.248.112 0 .188.112.188.248v2.821Zm.848 0c0 .135-.075.248-.188.248-.104 0-.188-.113-.188-.248v-2.821c0-.136.083-.248.188-.248.11 0 .188.112.188.248v2.821Zm.849 0c0 .135-.075.248-.188.248-.104 0-.188-.113-.188-.248v-2.821c0-.136.082-.248.188-.248.113 0 .188.112.188.248v2.821Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_590",
    fill: "#CCC",
    d: "M265.744 286.508h-.487v10.059h.487v-10.059Zm-4.353 13.167v-1.291a3.24 3.24 0 0 0-.285-1.375v-.045c-.256-.524-.623-.825-1.015-.825-.397 0-.751.322-1.028.877a3.445 3.445 0 0 0-.263 1.328v1.33c0 1.125.511 2.025 1.134 2.025h.31c.643-.006 1.147-.907 1.147-2.024Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_591",
    fill: "#CCC",
    d: "M260.287 286.508h-.495v10.059h.495v-10.059Zm-3.965 12.717v-1.275a2.561 2.561 0 0 0-.375-1.366v-.038a1.584 1.584 0 0 0-1.299-.826 1.6 1.6 0 0 0-1.352.879 2.573 2.573 0 0 0-.331 1.313v1.313c0 1.104.653 2.004 1.502 2.004h.442c.754 0 1.413-.901 1.413-2.004Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_592",
    fill: "#CCC",
    d: "M254.822 286.508h-.495v10.059h.495v-10.059Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_593",
    fill: "#B8D0FC",
    d: "M254.574 286.777h-.016a.09.09 0 0 0-.091.091v.42c0 .052.046.09.091.09h.016a.087.087 0 0 0 .091-.09v-.42a.091.091 0 0 0-.091-.091Zm5.473 0h-.021a.092.092 0 0 0-.084.091v.42c0 .052.039.09.084.09h.021c.045 0 .09-.038.09-.09v-.42a.091.091 0 0 0-.09-.091Zm5.457 0h-.016a.091.091 0 0 0-.09.091v.42c0 .052.045.09.09.09h.016a.088.088 0 0 0 .092-.09v-.42a.094.094 0 0 0-.092-.091Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_594",
    fill: "#F3EEEC",
    d: "M229.284 272.545h-32.278v95.335h32.278v-95.335Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "oven",
    className: "oven"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_595",
    fill: "#E0E18C",
    d: "M226 277h-26v18h26v-18Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_596",
    fill: "#CCC",
    d: "M226.282 277.049h-7.507v18.016h7.507v-18.016Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_597",
    fill: "#fff",
    d: "M222.348 287.716c.57 0 1.021-.616 1.021-1.374 0-.758-.45-1.374-1.014-1.374-.564 0-1.021.616-1.021 1.374 0 .758.45 1.374 1.021 1.374h-.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_598",
    fill: "#686868",
    d: "M225.109 278.048h-5.568v3.453h5.568v-3.453Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_599",
    fill: "#fff",
    d: "M221.268 290.073h-1.074v1.434h1.074v-1.434Zm1.726 0h-1.073v1.434h1.073v-1.434Zm1.703 0h-1.073v1.434h1.073v-1.434Zm0 2.409h-1.073v1.435h1.073v-1.435Zm0 2.411h-1.073v1.436h1.073v-1.436Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_600",
    fill: "#CCC",
    d: "M226.282 295.064h-26.273v-18.768h26.273v18.768Zm-25.485-1.125h24.696v-16.492h-24.696v16.492Zm25.485 11.635h-26.273v30.027h26.273v-30.027Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_601",
    fill: "#F3EEEC",
    d: "M226.318 309.328h-23.346c-.396 0-.714.488-.714 1.09v.824c0 .602.315 1.09.714 1.09h23.346c.392 0 .714-.488.714-1.09v-.824c0-.602-.322-1.09-.714-1.09Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_602",
    fill: "#CCC",
    d: "M226.282 304.074h-26.273v4.504h26.273v-4.504Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_603",
    fill: "#F3EEEC",
    d: "M224.779 313.832h-22.521v19.518h22.521v-19.518Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_604",
    fill: "#7792E0",
    d: "M213.288 346.546h-5.638c-.248 0-.45-.271-.45-.603 0-.338.194-.606.45-.606h5.629c.248 0 .451.271.451.603-.03.338-.195.606-.451.606h.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_605",
    fill: "#fff",
    d: "M210.338 306.912c0-.602.359-1.098.825-1.098.45 0 .817.486.817 1.098 0 .607-.375 1.104-.824 1.104-.451 0-.826-.496-.826-1.104h.008Zm3.04 0c0-.602.36-1.098.817-1.098.451 0 .826.486.826 1.098 0 .607-.375 1.104-.826 1.104-.465 0-.825-.496-.825-1.104h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_606",
    fill: "#686868",
    d: "M224.111 305.732h-6.402v2.355h6.402v-2.355Zm90.698 4.032h-29.143v1.53h29.143v-1.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_607",
    fill: "#2A3967",
    d: "M307.15 259.386a.36.36 0 0 1 .053-.323.37.37 0 0 1 .301-.148c.113 0 .227.061.301.148.061.09.082.211.053.323 0 .263-.158.474-.354.474-.196 0-.354-.212-.354-.474Zm1.653 0a.375.375 0 0 1 .645-.324c.076.09.09.211.064.322 0 .264-.158.475-.355.475-.196 0-.354-.211-.354-.473Zm1.65 0a.42.42 0 0 1-.014-.165.374.374 0 0 1 .367-.301.373.373 0 0 1 .342.467c0 .262-.146.473-.352.473-.202-.001-.343-.212-.343-.474Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_608",
    fill: "#2F80ED",
    d: "M242.616 289.525a21.498 21.498 0 0 1 10.585-2.711c1.23.045 5.576 1.246 6.253 2.08 1.876 2.313 3.642 39.598 3.642 39.598s-10.436 3.949-20.472-1.336v-37.623l-.008-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_609",
    fill: "#28130F",
    d: "M253.973 289.391a7.558 7.558 0 0 1-5.037-.871.957.957 0 0 1-.39-1.142c.466-1.312.784-2.671.953-4.054v-.165c.037-.36.037-.728 0-1.097h4.144s1.127.578 1.127.977v.615c0 .533 0 1 .062 1.396.021.639.09 1.276.21 1.915-.002.001.546 2.073-1.069 2.426Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_610",
    fill: "#3F1E19",
    d: "M248.471 281.307c.563 3.377 4.459 3.258 6.147 3.047.474-.06.751-.127.751-.127.541-.149.826-1.097.977-2.328a21.533 21.533 0 0 0-.451-6.928c-.547-1.382-1.59-2.867-5.518-1.795-3.925 1.073-2.626 3.804-1.906 8.131Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_611",
    fill: "#000",
    d: "M256.068 273.093a9.353 9.353 0 0 0-2.711-2.47c-2.252-1.344-5.061.038-5.073.045-3.206 1.577-4.039 4.316-2.343 8.58 1.802 4.504 3.514 4.001 3.514 4.001s-.368-.248-.33-1.651v-.211a.966.966 0 0 0-.271-.75c-.396-.398-.592-1.599-.263-1.937.33-.339.976.09 1.147.465a.467.467 0 0 0 .707.173c.998-.706.353-2.102 1.306-3.003.953-.894 2.883-.144 4.315-.826 1.877-.766.429-1.801 0-2.424v.008h.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_612",
    fill: "#fff",
    d: "M253.764 282.064c.359.33.857.465 1.336.358.487-.098.75-.812.75-.812a3.395 3.395 0 0 0-2.086.454Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_613",
    fill: "#F9924F",
    d: "M277.673 340.833c-.045.899-.008 1.81.12 2.711.495 4.451 2.124 11.56 2.124 11.56l2.026.278c-.149-1.262.285-6.082.849-11.409.849-8.05 2.013-17.267 2.013-17.267s-4.43-4.093-7.041-2.959c-2.614 1.135.216 13.971-.091 17.086Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_614",
    fill: "#DCEAFF",
    d: "M277.793 343.544c.495 4.451 2.124 11.56 2.124 11.56l2.026.278c-.149-1.262.285-6.082.849-11.409a8.018 8.018 0 0 1-4.339-.265 1.837 1.837 0 0 0-.66-.164Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_615",
    fill: "#FFAE73",
    d: "M273.971 340.376a18.442 18.442 0 0 0 0 3.563c.346 4.504 1.449 11.035 1.449 11.035l2.02.51c-.082-1.237.578-5.914 1.404-11.139 1.29-8.132 3.002-17.604 3.002-17.604s-4.203-4.386-6.861-3.438c-2.665.948-.533 13.95-1.014 17.073Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_616",
    fill: "#D36E46",
    d: "m281.613 304.718-3.858 2.562-.976-3.002a10.48 10.48 0 0 0 .578-2.868 13.61 13.61 0 0 0-.063-2.552l3.35 1.629s-.054.345-.082.841a6.54 6.54 0 0 0 .172 1.938c.121.567.437 1.077.879 1.452Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_617",
    fill: "#9DDEDA",
    d: "M272.381 337.531c1.043 1.125 8.773 3.43 13.137 1.771.75-.301-1.313-26.827-2.058-32.022-.202-1.426-.375-2.903-1.657-3.1l-.699-.093a1.23 1.23 0 0 1-1.139 1.458c-1.327.301-2.582-.645-3.229-1.291a5.112 5.112 0 0 0-2.408 1.096c-.797.64-.322 10.758-.322 10.758.104.826.104 1.65 0 2.479a326.32 326.32 0 0 0-1.23 13.139 76.925 76.925 0 0 0-.395 5.805Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_618",
    fill: "#fff",
    d: "M273.994 343.912c.354 4.504 1.456 11.035 1.456 11.035l2.021.51c-.082-1.238.577-5.916 1.403-11.141a11.505 11.505 0 0 1-4.88-.404Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_619",
    fill: "#2A3967",
    d: "M234.284 347.77a2.448 2.448 0 0 0 1.854.916 2.635 2.635 0 0 1 1.86.685.751.751 0 0 1-.276 1.271l-5.479 1.44a.826.826 0 0 1-.998-.752 32.7 32.7 0 0 0-.188-1.418 2.89 2.89 0 0 1 .496-1.815l2.739-.324h-.008v-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_620",
    fill: "#2D3554",
    d: "M286.74 341.005v-.877l-.367-.062-.061.313a1.17 1.17 0 0 1-.137-.144c-1.162-1.35-4.594-1.764-7.033-1.381a23.638 23.638 0 0 0-3.963.924l-1.32.082v.66a.371.371 0 0 0 0 .233v.054l.074.082c.271.172.604.228.916.149l.33-.054c1.62-.228 3.094.045 3.159.375.065.33-.751.632-1.922.697a1.928 1.928 0 0 0-.231-.39h-1.976v.75c0 .065.028.135.065.194a.606.606 0 0 0 .203.173c1.276.676 3.754.896 5.697.916 2.521 0 5.9-.548 6.328-2.125.045-.181.173-.449.195-.623l.043.054Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_621",
    fill: "#2D3554",
    d: "M280.18 342.958c-1.975 0-4.43-.24-5.705-.916a.664.664 0 0 1-.195-.174.325.325 0 0 1-.036-.339c.073-.135.284-.225.659-.2 1.996.119 3.662-.256 3.566-.752-.076-.367-1.894-.652-3.709-.322a.881.881 0 0 1-.887-.226.374.374 0 0 1 0-.42l.045-.039c1.036-.704 3.243-1.2 5.157-1.5 2.438-.383 5.87 0 7.034 1.382.18.209.525.519.563.676-.037.24-.104.479-.195.705-.396 1.576-3.773 2.146-6.306 2.125h.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_622",
    fill: "#FF912B",
    d: "M282.973 342.628c-.947.172-1.908.246-2.869.231h-.733c-.677 0-1.366-.075-2.026-.149h-.082l-.685-.112h-.157a6.665 6.665 0 0 1-1.777-.556.56.56 0 0 1-.203-.181.294.294 0 0 1 0-.315c.066-.127.271-.209.631-.194 1.922.112 3.521-.24 3.424-.75-.075-.354-1.803-.623-3.559-.302a.847.847 0 0 1-.851-.217.357.357 0 0 1-.045-.149.32.32 0 0 1 .045-.149.452.452 0 0 1 .203-.22 6.698 6.698 0 0 1 1.329-.575c-.15.073-.303.172-.443.27-.23.173-.338.33-.3.466.017.06.05.11.099.149.358.172.75.256 1.147.226h.854s-1.593.084-1.945-.209c-.352-.293.753-.896.753-.9l.614-.182h.054a26.087 26.087 0 0 1 1.829-.396l.863-.139a11.987 11.987 0 0 1 3.004-.072h.045a8.344 8.344 0 0 1 2.17.504h.054l.503.227h.061l.166.104c.457.244.803.668.953 1.17.125.479-.021.988-.385 1.328-.047.051-.097.1-.148.143h-.037c-.12.094-.24.176-.375.258a7.495 7.495 0 0 1-2.181.691Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_623",
    fill: "#EEE",
    d: "M274.242 341.531c.045-.143.391-.291.803-.262 1.914.127 3.408-.203 3.305-.691-.076-.344-1.733-.629-3.482-.314-.398.074-.881 0-1.021-.285l.172.074a.91.91 0 0 0 .603.137c.376 0 3.827-.615 4.104.354.277.969-2.363.879-2.867.85a4.483 4.483 0 0 0-1.612.148v-.009l-.005-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_624",
    fill: "#FFC89B",
    d: "M285.622 341.494c.194-.277-.045-.75-.631-.916-.412-.127-4.017 0-4.017 0l-.037-.148s3.394-.188 3.926-.572c.375-.262.189-.816.181-.822.459.244.802.664.953 1.16.12.471-.029.968-.375 1.298Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_625",
    fill: "#fff",
    d: "M279.85 340.068c.555 0 1.051.158 1.117.412.067.256-.33.496-.886.523-.556.031-1.06-.146-1.126-.412-.053-.254.348-.493.895-.523Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_626",
    fill: "#EEE",
    d: "M279.88 340.173c.429 0 .812.127.863.322.045.194-.271.383-.69.405-.429.021-.812-.121-.863-.323-.04-.201.262-.374.69-.404Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_627",
    fill: "#25468F",
    d: "M276.84 304.096a11.314 11.314 0 0 1 1.439 4.394l-.531.059s-.676-3.166-1.382-4.202l.474-.257v.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_628",
    fill: "#EEE",
    d: "m266.322 324.846-.075.036s-.12 0-.21.24c0 .065-.112.33-.225.637l-.047.113c-.24.606-.602 1.328-.953 1.142-.353-.188-.149-.894.076-1.373l.065-.149.149-.285c.148-.242.26-.506.33-.781v-.073a.449.449 0 0 1 0 .276.756.756 0 0 1-.09.231c-.557.899-.752 1.804-.488 1.959.149.091.52-.299.805-.944l.164-.42.046-.144a.45.45 0 0 1 0-.09v-.039a.513.513 0 0 1 .239-.3h.209v-.036h.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_629",
    fill: "#A0A0C1",
    d: "M353.145 324.395H197.006v42.787h156.139v-42.787Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grocery-bag",
    className: "grocery-bag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_630",
    fill: "#FFB600",
    d: "M337.658 324.537c.578 2.02.742 4.129.496 6.207a1.254 1.254 0 0 1-.488.887c-.119.09-.256.15-.404.188-.33 0-.977-.676-1.354-1.502a4.472 4.472 0 0 1-.225-.75c-.375-1.975-1.066-4.354-1.922-5.555a13.468 13.468 0 0 0-3.67-3.754l-3.828-3.1c-.377-.428.064-.916.064-.916.438.383.908.729 1.41 1.029 1.066.674 2.932-.121 2.932-.121a1.647 1.647 0 0 1 1.674.113 13.61 13.61 0 0 1 2.852 2.609 13.184 13.184 0 0 1 2.463 4.665Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_631",
    fill: "#FF9F00",
    d: "M335.639 329.566c-.367-1.977-1.051-4.354-1.914-5.555a13.476 13.476 0 0 0-3.678-3.756 1.01 1.01 0 0 1 .098-1.748c1.193-.805 6.004 5.156 5.734 11.785a4.091 4.091 0 0 1-.24-.726Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_632",
    fill: "#9BD399",
    d: "M340.092 321.841a5.082 5.082 0 0 0 4.436 2.351 5.816 5.816 0 0 0 1.063-1.733 3.087 3.087 0 0 0 0-2.401 1.688 1.688 0 0 0-.961-.804c-.598-.203-1.201-.099-1.467-.392a2.509 2.509 0 0 0-1.045-.688l-.199-.062h-.074a1.674 1.674 0 0 0-1.771.623 2.108 2.108 0 0 0-.293.524 2.972 2.972 0 0 0 .311 2.582Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_633",
    fill: "#86C484",
    d: "M340.061 318.734a2.253 2.253 0 0 0-.293.533c-.301.75-.713 2.748-.219 3.615l.67.678c.84.924 2.604.668 4.309.652a5.79 5.79 0 0 0 1.061-1.732 3.808 3.808 0 0 1-4.094-1.006 5.014 5.014 0 0 1-1.434-2.74Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_634",
    fill: "#9BD399",
    d: "M343.281 317.744c.338-.232.689.098 1.096.27.389.123.795.184 1.201.18a5.88 5.88 0 0 0-.855-1.033c-.525-.52-1.449.586-1.449.586l.007-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_635",
    fill: "#73B471",
    d: "M343.281 317.744a1.355 1.355 0 0 1 1.215-.338c.375.232.736.502 1.074.787a5.82 5.82 0 0 0-.848-1.035c-.525-.518-1.449.586-1.449.586h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_636",
    fill: "#86C484",
    d: "M343.16 318.884a2.526 2.526 0 0 0-1.043-.69c.697.302 1.08 1.277 1.352 1.164a3.988 3.988 0 0 1 1.156-.073c-.594-.228-1.201-.108-1.465-.401Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_637",
    fill: "#73B471",
    d: "M343.408 319.333a2.642 2.642 0 0 0 0-1.703 11.612 11.612 0 0 0-.428-1.133.054.054 0 0 0-.053-.054c-.018 0-.023 0-.037.015-.012.011-.02.022-.018.039l-.045.144a.635.635 0 0 0 .045.437c.393.623.551 1.356.449 2.086-.055.087.05.268.087.169Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_638",
    fill: "#9BD399",
    d: "M337.148 317.789v.059-.059c.09-.316.539-1.869.945-3.596.563-2.396 1.051-5.127.402-5.383-1.199-.48-1.426 3.348-1.426 6.17.019 1.389.079 2.577.079 2.809Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_639",
    fill: "#9BD399",
    d: "m335.969 314.682 1.027 2.536c.1.24.166.404.189.486 0-.136-.076-.494-.158-1.007-.127-.75-.301-1.891-.496-3.1-.473-2.943-1.051-6.455-1.186-6.943-.24-.887-1.328-2.771-2.064-1.133-.478 1.066 1.375 5.895 2.688 9.161Zm-.088 1.545c.449.532.832.961 1.051 1.2l.18.203-.322-.75a38.782 38.782 0 0 0-.752-1.601c-.98-2.012-2.455-4.603-3.354-4.45-1.029.211 1.553 3.461 3.197 5.403v-.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_640",
    fill: "#73B471",
    d: "M337.148 317.789c.09-.316.539-1.869.945-3.596a1.462 1.462 0 0 1-1.029.787c.024 1.389.077 2.577.084 2.809Zm-1.179-3.107 1.027 2.536a2.823 2.823 0 0 0 0-.52c-.127-.75-.301-1.892-.494-3.101a1.665 1.665 0 0 1-.525 1.082h-.008v.003Zm-.088 1.545c.449.532.824.961 1.051 1.2a4.018 4.018 0 0 0-.145-.51 43.98 43.98 0 0 0-.75-1.601c.008.31-.045.618-.156.911Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_641",
    fill: "#FC7600",
    d: "M336.576 321.602a138.716 138.716 0 0 0 1.705 5.017l2.141-.716s-.248-1.776-.615-3.752c-.428-2.305-.676-4.625-1.555-5.256a1.529 1.529 0 0 0-.75-.263 1.47 1.47 0 0 0-.375 0h-.1l-.217.062h-.076a1.685 1.685 0 0 0-1.02.99c-.398 1.095.3 2.125.862 3.918Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_642",
    fill: "#25468F",
    d: "M338.828 321.813h.076a2.59 2.59 0 0 0-1.914-1.226l-.053.076a.062.062 0 0 0-.016.028v.054l.016.016a2.738 2.738 0 0 1 1.891 1.052Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_643",
    fill: "#5C9CF4",
    d: "M340.129 321.962c-.346-.978-.842-.752-1.457-.496-.615.265-1.104.496-.75 1.502a1.16 1.16 0 0 0 1.56.75 1.428 1.428 0 0 0 .646-1.764v.008h.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_644",
    fill: "#FFEBD8",
    d: "m331.143 322.6-1.877 15.015a3 3 0 0 0 2.733 3.519h2.855a2.604 2.604 0 0 0 2.412-2.784c-.006-.072-.016-.146-.025-.22l-1.592-13.946-4.506-1.584Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_645",
    fill: "#FFEBD8",
    d: "M341.053 322.6a16.173 16.173 0 0 1-9.91 0l1.576 18.571h9.945l-1.611-18.571Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_646",
    fill: "#F4C9A5",
    d: "m341.053 322.6-1.893 15.015a3 3 0 0 0 2.746 3.528h2.838a2.608 2.608 0 0 0 2.43-2.771c-.006-.078-.016-.154-.025-.231l-1.359-15.539c-.75.112-1.502.166-2.252.149a17.15 17.15 0 0 1-2.477-.149h-.008v-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_647",
    fill: "#FC7600",
    d: "M332.592 324.273c0-.193.156-.354.354-.354.195 0 .355.148.355.348v.006a.427.427 0 0 1-.174.346 3.917 3.917 0 0 0 .676 3.078 2.398 2.398 0 0 0 2.355.652c.877-.156 1.5-1.252 1.805-2.141.191-.532.344-1.08.457-1.637a.44.44 0 0 1-.131-.303c0-.207.168-.375.375-.375.215 0 .379.166.379.375a.405.405 0 0 1-.184.348c-.195.979-.893 3.865-2.604 4.174a4.165 4.165 0 0 1-.75.076 2.529 2.529 0 0 1-1.996-.852 4.376 4.376 0 0 1-.752-3.438.386.386 0 0 1-.165-.303Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_648",
    fill: "#D36E46",
    d: "M272.088 315.505c.27-2.438.698-4.854 1.275-7.235l1.457 1.353c-.33 1.815-.488 4.315-1.098 6.065-.601 1.748-1.658 1.229-1.637-.188l.003.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_649",
    fill: "#FCDD5B",
    d: "M231.986 300.809a5.098 5.098 0 0 0-2.566-1.39 4.87 4.87 0 0 0-1.299 0l2.854 8.422c0 .022.014.046.029.068.045.062.127.073.193.028l3.326-1.802a.157.157 0 0 0 .076-.09.134.134 0 0 0 0-.104c-.533-1.259-1.974-4.42-2.613-5.132Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_650",
    fill: "#FCDD5B",
    d: "M230.65 299.839s-3.754-1.764-6.629-1.291c-2.867.474-4.504.925-5.254 1.688-.752.766 1.109 17.617.75 19.683a52.92 52.92 0 0 0-.457 5.722h13.405s-.751-4.865-.391-6.613c.348-1.751-.215-18.663-1.424-19.189Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_651",
    fill: "#F29A7E",
    d: "m226.777 300.125-.653.375a2.44 2.44 0 0 1-3.543-1.711c.39-.945.642-1.941.751-2.958.12-.886.148-1.779.082-2.672l3.416 1.952a7.712 7.712 0 0 0 0 3.152c.053.231.135.457.247.676a.898.898 0 0 1 .075.651.894.894 0 0 1-.375.535Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_652",
    fill: "#2A3967",
    d: "m235.335 319.289-2.785 2.426a.51.51 0 0 0-.149.541l.211.652c.029.15.144.262.285.301a.399.399 0 0 0 .412-.09c.75-.691 2.059-1.967 2.379-2.328.451-.502.623-1.148.174-1.502a.417.417 0 0 0-.527 0Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_653",
    fill: "#FCAA90",
    d: "M227.73 296.837s-3.873 1.142-5.211-2.297c-1.439-3.708.145-6.411 1.457-6.599 2.619-.36 4.145.75 4.607 1.937.47 1.186 1.278 6.329-.853 6.959Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_654",
    fill: "#28130F",
    d: "M223.212 295.718a8.772 8.772 0 0 1-.397-2.252s-1.014-1.44-.42-1.801c.592-.347.899.503 1.043.337.137-.165.347-3.002 1.051-2.904.722.098 3.363 1.006 4.506-.113 1.154-1.127-1.652-5.479-6.411-3.799-4.77 1.682-3.786 7.575.628 10.532Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_655",
    fill: "#28130F",
    d: "M220.238 287.482a2.17 2.17 0 0 1 0-1.237c0 .36.091.713.264 1.028.262.316-.264.209-.264.209Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_656",
    fill: "#28130F",
    d: "M220.337 286.98a.892.892 0 0 0-.862.428.672.672 0 0 1 .824 0l.038-.428Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_657",
    fill: "#fff",
    d: "M228.15 294.262c0-.218-.166-.09-1.976.437-.524.149 1.744 1.5 1.976-.437Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_658",
    fill: "#F29A7E",
    d: "M216.764 314.568a97.198 97.198 0 0 1 1.147-11.729l2.507 1.969c-.314 2.941-.264 6.967-.998 9.834-.729 2.869-2.507 2.199-2.656-.074Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_659",
    fill: "#F29A7E",
    d: "M217.161 315.973c-.503-.984-.45-1.412.315-1.968.885-.639 1.975-.075 4.219 4.099 1.125 2.103 2.14 4.438 2.574 5.256.217.714-.062.75-.314.899-.616.449-.946.302-1.036.173-2.116-3.168-4.355-5.705-5.758-8.459Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_660",
    fill: "#F29A7E",
    d: "M224.503 324.447a1.697 1.697 0 0 1-.578-1.254 1.375 1.375 0 0 1 1.353.854l.795 1.895-.301.098a1.55 1.55 0 0 1-.375-.391 3.22 3.22 0 0 0-.899-1.201h.005v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_661",
    fill: "#F29A7E",
    d: "M224.855 324.891c.403 1.598-.053 3.241-.52 3.315-.449.076-1.374-1.793-1.605-3.258-.232-1.464.301-1.98.75-2.05.451-.065 1.006.541 1.375 1.981v.012Zm8.784-14.761c-.978-1.875-.978-1.875-1.728-3.377l-.263-4.978c1.133 2.162 3.002 4.896 3.851 7.199.849 2.303-.713 2.647-1.854 1.153l-.006.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_662",
    fill: "#F29A7E",
    d: "M233.594 309.906c.172-.9.428-1.148 1.2-1.125.901 0 1.329.945.69 4.803-.322 1.945-.84 3.986-.99 4.76-.227.57-.405.438-.66.428-.623 0-.751-.285-.751-.412.218-3.161.045-5.946.511-8.454Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_663",
    fill: "#F29A7E",
    d: "M235.02 319.507c.524 1.435.301 3.002-.076 3.078-.383.074-1.381-1.502-1.739-2.821-.36-1.322.045-1.832.428-1.938.373-.105.914.406 1.387 1.681Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_664",
    fill: "#FFD400",
    d: "M217.416 301.814a5.025 5.025 0 0 1 1.975-2.146c.09-.045 1.217-.518 1.231-.414v8.896c0 .021 0 .053-.017.074a.164.164 0 0 1-.099.09.114.114 0 0 1-.073 0l-3.754-.629a.151.151 0 0 1-.099-.055.162.162 0 0 1-.03-.111c.15-1.367.479-4.82.856-5.705h.01Zm14.563-1.005a7.1 7.1 0 0 0-1.088-.826l.969 7.61 2.693-1.463a.153.153 0 0 0 .075-.082.141.141 0 0 0-.007-.112c-.557-1.254-1.997-4.414-2.635-5.127h-.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_665",
    fill: "#28130F",
    d: "M241.25 312.248c-.751-5.531-.751-14.637-.684-17.73l4.158 2.439c.121 4.451 1.027 10.457.52 14.895-.512 4.435-3.305 3.752-3.994.396Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_666",
    fill: "#28130F",
    d: "M242.121 314.275c-.953-1.373-.953-2.027.074-3.002 1.193-1.145 2.929-.521 7.132 5.254 2.125 2.904 4.12 6.191 4.932 7.379.474 1.014.054 1.088-.284 1.412-.826.75-1.352.637-1.502.465-3.836-4.346-7.68-7.695-10.358-11.508h.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_667",
    fill: "#28130F",
    d: "M254.822 325.43a2.562 2.562 0 0 1-1.127-1.748 2.07 2.07 0 0 1 2.207 1.006l1.568 2.664s.047.228-.061.271c-.112.053-.375-.066-.375-.066a2.236 2.236 0 0 1-.623-.504 4.901 4.901 0 0 0-1.589-1.623Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_668",
    fill: "#28130F",
    d: "M255.438 326.016c.938 2.327.586 4.864-.082 5.065-.676.203-2.418-2.388-3.078-4.504-.646-2.115.062-3.002.75-3.22.705-.219 1.568.576 2.402 2.647l.008.012Zm12.656-20.974a129.36 129.36 0 0 0-7.341-14.36l-2.215 3.752c1.884 3.588 3.828 8.752 6.208 12.049 2.38 3.304 4.302 1.538 3.348-1.441Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_669",
    fill: "#28130F",
    d: "M268.229 306.934c0-1.502-.33-2.013-1.604-2.216-1.502-.239-2.463 1.128-2.636 7.619-.092 3.267.104 6.756.104 8.063.175 1.006.525.842.938.908 1.021.166 1.353-.219 1.375-.43.637-5.222 1.793-9.711 1.823-13.944Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_670",
    fill: "#28130F",
    d: "M265.061 320.859a2.284 2.284 0 0 0-.053-1.895 1.88 1.88 0 0 0-1.134 1.895l.203 2.807s0 .113.226.113c.225 0 .194-.18.194-.18.104-.229.181-.459.211-.707a4.546 4.546 0 0 1 .36-2.025l-.007-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_671",
    fill: "#2B73D3",
    d: "m246.46 301.83-7.417-.932a.28.28 0 0 1-.075-.021.22.22 0 0 1-.104-.219c.166-2.004.67-7.079 1.226-8.37a7.431 7.431 0 0 1 2.896-3.153 11.17 11.17 0 0 1 3.498-1.292l-.024 13.987Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_672",
    fill: "#2F80ED",
    d: "m260.25 303.646 5.697-5.008a.221.221 0 0 0 .111-.277c-.75-1.877-2.611-6.621-3.507-7.709a7.357 7.357 0 0 0-3.653-2.252 11.04 11.04 0 0 0-3.717-.271l2.326 7.77 2.743 7.747Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_673",
    fill: "#2B73D3",
    d: "m261.443 302.572 4.504-3.934a.221.221 0 0 0 .111-.277c-.75-1.885-2.611-6.621-3.507-7.709a7.357 7.357 0 0 0-3.653-2.252 13.061 13.061 0 0 0-1.403-.248 42.366 42.366 0 0 1 2.417 6.643 72.943 72.943 0 0 1 1.531 7.777Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_674",
    fill: "#D36E46",
    d: "M284.549 315.648a58.252 58.252 0 0 1-1.111-7.25l1.824.803c.256 1.824.901 4.248.901 6.096 0 1.846-1.142 1.703-1.614.351Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_675",
    fill: "#D36E46",
    d: "M284.624 315.986c-.256-.646-.194-.908.3-1.201.512-.299 1.239.061 2.395 2.777.586 1.375 1.082 2.883 1.301 3.438.098.449-.082.449-.247.539-.406.238-.606.129-.653.047-1.137-2.102-2.376-3.813-3.096-5.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_676",
    fill: "#D36E46",
    d: "M288.594 320.904c-.3.061-.601 0-.841-.18a.854.854 0 0 1 .931-.354l1.246.307-.074.189a.953.953 0 0 1-.321.036 1.996 1.996 0 0 0-.941.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_677",
    fill: "#55C4B9",
    d: "m283.023 310.852 2.688-.494a.103.103 0 0 0 .075-.121c-.149-1.356-.42-2.7-.804-4.022a3.578 3.578 0 0 0-1.502-1.455 7.431 7.431 0 0 0-1.996-.67l1.537 6.759v.004h.002v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_678",
    fill: "#25468F",
    d: "m277.748 308.546 4.984-.53a11.055 11.055 0 0 1 1.261 4.202l1.778 12.281H273.07l.75-9.896c0 .001 4.28-1.628 3.928-6.057Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_679",
    fill: "#FF912B",
    d: "M278.213 309.471c0-.037 0-.074.016-.111a.301.301 0 0 1 .265-.194.32.32 0 0 1 .354.271.534.534 0 0 1 0 .08.318.318 0 0 1-.635-.046Zm3.573-.285a.323.323 0 0 1 .149-.397.267.267 0 0 1 .354.142l.015.032a.352.352 0 0 1-.01.231c-.029.074-.074.144-.148.173a.274.274 0 0 1-.31-.074.387.387 0 0 1-.05-.107Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_680",
    fill: "#855B47",
    d: "M279.654 293.631a2.7 2.7 0 0 1 2.252 0c1.201.578 2.078 3.003 1.539 5.314-.541 2.313 1.275 2.326.441 4.158-.301.651-4.265 1.201-4.398-1.328-.074-1.569 1.201-1.651.826-3.354-.382-1.704-.66-4.79-.66-4.79Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_681",
    fill: "#855B47",
    d: "M282.236 294.33a6.373 6.373 0 0 0-3.963-2.958c-2.072-.397-4.019 1.239-4.332 3.565-.314 2.326 0 5.353 3.416 6.439l4.879-7.046Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_682",
    fill: "#E57A47",
    d: "M281.561 302.018s-3.619 1.353-5.082-1.832c-1.576-3.432-.211-6.11 1.028-6.375 2.478-.518 3.979.438 4.505 1.502.517 1.066 1.545 5.983-.451 6.705Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_683",
    fill: "#855B47",
    d: "M279.016 294.188s.346 3.797-2.883 5.144c-1.275.532-1.951-5.255.751-6.418 2.694-1.164 5.322.217 5.63 2.252.309 2.034.075 2.438.075 2.438s-1.261-3.853-3.573-3.416Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_684",
    fill: "#855B47",
    d: "M275.021 293.669a2.4 2.4 0 0 0-2.252 0c-1.207.646-2.086 3.401-1.555 6.006.549 2.604-1.275 2.619-.438 4.685.303.75 4.266 1.358 4.4-1.502.074-1.771-1.188-1.854-.826-3.754.379-1.899.671-5.435.671-5.435Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_685",
    fill: "#fff",
    d: "M281.936 299.555c0-.218-.172-.091-1.975.437-.525.149 1.743 1.5 1.975-.437Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_686",
    fill: "#D36E46",
    d: "M274.145 314.042a10.766 10.766 0 0 1-.524 1.922c-.228.404-.55-1.637-.55-1.637l1.082-.285h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_687",
    fill: "#FFCD38",
    d: "M309.951 279.016s-.082-3.002 3.498-3.625c3.58-.623 4.572.346 5.18 1.353.602 1.021 1.75 5.192 1.637 6.838-.111 1.649-4.203 3.708-4.129 4.677.066.973-6.186-9.243-6.186-9.243Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_688",
    fill: "#fff",
    d: "M323.455 323.703c-.75.586-2.783.902-5.111 1-4.182.172-9.383-.383-10.404-1.465a2.162 2.162 0 0 1-.436-1.328c-.111-1.787.652-4.73 1.172-7.162.33-1.584.555-2.949.367-3.648-.563-2.123-1.65-5.832-1.809-7.258-.158-1.428.705-9.669 2.807-10.615 2.104-.944 10.225 0 10.225 0 3.168.752 3.303 8.258 2.252 14.697 0 .166-.059.324-.082.48-1.141 6.523 3.189 13.678 1.019 15.299Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_689",
    fill: "#FFCD38",
    d: "M316.902 276.914s-.232-1.614 1.779-2.034c2.01-.42 2.041 4.347 2.252 5.495.209 1.148-.322 1.839-1.09 1.906-.765.06-2.941-5.367-2.941-5.367Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_690",
    fill: "#D36E46",
    d: "M288.932 320.859c.969.396 1.614 1.238 1.502 1.5-.099.264-1.404 0-2.252-.404-.834-.406-.871-.895-.75-1.148.134-.257.652-.272 1.5.052Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_691",
    fill: "#F29A7E",
    d: "M311.438 293.902c.061.412 1.072 1.08 3.234.449 2.178-.646 2.336-1.373 2.336-1.869 0-.494-.902-1.39-.895-5.028l-.256.067-4.188.916s.098 1.5.098 2.858c.008 1.15-.419 1.9-.329 2.607Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_692",
    fill: "#FFAE73",
    d: "M310.889 289.734s5.555.104 5.555-3.752c.008-3.858.752-6.457-2.822-6.683-3.57-.225-4.23 1.246-4.504 2.537-.27 1.294.329 7.771 1.771 7.898Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_693",
    fill: "#FFCD38",
    d: "M311.107 279.211s1.5 4.504 3.85 5.193c2.352.691 3.35 0 3.35 0a7.542 7.542 0 0 1-2.162-4.36s-3.905-2.987-5.038-.833Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_694",
    fill: "#FFCD38",
    d: "M311.475 279.579a5.362 5.362 0 0 0-1.412 1.989c-.277.976-.395 3.002-.93 2.94 0 0-1.143-3.077.143-4.817 1.277-1.741 2.199-.112 2.199-.112Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_695",
    fill: "#25468F",
    d: "M317.555 292.514a16.516 16.516 0 0 0-2.252 6.516h-.75s.945-4.43 2.445-6.567l.557.051Zm-6.012.375s-1.502 3.37-1.396 6.148h-.652s.184-3.633 1.576-6.081l.477-.06v-.008h-.005v.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_696",
    fill: "#F29A7E",
    d: "M304.441 310.199c.449-4.43 1.17-8.813 2.162-13.145l2.688 2.426c-.586 3.295-.826 7.852-1.885 11.033-1.051 3.199-2.972 2.276-2.965-.314Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_697",
    fill: "#F29A7E",
    d: "M304.268 310.814c.631-1.088 1.074-1.299 2.072-.916 1.156.451 1.275 1.832-1.299 6.531-1.299 2.379-2.896 4.787-3.453 5.703-.525.66-.75.398-1.051.271-.789-.307-.855-.713-.797-.877 1.742-3.993 2.78-7.678 4.528-10.712Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_698",
    fill: "#EB5757",
    d: "M309.492 299.037h5.826s1.943 8.145 5.705 8.678l2.326 10.283s1.164 4.287 1.127 6.568h-17.633s.27-3.752.822-7.957c.57-4.219-.447-11.59-.447-11.59a15.956 15.956 0 0 1 2.274-5.982Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_699",
    fill: "#FF912B",
    d: "M309.455 300.096a.326.326 0 0 1 .271-.369.323.323 0 0 1 .367.371.34.34 0 0 1-.074.254.36.36 0 0 1-.105.084.327.327 0 0 1-.383-.076.33.33 0 0 1-.076-.264Zm4.58 0a.319.319 0 0 1 .074-.265.294.294 0 0 1 .375-.074c.131.06.207.195.189.339a.338.338 0 0 1-.189.338.327.327 0 0 1-.428-.149.333.333 0 0 1-.021-.189Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_700",
    fill: "#F29A7E",
    d: "M324.133 313.201c0-4.607-.271-9.209-.826-13.781l-3.004 2.207c.24 3.453 0 8.174.752 11.574.75 3.401 2.814 2.666 3.078 0Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_701",
    fill: "#F29A7E",
    d: "M323.635 315.109c.525-1.188.443-1.689-.48-2.291-1.08-.697-2.326 0-4.713 5.045-1.201 2.529-2.252 5.33-2.703 6.352-.225.84.113.84.42 1.051.752.48 1.127.293 1.227.135 2.297-3.881 4.76-6.979 6.254-10.283v-.008h-.005v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_702",
    fill: "#fff",
    d: "M324.822 299.27c0-1.246 0-4.414-2.891-5.758a20.843 20.843 0 0 0-4.377-1.051l-2.025 5.354 2.025 4.293c.826.805 6.074-.639 7.271-2.838h-.003Zm-15.33-.233a21.488 21.488 0 0 1 1.219-6.005s-1.504.075-3.395 2.483a13.442 13.442 0 0 0-2.305 5.938 2.531 2.531 0 0 0 2.619 1.75 303.212 303.212 0 0 0 1.859-4.174v.008h.003Zm3.041-11.357a1.504 1.504 0 0 1-1.352.359c-.488-.098-.75-.811-.75-.811a3.376 3.376 0 0 1 2.102.452Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_703",
    fill: "#F29A7E",
    d: "M300.928 323.238a1.91 1.91 0 0 1 .322-1.502c.557.377.811 1.051.646 1.705l-.57 2.252-.338-.113a1.816 1.816 0 0 1-.076-.6 3.798 3.798 0 0 0 .016-1.742Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kitchen-food",
    className: "kitchen-food"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_704",
    fill: "#FDDBBA",
    d: "M268.752 335.59h-28.931l3.489-11.559h21.771l3.671 11.559Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_705",
    fill: "#DDB79E",
    d: "M268.758 335.59h-28.931v.813h28.931v-.813Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_706",
    fill: "#2D3554",
    d: "M263.353 327.392a4.87 4.87 0 0 1-1.906 2.748h-.51c-.228 0-.285.136-.496.136-7.506.098-11.434-3.003-11.434-3.003v-1.178s6.217-2.711 11.307-2.86a14.567 14.567 0 0 1 2.326 0s-.451.284-.42.293l.547.104h.062a.803.803 0 0 1-.09.226c-.556.899-.751 1.803-.488 1.967.149.09.519-.301.804-.944l.166-.42.045-.15a.282.282 0 0 1 0-.082v-.039a.492.492 0 0 1 .239-.307h.292a.437.437 0 0 1 .12.149 9.582 9.582 0 0 1-.563 3.354v.006h-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_707",
    fill: "#2F3E69",
    d: "M249.008 327.265s-3.926 2.297-4.361 1.666c-.435-.631 1.563-1.922 1.563-2.469 0-.55-.978-2.351 0-2.191.978.156 2.83 1.824 2.83 1.824l-.032 1.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_708",
    fill: "#FF912B",
    d: "M263.122 324.916c-.12.219-.211.436-.218.436.066-.15.135-.301.218-.451.12-.201.263-.412.375-.428.3-.059.271.752.271.752 0 .127-.037.254-.061.391-.074.359-.156.75-.264 1.098l-.149.492a5.486 5.486 0 0 1-.75 1.504 3.645 3.645 0 0 1-.796.861l-.248.15-.09.037a.957.957 0 0 1-.841-.053 1.253 1.253 0 0 1-.578-.75c0-.037 0-.082-.037-.135a4.428 4.428 0 0 1 .173-1.639 7.554 7.554 0 0 1 .602-1.502c.061-.104.111-.227.181-.32.065-.105 0 0 0-.037a8.91 8.91 0 0 1 .593-.947v-.037l.227-.301.054-.066c.135-.158.284-.309.45-.451.082-.074.18-.135.285-.188a.219.219 0 0 1 .143 0 .263.263 0 0 1 .165.127.277.277 0 0 1 0 .166.837.837 0 0 1-.082.203c-.541.908-.751 1.877-.496 2.033.149.098.524-.322.817-.977l.166-.428.045-.145v-.129a.546.546 0 0 1 .082-.15.287.287 0 0 1 .091-.082.305.305 0 0 1 .12-.027.246.246 0 0 1 .164.127.47.47 0 0 1 .062.193c.015.311 0 .615-.045.926v-.348c0-.193-.083-.313-.165-.357a.12.12 0 0 0-.098 0c-.092 0-.203.119-.338.357l-.028.095Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_709",
    fill: "#FFC89B",
    d: "M259.969 329.074a.375.375 0 0 0 .623.095 21.47 21.47 0 0 0 1.027-1.996l.09.053a9.078 9.078 0 0 0-.705 2.253c.047.206.188.38.383.466a.945.945 0 0 1-.841-.055c-.3-.18-.511-.473-.577-.822v.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_710",
    fill: "#fff",
    d: "M262.153 326.838c-.128.285-.347.451-.495.367-.15-.09-.165-.391-.038-.676.128-.285.347-.457.487-.375.144.074.174.391.046.676v.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_711",
    fill: "#EEE",
    d: "M262.094 326.801c-.099.225-.271.352-.385.285-.111-.076-.127-.301 0-.525.128-.225.264-.346.376-.285.112.061.067.299 0 .525h.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_712",
    fill: "#2F3E69",
    d: "M258.4 329.879s-1.441 1.178-1.916.818c-.473-.361-.441-.707-.75-.707-.307 0-.487-.602-.487-.602 1.036.256 2.087.422 3.153.491Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_713",
    fill: "#fff",
    d: "M239.303 339.494c0 3.754-4.067 6.859-9.084 6.859-5.029 0-9.082-3.105-9.082-6.859v-.24c0-.074 0-.314.037-.473.473-1.666 4.338-3.002 9.008-3.002 4.67 0 8.564 1.313 9.008 3.002 0 .158 0 .307.045.473.047.172.076.143.076.24h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_714",
    fill: "#A8CFFF",
    d: "M239.303 339.103v.121c-.067.683-.689 1.313-1.705 1.83-.688.332-1.41.578-2.152.752a19.012 19.012 0 0 1-3.424.541l-.646.045h-1.155c-.563 0-1.117 0-1.65-.062h-.45a13.843 13.843 0 0 1-5.713-1.547 2.346 2.346 0 0 1-1.269-1.584v-.119c0-.12.014-.239.053-.346.029-.136.082-.257.148-.375a4.159 4.159 0 0 1 1.989-1.449c.915-.375 1.86-.646 2.837-.812a19.28 19.28 0 0 1 2.252-.285l.895-.053h1.065c.606 0 1.2 0 1.778.073.602.054 1.188.121 1.74.212 2.906.473 5.017 1.502 5.354 2.702.038.117.053.238.053.356Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_715",
    fill: "#73B471",
    d: "M231.376 342.422h-1.155c-.563 0-1.119 0-1.66-.061a48.526 48.526 0 0 0-4.602-3.178c-.75-.238-.684-.51-.18-1.178.383-.523-.105-.533-.45-1.098a1.872 1.872 0 0 1-.256-.65c-.255-1.264 1.239-.572 2.252-.826h.104c.842-.285-.127-1.072 1.576-.961.422 0 .907.568 1.41 1.373.441.699.826 1.436 1.171 2.189.443.939.856 1.945 1.201 2.848.259.573.432 1.09.589 1.542Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_716",
    fill: "#9BD399",
    d: "M230.783 342.437h-.563c-.563 0-1.119 0-1.651-.061h-.45a57.743 57.743 0 0 0-5.953-2.154c-.751 0-.751-.301-.441-1.096.209-.48-.039-.505-.383-.753a1.603 1.603 0 0 1-.677-.75c-.519-1.155 1.073-.885 2.013-1.411.938-.525-.324-1.052 1.41-1.41.346-.076.826.181 1.352.646.271.228.52.451.75.698a49.595 49.595 0 0 1 4.593 6.291Zm4.661-.601a19.752 19.752 0 0 1-3.423.549 66.223 66.223 0 0 0-1.226-1.502 12.842 12.842 0 0 0-1.409-1.555c-.641-.449-.541-.697.098-1.199a.692.692 0 0 0 .104-.092c.406-.428-.428-.602-.375-1.801 0-.15.038-.303.105-.451.188-.293.601-.172 1.064 0 .391.166.797.271 1.2.33.368 0 .488-.104.586-.246.165-.279.165-.631 1.271-.229.195.092.359.24.473.438.676 1.006 1.201 3.521 1.531 5.766l.001-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_717",
    fill: "#fff",
    d: "M218.209 337.16c0 2.754-2.949 4.982-6.605 4.982-3.641 0-6.604-2.252-6.604-4.982v-.525c.347-1.217 3.151-2.17 6.576-2.17 3.423 0 6.224.953 6.567 2.178v.336l.074.182h-.008v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_718",
    fill: "#A8CFFF",
    d: "M218.209 336.928v.09c-.045.494-.494.953-1.23 1.328h-.037c-.479.24-.977.42-1.502.549-.816.209-1.649.344-2.49.396h-1.309c-.412 0-.816 0-1.201-.037h-.33a11.474 11.474 0 0 1-3.398-.75 4.828 4.828 0 0 1-.751-.375 1.652 1.652 0 0 1-.923-1.15c-.014-.209.041-.42.148-.6.36-.494.863-.865 1.44-1.066a9.708 9.708 0 0 1 2.063-.592 14.658 14.658 0 0 1 1.652-.211h1.396c.442 0 .87 0 1.29.053.443 0 .863.09 1.27.158 2.104.344 3.641 1.08 3.889 1.959.017.074.031.164.031.248h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_719",
    fill: "#FF912B",
    d: "M216.932 338.33a7.63 7.63 0 0 1-1.5.541c-.812.211-1.645.346-2.483.396h-1.308c-.414 0-.817 0-1.209-.035h-.33a11.459 11.459 0 0 1-3.399-.754 4.03 4.03 0 0 1 2.162-.568c1.501.09 2.198-.885 3.229-.475 1.027.412 2.02.881 2.521.66a4.243 4.243 0 0 1 2.325.227l-.008.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_720",
    fill: "#BFDCFF",
    d: "m253.055 332.498.998.473.842-.24.869 5.301.67 2.447.264 7.002h-4.432l-2.094-9.449 2.883-5.534Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_721",
    fill: "#fff",
    d: "M245.758 332.274s-.961 5.62-.871 6.342c.09.722.594.752.496 1.593-.098.842-1.502 2.079-1.688 2.905a27.682 27.682 0 0 0 0 4.367h8.588s.165-3.837.354-4.578c.182-.75-.578-4.377-.396-5.037.18-.66.795-5.366.795-5.366l-7.281-.226h.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_722",
    fill: "#DDB79E",
    d: "M282.391 350.282c7.117 0 12.875-2.649 12.875-5.922 0-3.273-5.758-5.925-12.867-5.925-7.107 0-12.865 2.65-12.865 5.931 0 3.267 5.758 5.916 12.865 5.916h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_723",
    fill: "#FDDBBA",
    d: "M282.391 348.855c7.117 0 12.875-2.454 12.875-5.487 0-3.032-5.758-5.485-12.867-5.485-7.107 0-12.865 2.453-12.865 5.479 0 3.041 5.758 5.496 12.865 5.496l-.008-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_724",
    fill: "#2D3554",
    d: "m293.553 344.291-.037-.879-.367-.061-.061.314a2.334 2.334 0 0 1-.136-.15c-1.163-1.354-4.579-1.748-7.033-1.373a23.641 23.641 0 0 0-3.964.926l-1.32.072v.668a.382.382 0 0 0 0 .227v.061l.074.074c.143.092.285.15.45.182.149.021.315.014.474-.023l.322-.053c1.621-.225 3.094.045 3.16.375.074.332-.751.631-1.922.699a1.736 1.736 0 0 0-.225-.398h-1.998v.789a.354.354 0 0 0 .076.195.477.477 0 0 0 .193.172c1.273.676 3.753.895 5.705.916 2.515 0 5.895-.549 6.326-2.125.047-.18.175-.449.195-.623l.088.015Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_725",
    fill: "#2D3554",
    d: "M286.993 346.242c-1.976 0-4.422-.24-5.698-.916a.664.664 0 0 1-.201-.172.325.325 0 0 1-.039-.338c.076-.137.287-.227.662-.203 1.996.121 3.662-.254 3.564-.75-.075-.375-1.893-.652-3.7-.322a.905.905 0 0 1-.894-.218.373.373 0 0 1 0-.428l.045-.037c1.035-.705 3.242-1.201 5.156-1.502 2.446-.383 5.871 0 7.032 1.381.183.211.525.521.563.676a2.98 2.98 0 0 1-.194.707c-.397 1.576-3.773 2.145-6.296 2.122Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_726",
    fill: "#FF912B",
    d: "M289.785 345.905c-.945.174-1.898.248-2.859.231h-.736a20.288 20.288 0 0 1-2.019-.156h-.091l-.684-.104h-.157a6.23 6.23 0 0 1-1.771-.555.526.526 0 0 1-.211-.183.29.29 0 0 1 0-.313c.074-.127.27-.211.631-.194 1.922.112 3.527-.24 3.424-.75-.067-.354-1.803-.623-3.561-.31a.819.819 0 0 1-.848-.211.293.293 0 0 1 0-.3.443.443 0 0 1 .21-.219c.421-.24.864-.435 1.329-.578-.15.076-.303.174-.451.271-.227.172-.33.33-.301.465a.311.311 0 0 0 .105.15c.359.172.752.248 1.148.225h.854s-1.592.076-1.943-.211c-.354-.299.75-.893.75-.898l.615-.182h.055a26.471 26.471 0 0 1 1.83-.396l.855-.145a11.79 11.79 0 0 1 3.002-.064h.053c.736.074 1.474.24 2.17.494h.055c.182.076.345.148.503.232l.062.037.164.1c.459.248.805.676.953 1.17.129.479-.021.99-.384 1.33l-.147.143c-.119.094-.246.18-.377.256a7.619 7.619 0 0 1-2.228.665Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_727",
    fill: "#EEE",
    d: "M281.062 344.817c.045-.149.391-.302.804-.265 1.914.129 3.407-.201 3.303-.688-.075-.347-1.733-.64-3.483-.315-.396.075-.877 0-1.021-.291l.173.073c.18.121.391.166.607.144.367 0 3.82-.614 4.099.354.278.968-2.364.877-2.866.849a4.574 4.574 0 0 0-1.616.139Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_728",
    fill: "#FFC89B",
    d: "M292.473 344.78c.194-.271-.045-.752-.631-.916-.412-.127-4.017 0-4.017 0v-.149s3.394-.188 3.935-.57c.375-.264.188-.825.18-.834.457.248.805.677.953 1.173.105.469-.053.973-.42 1.296Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_729",
    fill: "#fff",
    d: "M286.67 343.353c.549 0 1.051.148 1.111.412.061.256-.33.496-.887.524-.555.029-1.06-.157-1.117-.411-.061-.257.337-.496.886-.525h.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_730",
    fill: "#EEE",
    d: "M286.691 343.465c.429 0 .812.121.863.316.053.193-.264.383-.689.402-.428.021-.811-.117-.855-.32-.043-.203.254-.374.681-.398Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_731",
    fill: "#2D3554",
    d: "M283.758 339.584v-.879l-.369-.061-.06.314a1.681 1.681 0 0 1-.136-.145c-1.163-1.352-4.594-1.764-7.033-1.381a23.92 23.92 0 0 0-3.964.924l-1.321.074v.668a.375.375 0 0 0 0 .225v.063l.075.076c.276.18.601.23.923.148l.331-.047c1.621-.225 3.093.047 3.151.377.076.33-.75.629-1.914.697a1.869 1.869 0 0 0-.239-.398h-1.976v.752a.378.378 0 0 0 .076.195.477.477 0 0 0 .193.172c1.275.676 3.754.895 5.705.916 2.516 0 5.895-.549 6.32-2.125.053-.18.173-.449.201-.623l.037.058Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_732",
    fill: "#FF912B",
    d: "M279.989 341.205c-.946.166-1.907.248-2.867.23h-.735c-.668 0-1.352-.072-2.021-.154h-.082l-.685-.105h-.156a6.687 6.687 0 0 1-1.779-.555.555.555 0 0 1-.21-.184.303.303 0 0 1 0-.313c.075-.127.271-.211.638-.195 1.922.113 3.514-.24 3.424-.75-.074-.354-1.81-.623-3.559-.309a.827.827 0 0 1-.85-.211.301.301 0 0 1 0-.299.455.455 0 0 1 .203-.229 6.479 6.479 0 0 1 1.33-.57c-.15.076-.301.166-.451.271-.225.162-.33.32-.301.465a.328.328 0 0 0 .104.148c.359.172.751.248 1.148.227h.854s-1.592.074-1.952-.211c-.345-.301.752-.9.752-.9l.623-.18h.053a25.585 25.585 0 0 1 1.83-.396l.863-.145a12.265 12.265 0 0 1 3.004-.074h.045c.735.074 1.471.24 2.17.502h.053c.181.076.346.15.504.234h.06l.165.096c.458.248.805.678.953 1.174a1.33 1.33 0 0 1-.383 1.326l-.148.145h-.037a2.965 2.965 0 0 1-.375.256 7.035 7.035 0 0 1-2.185.706Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_733",
    fill: "#FFC89B",
    d: "M282.639 340.073c.194-.276-.045-.75-.631-.916-.412-.127-4.017 0-4.017 0l-.037-.149s3.394-.188 3.935-.57c.375-.262.188-.825.18-.834.457.248.805.671.953 1.173.119.462-.03.965-.383 1.296Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_734",
    fill: "#fff",
    d: "M276.866 338.646c.556 0 1.06.15 1.118.412.061.256-.33.496-.885.524-.558.031-1.061-.157-1.119-.411-.059-.255.338-.495.886-.525Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_735",
    fill: "#EEE",
    d: "M276.896 338.752c.428 0 .811.127.863.322.051.193-.265.375-.69.402-.429.023-.812-.117-.856-.32-.044-.203.256-.374.683-.404Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_736",
    fill: "#FDDBBA",
    d: "M317.703 334.855h-28.932l3.481-12.114h21.776l3.662 12.114h.013Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_737",
    fill: "#DDB79E",
    d: "M317.711 334.855h-28.939v.849h28.934v-.849h.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_738",
    fill: "#FF9F00",
    d: "M294.732 329.924a3.317 3.317 0 0 1 4.301-.932 2.654 2.654 0 0 1 .847 4.039 3.342 3.342 0 0 1-4.504.75 2.577 2.577 0 0 1-.644-3.852v-.005Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_739",
    fill: "#FFD895",
    d: "M294.867 329.976a3.154 3.154 0 0 1 4.931-.182 2.53 2.53 0 0 1-.045 3.122 3.183 3.183 0 0 1-4.268.753 2.45 2.45 0 0 1-.864-3.353 2.72 2.72 0 0 1 .246-.34Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_740",
    fill: "#FFB600",
    d: "m296.947 331.349-1.953-.301a.218.218 0 0 1-.082-.037.234.234 0 0 1-.066-.067.2.2 0 0 1 0-.181c.234-.446.547-.849.924-1.187a.225.225 0 0 1 .271.054l1 1.567c.014.008.027.028.033.053a.084.084 0 0 1-.064.104l-.063-.005Zm.27-.194-.977-1.556a.205.205 0 0 1-.021-.188.225.225 0 0 1 .148-.127 5.034 5.034 0 0 1 1.531-.203c.082.047.127.15.098.248l-.631 1.803a.114.114 0 0 1-.029.029.064.064 0 0 1-.045.018h-.045a.057.057 0 0 1-.029-.024Zm-.172.509-1.563 1.201a.22.22 0 0 1-.316-.018c-.004-.002-.004-.004-.006-.006l-.021-.037a2.326 2.326 0 0 1-.24-.578 3.94 3.94 0 0 1-.135-.689c0-.105.066-.195.164-.227a.205.205 0 0 1 .098-.016l1.982.225.045.023c.01.01.02.021.021.035a.093.093 0 0 1 0 .047l-.029.04Zm.586.023 1.592 1.021a.203.203 0 0 1 .074.164c0 .037 0 .076-.016.1a4.819 4.819 0 0 1-1.32.795.156.156 0 0 1-.1.021.215.215 0 0 1-.201-.18l-.174-1.848a.061.061 0 0 1 0-.053.087.087 0 0 1 .09-.045c.024.002.039.017.055.025Zm-.301.136-.105 1.823a.24.24 0 0 1-.262.218c-.014 0-.025-.004-.039-.006a4.006 4.006 0 0 1-1.291-.525.21.21 0 0 1-.066-.067.225.225 0 0 1 0-.18.304.304 0 0 1 .066-.076l1.568-1.254c.037-.022.088-.015.113.022l.016.045Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_741",
    fill: "#FF9F00",
    d: "M297.375 329.803a3.327 3.327 0 0 1 4.309-.924 2.655 2.655 0 0 1 .847 4.039 3.345 3.345 0 0 1-5.299-.007 2.573 2.573 0 0 1 .148-3.105l-.005-.003Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_742",
    fill: "#FFD895",
    d: "M297.517 329.885a3.153 3.153 0 0 1 4.928-.18 2.48 2.48 0 0 1-.045 3.131 3.168 3.168 0 0 1-4.256.705 2.429 2.429 0 0 1-.627-3.656Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_743",
    fill: "#FFB600",
    d: "m300.219 331.064.752-1.741a.245.245 0 0 1 .344-.119c.398.229.748.531 1.029.894a.21.21 0 0 1-.059.291.112.112 0 0 1-.047.022l-1.885.752c-.097.015-.164-.032-.134-.099Zm-.623.158-1.938-.293a.206.206 0 0 1-.18-.194c0-.035.008-.067.021-.099.223-.453.531-.856.916-1.187a.248.248 0 0 1 .193 0l.074.06.998 1.576c.023.008.031.022.039.045l-.008.067-.055.037c-.014 0-.053 0-.074-.015l.014.003Zm.271-.189-.977-1.545a.214.214 0 0 1-.023-.188.233.233 0 0 1 .15-.121 4.49 4.49 0 0 1 1.428-.226.192.192 0 0 1 .09.017.2.2 0 0 1 .104.24l-.629 1.801c0 .017-.018.021-.023.028-.021.019-.055.022-.082.017a.063.063 0 0 1-.038-.023Zm-.174.512-1.561 1.215a.229.229 0 0 1-.189.047.256.256 0 0 1-.158-.113 3.36 3.36 0 0 1-.375-1.277l.023-.09a.228.228 0 0 1 .24-.143l1.986.227c.018.002.027.014.037.021.023.016.037.053.023.076l-.026.037Zm.705-.241 1.9-.614a.207.207 0 0 1 .098-.017.237.237 0 0 1 .164.098l.039.099c.014.211.014.42 0 .64a6 6 0 0 1-.158.696.238.238 0 0 1-.135.136.253.253 0 0 1-.195-.009l-1.734-.854a.11.11 0 0 1-.061-.036.085.085 0 0 1-.014-.062c0-.021.014-.045.025-.06a.088.088 0 0 1 .071-.017Zm-.111.27 1.576 1.014a.211.211 0 0 1 .074.264 3.947 3.947 0 0 1-1.313.811.216.216 0 0 1-.285-.113c-.006-.018-.014-.033-.018-.053l-.188-1.854.008-.045a.087.087 0 0 1 .039-.037.068.068 0 0 1 .051-.016c.025 0 .04.015.056.029Zm-.338.129-.098 1.838a.25.25 0 0 1-.293.211 4.08 4.08 0 0 1-1.299-.533.195.195 0 0 1-.082-.166c0-.029 0-.059.016-.09a.248.248 0 0 1 .066-.074l1.563-1.246a.075.075 0 0 1 .074-.008c.03.009.051.037.053.068Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_744",
    fill: "#FDDBBA",
    d: "M235.264 331.769h-22.279l2.695-8.896h16.771l2.813 8.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_745",
    fill: "#DDB79E",
    d: "M235.279 331.769h-22.295v.623h22.295v-.623Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_746",
    fill: "#9BD399",
    d: "M226.008 324.562s-5.143-1.223-5.758-.885c-.615.338-.074.705-.676.885-.585.183-1.109.378-1.014.753.113.375-.33.284-.354.75-.022.465.981.51 2.063.225 1.072-.284 5.254-.313 6.006-.555.753-.241.724-1.125-.267-1.173Zm2.056 1.104s1.63-1.635 2.252-1.455c.623.18 1.688 1.17 1.63 1.455-.059.285-4.076.467-3.882 0Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_747",
    fill: "#fff",
    d: "M216.392 330.922c-.707-.285-1.651-1.381-1.396-2.178.256-.795 1.605-.977 2.313-.689.74.338 1.1 1.186.826 1.951a1.322 1.322 0 0 1-1.604.959c-.049-.012-.094-.028-.139-.043Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_748",
    fill: "#FF912B",
    d: "M216.557 330.239a.879.879 0 0 1-.457-1.088.757.757 0 0 1 .668-.558c.099 0 .203 0 .302.039a.882.882 0 0 1 .465 1.088.75.75 0 0 1-.913.541h-.002l-.063-.022Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_749",
    fill: "#fff",
    d: "M218.705 330.217c-.496-.623-.855-2.096-.301-2.658.554-.563 1.832 0 2.326.631a1.63 1.63 0 0 1-.098 2.146 1.27 1.27 0 0 1-1.927-.119Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_750",
    fill: "#FF912B",
    d: "M219.133 329.737a.915.915 0 0 1 .059-1.201.709.709 0 0 1 1.074.065.939.939 0 0 1-.061 1.201.724.724 0 0 1-.557.226.695.695 0 0 1-.524-.291h.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_751",
    fill: "#73B471",
    d: "M225.04 328.73s-2.042.091-2.483 1.23c0 0-.084.262.239.301.322.037 1.3-1.321 2.253-1.449v-.082h-.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_752",
    fill: "#73B471",
    d: "M225.04 328.67s-1.11-1.127-1.974-.752c-.856.377.601.422 1.027.504.33.074.646.18.952.322v-.074h-.005Zm-.023.233s-1.021.383-.85 1.006c.171.623.85-1.006.85-1.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_753",
    fill: "#FF912B",
    d: "M233.146 330.17a.376.376 0 0 1-.338.377h-7.14a1.095 1.095 0 0 1-.751-1.238l.045-.43a1.068 1.068 0 0 1 1.081-1.057l6.914 1.928a.368.368 0 0 1 .189.42Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_754",
    fill: "#E8F2FA",
    d: "M289.814 323.136c0 3.205-3.452 5.812-7.693 5.812-4.249 0-7.693-2.604-7.693-5.812v-.209a2.63 2.63 0 0 1 0-.397c.396-1.42 3.67-2.528 7.648-2.528 3.978 0 7.251 1.108 7.656 2.528v.397l.074.209h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_755",
    fill: "#A8CFFF",
    d: "M289.814 322.83v.098c-.053.578-.577 1.109-1.44 1.545a14.591 14.591 0 0 1-6.245 1.18c-2.814 0-5.255-.557-6.613-1.381a1.998 1.998 0 0 1-1.074-1.344v-.098c0-.105.018-.203.047-.301.396-1.42 3.671-2.529 7.648-2.529 3.979 0 7.252 1.109 7.656 2.529.014.098.021.204.021.301Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_756",
    fill: "#FFD895",
    d: "M288.314 324.472a14.6 14.6 0 0 1-6.246 1.181c-2.814 0-5.256-.558-6.613-1.382.021 0 6.583-3.439 12.859.201Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_757",
    fill: "#FF9F00",
    d: "M302.885 325.457a4.247 4.247 0 0 1 3.002-4.121c1.764-.541 3.229.75 3.229 2.717a4.263 4.263 0 0 1-3.289 4.121c-1.749.248-2.929-.782-2.942-2.717Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_758",
    fill: "#FF9F00",
    d: "M310.615 325.164a8.097 8.097 0 0 1-.275 1.125c-.855 2.486-2.613 1.953-4.34 1.953-1.943 0-1.938-1.457-1.938-3.424 0-1.969 1.082-3.521 3.002-3.521 1.939 0 3.896 1.938 3.545 3.863h.006v.004Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_759",
    fill: "#FFD895",
    d: "M303.035 325.42a4.058 4.058 0 0 1 2.867-3.928c1.682-.51 3.078.752 3.07 2.584a4.03 4.03 0 0 1-3.123 3.9c-1.652.248-2.801-.729-2.809-2.564l-.005.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_760",
    fill: "#FFB600",
    d: "m306.037 324.301-.48-2.02a.305.305 0 0 1 .203-.359c.225-.053.459-.092.699-.105.246-.008.494.014.75.053.135 0 .188.188.104.338l-1.104 2.096c-.074.071-.156.071-.172-.003Zm-.42.615-1.803 1.262a.19.19 0 0 1-.195.029.196.196 0 0 1-.119-.15 4.47 4.47 0 0 1 0-1.598c0-.166.182-.285.309-.248l1.816.541c.058.022.058.164-.008.164Zm.111-.375-1.785-.525a.246.246 0 0 1-.105-.322c0-.016.016-.021.021-.039a5.41 5.41 0 0 1 1.143-1.365c.033-.01.07-.01.104 0 .068.01.121.063.146.129l.592 1.996c.02.074-.045.156-.111.137v-.009l-.005-.002Zm.174.571-.557 2.252a.176.176 0 0 1-.037.104.267.267 0 0 1-.293.119 2.728 2.728 0 0 1-1.105-.779.283.283 0 0 1 .072-.396l.002-.002 1.805-1.354c.061-.08.135-.026.113.056Zm.428-.75 1.201-1.99c.098-.149.271-.188.359-.073.32.358.555.784.691 1.246.045.149-.049.307-.189.358l-1.988.594c-.074.02-.074-.062-.074-.135Zm.074.314 1.977-.375c.143 0 .246.098.209.262a5.285 5.285 0 0 1-.602 1.578c-.074.148-.248.188-.338.082l-1.32-1.373a.077.077 0 0 1-.021-.053c0-.039.014-.076.053-.098a.096.096 0 0 1 .055-.023h-.013Zm-.172.345 1.051 1.613a.301.301 0 0 1-.104.405 4.45 4.45 0 0 1-1.412.563c-.15 0-.248-.104-.211-.262l.533-2.252c.014-.09.106-.127.143-.067Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_761",
    fill: "#25468F",
    d: "M281.027 304.005a22.505 22.505 0 0 1 1.201 4.056l.496-.045s-.752-3.244-1.226-3.929l-.471-.082Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_762",
    fill: "#55C4B9",
    d: "m275.33 311.807-3.753-.677a.128.128 0 0 1-.067-.045.114.114 0 0 1-.016-.076c.158-1.426.443-2.829.841-4.202.363-.64.903-1.16 1.556-1.502a5.604 5.604 0 0 1 1.801-.556l-.362 7.058Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_763",
    fill: "#919191",
    d: "M363.602 155.059h-10.375v264.086h10.375V155.059Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tree",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_764",
    fill: "#A3E440",
    d: "M93.818 388.021a7.925 7.925 0 0 0 1.29-4.377c0-3.809-2.565-6.938-5.868-7.355-.602-3.402-3.288-6.006-6.518-6.006s-5.906 2.566-6.51 6.006c-3.302.42-5.867 3.551-5.867 7.355a7.936 7.936 0 0 0 1.28 4.377 4.052 4.052 0 0 0 .112 6.002 8.36 8.36 0 0 0-.293 2.178c0 4.1 3.004 7.408 6.638 7.408a6.272 6.272 0 0 0 4.587-2.057 6.251 6.251 0 0 0 4.586 2.057c3.663 0 6.637-3.311 6.637-7.4 0-.713-.09-1.426-.276-2.117a4.02 4.02 0 0 0 .202-6.078v.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_765",
    fill: "#72493E",
    d: "M83.925 400.939h-2.401v22.596h2.4v-22.596Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_766",
    fill: "#A3E440",
    d: "M93.818 388.021a7.91 7.91 0 0 0 1.29-4.377 7.625 7.625 0 0 0-3.001-6.201c.457 1.623.688 3.305.688 4.982 0 9.012-6.546 16.32-14.623 16.32a13.26 13.26 0 0 1-6.694-1.803c.33 3.754 3.16 6.682 6.604 6.682a6.268 6.268 0 0 0 4.587-2.059 6.245 6.245 0 0 0 4.586 2.051c3.663 0 6.637-3.305 6.637-7.395 0-.721-.09-1.428-.276-2.117a4.032 4.032 0 0 0 .594-5.67 4.35 4.35 0 0 0-.392-.413Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_767",
    fill: "#D8E2F1",
    d: "M194.07 403.365h-29.6v3.934h29.6v-3.934Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_768",
    fill: "#BAC3D1",
    d: "M387.975 411.246s-10.988-1.41-16.273-2.439c-4.932-.953-192.53-1.553-192.53-1.553v5.592h186.017c19.161 0 20.842 0 22.786-1.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_769",
    fill: "#BAC3D1",
    d: "M220.516 408.221a4.619 4.619 0 0 1-4.615 4.625h-18.908a4.623 4.623 0 0 1-4.625-4.625v-.923h28.148m-29.651-.007v.93a4.62 4.62 0 0 1-4.616 4.625h-17.146a4.623 4.623 0 0 1-4.625-4.625v-.922l26.387-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_770",
    fill: "#919191",
    d: "M129.82 397.037h-7.896v12.055h7.896v-12.055Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_771",
    fill: "#CCC",
    d: "M126.314 397.037h-.879v12.055h.879v-12.055Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_772",
    fill: "#CCC",
    d: "M129.82 402.621h-7.896v.871h7.896v-.871Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_773",
    fill: "#919191",
    d: "M154.458 397.037h-7.897v12.055h7.897v-12.055Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_774",
    fill: "#CCC",
    d: "M150.952 397.037h-.878v12.055h.878v-12.055Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_775",
    fill: "#CCC",
    d: "M154.458 402.621h-7.897v.871h7.897v-.871Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_776",
    fill: "#F3EEEC",
    d: "M399.807 424.136h1.83v-56.293h-1.83v56.293Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_777",
    fill: "#8CBE4B",
    d: "M283.242 350.208c4.068 0 7.611 3.199 9.488 7.942 1.787-4.278 5.029-7.146 8.76-7.146 5.646 0 10.227 6.568 10.227 14.668a19.755 19.755 0 0 1-1.367 7.289h.113c6.004 0 10.846 6.969 10.846 15.563 0 8.596-4.855 15.563-10.846 15.563-5.992 0-29.354-1.502-33.48-1.502-6.006 0-4.652-28.061-4.652-36.715-.003-8.658 4.876-15.662 10.911-15.662Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_778",
    fill: "#A0D755",
    d: "M248.898 376.146c.174 0 .354 0 .541.037 0-.398-.09-.799-.09-1.201 0-5.879 3.316-10.623 7.407-10.623a6.337 6.337 0 0 1 4.882 2.68c1.629-3.242 4.264-5.381 7.266-5.381 4.955 0 8.971 5.758 8.971 12.873a18.04 18.04 0 0 1-.639 4.699c4.55.301 8.197 5.668 8.197 12.289 0 6.814-3.852 12.334-8.604 12.334-1.301 0-27.023-1.502-27.934-1.502-5.045 0-9.144-5.871-9.144-13.115.006-7.242 4.104-13.09 9.147-13.09Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_779",
    fill: "#8CBE4B",
    d: "M227.445 350.208c4.068 0 7.611 3.199 9.488 7.942 1.787-4.278 5.027-7.146 8.76-7.146 5.646 0 10.209 6.568 10.209 14.668a19.5 19.5 0 0 1-1.353 7.289h.104c6.006 0 10.841 6.969 10.841 15.563 0 8.596-4.851 15.563-10.841 15.563-5.989 0-29.352-1.502-33.479-1.502-6.007 0-4.654-28.061-4.654-36.715.003-8.658 4.919-15.662 10.925-15.662Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_780",
    fill: "#C0EA6E",
    d: "M193.109 376.146c.181 0 .358 0 .523.037 0-.398-.072-.799-.072-1.201 0-5.879 3.315-10.623 7.399-10.623a6.314 6.314 0 0 1 4.879 2.68c1.629-3.242 4.271-5.381 7.272-5.381 4.955 0 8.955 5.758 8.955 12.873 0 1.576-.209 3.168-.629 4.699 4.557.301 8.197 5.668 8.197 12.289 0 6.814-3.853 12.334-8.605 12.334-1.305 0-27.021-1.502-27.924-1.502-5.061 0-9.149-5.871-9.149-13.115.004-7.242 4.102-13.09 9.154-13.09Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_781",
    fill: "#B8C100",
    d: "M346.465 349.166c4.066 0 7.611 3.205 9.486 7.943 1.787-4.271 5.029-7.133 8.762-7.133 5.645 0 10.209 6.555 10.209 14.652a19.761 19.761 0 0 1-1.352 7.289h.105c6.004 0 10.846 6.965 10.846 15.563 0 8.596-4.863 15.561-10.846 15.561-5.99 0-29.355-1.5-33.48-1.5-6.006 0-4.652-28.061-4.652-36.709-.002-8.646 4.893-15.666 10.922-15.666Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_782",
    fill: "#DBDB03",
    d: "M312.121 375.102c.18 0 .354 0 .531.045 0-.403-.082-.795-.082-1.215 0-5.863 3.313-10.623 7.402-10.623a6.338 6.338 0 0 1 4.879 2.688c1.629-3.242 4.27-5.383 7.266-5.383 4.955 0 8.973 5.766 8.973 12.875a17.35 17.35 0 0 1-.639 4.69c4.563.315 8.197 5.668 8.197 12.289 0 6.815-3.852 12.348-8.604 12.348-1.301 0-27.023-1.5-27.928-1.5-5.053 0-9.143-5.879-9.143-13.123.002-7.243 4.095-13.091 9.148-13.091Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_783",
    fill: "#CCC",
    d: "M400.295 418.477h1.832V379.29h-1.832v39.187Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_784",
    fill: "#F3EEEC",
    d: "M334.836 424.142h1.832v-56.29h-1.832v56.3-.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_785",
    fill: "#686868",
    d: "M400.303 379.291h-68.846v39.186h68.838v-39.186h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_786",
    fill: "#F3EEEC",
    d: "M325.055 424.226h1.832v-56.292h-1.832v56.3-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_787",
    fill: "#CCC",
    d: "M325.055 367.775h-2.199v56.449h2.199v-56.449Zm82.009 56.451h1.832v-56.292h-1.832v56.3-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_788",
    fill: "#F3EEEC",
    d: "M407.064 367.775h-2.199v56.449h2.199v-56.449Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_789",
    fill: "#444",
    d: "M400.203 354.503h-85.35c-4.543 0-8.258 5.646-8.258 12.543v.947h17.385v-.062h69.168v-.158h7.063l-.008-13.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_790",
    fill: "#686868",
    d: "M408.889 367.994v-.947c0-6.898-3.754-12.543-8.258-12.543h-.824c-4.549 0-8.258 5.645-8.258 12.543v.947h17.34Zm-217.303-1.465h-30.177v57.695h30.177v-57.695Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "train",
    className: "train"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_791",
    fill: "#444",
    d: "M343.041 418.184c1.727 0 3.123-1.651 3.123-3.687 0-2.036-1.404-3.688-3.123-3.688-1.719 0-3.123 1.652-3.123 3.688 0 2.034 1.396 3.687 3.123 3.687Zm12.52-3.686c0 2.033-1.396 3.686-3.121 3.686-1.727 0-3.115-1.65-3.115-3.686s1.396-3.693 3.115-3.693c1.719 0 3.121 1.642 3.121 3.693Zm-65.202 3.686c1.726 0 3.121-1.651 3.121-3.687 0-2.036-1.402-3.688-3.121-3.688-1.729 0-3.123 1.652-3.123 3.688 0 2.034 1.397 3.687 3.123 3.687Zm12.514-3.686c0 2.033-1.396 3.686-3.115 3.686-1.721 0-3.123-1.65-3.123-3.686s1.396-3.693 3.123-3.693c1.724 0 3.115 1.642 3.115 3.693Zm-119.613 3.686c1.727 0 3.123-1.651 3.123-3.687 0-2.036-1.396-3.688-3.123-3.688-1.727 0-3.121 1.652-3.121 3.688 0 2.034 1.395 3.687 3.121 3.687Zm12.522-3.686c0 2.033-1.396 3.686-3.123 3.686-1.727 0-3.115-1.65-3.115-3.686s1.396-3.693 3.115-3.693c1.719 0 3.123 1.642 3.123 3.693Zm41.025 3.686c1.728 0 3.121-1.651 3.121-3.687 0-2.036-1.402-3.688-3.121-3.688-1.728 0-3.123 1.652-3.123 3.688 0 2.034 1.396 3.687 3.123 3.687Zm12.52-3.686c0 2.033-1.396 3.686-3.123 3.686-1.727 0-3.115-1.65-3.115-3.686s1.396-3.693 3.115-3.693c1.719 0 3.123 1.642 3.123 3.693Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_792",
    fill: "#D8E2F1",
    d: "M338.018 385.505H165.439v22.918s197.906 2.906 218.498 2.906c-3.416-4.022-14.85-12.763-23.58-17.8-8.728-5.035-13.675-8.024-22.339-8.024Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_793",
    fill: "#E7ECF6",
    d: "M386.625 402.479a138.835 138.835 0 0 0-18.939-16.565c-6.621-4.806-13.82-6.646-18.316-6.832-7.615-.322-123.986-.119-158.512 0h-22.563a2.853 2.853 0 0 0-2.854 2.854v13.76h5.346v-8.782h169.592c8.047 0 12.688 3.481 20.746 9.354 8.064 5.867 15.768 12.461 18.936 17.158h.75c4.837-.018 15.453-.462 5.814-10.947Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_794",
    fill: "#75CEF9",
    d: "M336.615 384.919c-.57-.276-1.156.36-1.156 1.276v14.054h3.754s.127-10.338 0-12.483c-.092-1.345-1.533-2.343-2.598-2.847Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_795",
    fill: "#90D8F9",
    d: "M338.266 389.072h-1.898v4.377h1.898v-4.385.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_796",
    fill: "#75CEF9",
    d: "M333.41 386.992H170.807v8.723h162.596v-8.723h.007Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_797",
    fill: "#90D8F9",
    d: "M331.689 389.072h-2.896v4.377h2.896v-4.385.008Zm-9.171 0h-2.891v4.377h2.891v-4.385.008Zm-9.166 0h-2.891v4.377h2.891v-4.385.008Zm-9.166 0h-2.891v4.377h2.891v-4.385.008Zm-9.166 0h-2.89v4.377h2.89v-4.385.008Zm-18.338 0h-2.896v4.377h2.896v-4.385.008Zm9.172 0h-2.89v4.377h2.89v-4.385.008Zm-27.504 0h-2.891v4.377h2.891v-4.385.008Zm9.166 0h-2.891v4.377h2.891v-4.385.008Zm-55.002 0h-2.891v4.377h2.891v-4.385.008Zm-18.33 0h-2.892v4.377h2.892v-4.385.008Zm9.158 0h-2.883v4.377h2.891v-4.385l-.008.008Zm-18.332 0h-2.89v4.377h2.89v-4.385.008Zm-9.166 0h-2.891v4.377h2.891v-4.385.008Zm64.176 0h-2.897v4.377h2.897v-4.385.008Zm9.158 0h-2.884v4.377h2.89v-4.385l-.006.008Zm-18.332 0h-2.891v4.377h2.891v-4.385.008Zm-9.166 0h-2.891v4.377h2.891v-4.385.008ZM355.563 404.4c-.797-.24-.902-2.371-23.873-2.326H165.447v2.041h171.746c10.45 0 18.368.285 18.37.285Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_798",
    fill: "#75CEF9",
    d: "M372.422 387.173c-5.42-5.428-9.008-6.2-11.635-5.256-1.021.383-3.355 1.996-3.59 3.304a.916.916 0 0 0 .256.87c1.943 2.041 8.67 7.611 13.768 11.484 2.043 1.538 3.807 1.75 5.256 1.403a6.932 6.932 0 0 0 3.752-2.763 75.655 75.655 0 0 0-7.807-9.042Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_799",
    fill: "#4D5961",
    d: "M402.127 418.184H160.561v6.003h241.564v-6.003h.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_800",
    fill: "#444",
    d: "M182.885 354.503h-29.854c-4.549 0-8.258 5.646-8.258 12.543v.947h17.363v-.062h13.686v-.158h7.056v-13.271l.007.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_801",
    fill: "#686868",
    d: "M191.57 367.994v-.947c0-6.898-3.754-12.543-8.258-12.543h-.824c-4.551 0-8.258 5.645-8.258 12.543v.947h17.34Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_802",
    fill: "#444",
    d: "M174.2 366.529h-29.441v57.695H174.2v-57.695Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_803",
    fill: "#919191",
    d: "M128.8 357.244h-4.954v7.559h4.954v-7.559Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_804",
    fill: "#CCC",
    d: "M158.811 388.457H119.53v35.807h39.281v-35.807Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_805",
    fill: "#919191",
    d: "M120.316 364.811h37.707l3.634 23.646h-44.974l3.633-23.646Zm23.925 39.146h-10.149v20.299h10.149v-20.299Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_806",
    fill: "#F3EEEC",
    d: "M130.818 397.794h-7.896v12.056h7.896v-12.056Zm24.601 0h-7.897v12.056h7.897v-12.056Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloud-large",
    fill: "#AFCCEF",
    d: "M619.82 80.959a20.85 20.85 0 0 0 .066-1.682c0-10.051-6.568-18.195-14.66-18.195-6.906 0-12.693 5.945-14.262 13.939-3.086-4.55-7.51-7.604-12.582-8.184V65.71c0-12.83-8.389-23.271-18.725-23.271-6.756 0-12.686 4.459-15.986 11.133a15.38 15.38 0 0 0-4.936-.826c-8.076 0-14.961 6.352-17.588 15.246a7.272 7.272 0 0 0-5.637-2.896c-3.477 0-6.441 2.79-7.508 6.666h-.172c-4.398 0-7.957 4.428-7.957 9.879 0 .465.029.922.074 1.38v.075c.557 4.76 3.865 8.422 7.867 8.422 3.482 0 6.439-2.791 7.506-6.672h.166a6.917 6.917 0 0 0 4.541-1.771h27.205a17.802 17.802 0 0 0 7.506 5.028c1.59.554 3.258.84 4.939.849 4.768 0 9.104-2.215 12.416-5.85H620v-2.145h-.18Z",
    className: "cloud-large"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloud-small",
    fill: "#AFCCEF",
    d: "M405.002 117.742c-.348-12.206-8.424-21.965-18.332-21.965-.9 0-1.803.084-2.688.248a8.356 8.356 0 0 0-6.93-4.145c-4.902 0-8.881 4.938-8.881 11.021a12.797 12.797 0 0 0 1.695 6.463 27.775 27.775 0 0 0-1.547 9.181v1.321a10.694 10.694 0 0 0-5.676-.848c-1.65-6.403-6.479-11.052-12.191-11.052-6.646 0-12.111 6.308-12.76 14.36-3.799.322-6.885 3.857-7.508 8.451v.158c-.059.487-.09.977-.098 1.463.01.885.105 1.765.285 2.629h20.795c.014 1.562.225 3.113.6 4.623 1.652 6.41 6.486 11.051 12.199 11.051 6.289 0 11.529-5.652 12.588-13.1a20.9 20.9 0 0 0 .195-2.574h37.383c.383-1.383.578-2.809.578-4.241-.018-6.903-4.281-12.518-9.707-13.044Z",
    className: "cloud-small"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bird-large",
    fill: "#67A4CF",
    d: "M395.303 40.318c4.354.313 8.002 3.093 11.77 5.065 5.254 2.732 10.813 3.956 16.568 5.127 8.646 1.734 13.76 6.831 17.018 13.769.219-.174.43-.315.623-.443 2.326-1.457 4.33-2.854 6.93-3.753 5.104-1.749 10.703-1.216 15.898-.248 9.082 1.696 19.426 11.335 28.967 8.679.189-.031.375-.031.57 0-8.158 7.139-19.779.75-29.373.149a28.102 28.102 0 0 0-4.578.038 24.75 24.75 0 0 0-4.588.277 14.792 14.792 0 0 0-5.104 2.013 52.07 52.07 0 0 0-9.346 4.879c-2.643.437-5.51-1.606-6.246-4.106a15.82 15.82 0 0 0-.697-2.5c-1.098-4.076-2.521-7.701-6.861-9.713a20.54 20.54 0 0 0-3.002-1.051 55.088 55.088 0 0 0-4.768-2.342c-9.01-3.956-19.293-7.131-24.021-15.809a1.09 1.09 0 0 1 .24-.031Z",
    className: "bird-large"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bird-small",
    fill: "#67A4CF",
    d: "M305.289 44.244c1.697-.57 3.527-.075 5.256.098a26.59 26.59 0 0 0 7.102-.615 9.368 9.368 0 0 1 8.662 2.599 13.064 13.064 0 0 1 2.252-2.757 13.21 13.21 0 0 1 6.006-2.59c3.754-.75 9.18 1.313 12.387-1.186.082-.045.164-.075.246-.105-2.023 4.002-7.443 3.387-11.195 4.631-.604.211-1.176.459-1.73.752a6.669 6.669 0 0 0-3.354 2.371 20.53 20.53 0 0 0-2.803 3.326 2.494 2.494 0 0 1-3.002-.602 6.84 6.84 0 0 0-.639-.855c-1.072-1.373-2.162-2.552-4.129-2.619-.441-.022-.885 0-1.32.074a15.433 15.433 0 0 0-2.184-.148c-4.057-.137-8.461.248-11.602-2.32.018-.019.031-.037.047-.054Z",
    className: "bird-small"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_807",
    fill: "#2A3967",
    d: "M278.438 319.199 280 325.5h-.5s-1.358-5.76-1.598-5.955c-.248-.195-1.646-.713-1.555-.99.089-.278 1.46 0 2.091.644Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_808",
    fill: "#D36E46",
    d: "M272.365 316.527c-.383-.57-.383-.84.053-1.238.428-.398 1.209-.195 2.912 2.252.855 1.217 1.652 2.59 1.982 3.086.188.42 0 .449-.129.576-.346.324-.563.256-.632.189-1.543-1.855-3.106-3.266-4.186-4.865Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_809",
    fill: "#D36E46",
    d: "M277.282 320.505a1.071 1.071 0 0 1-.863 0 .849.849 0 0 1 .841-.541l1.276.039v.192a.762.762 0 0 1-.315.113 1.978 1.978 0 0 0-.939.197Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_810",
    fill: "#D36E46",
    d: "M277.62 320.423c1.014.188 1.832.871 1.749 1.147-.083.277-1.374.313-2.252.074-.879-.254-1.051-.696-.977-.976.077-.275.564-.418 1.48-.245Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_811",
    fill: "#F29A7E",
    d: "M300.943 323.869c-.752 1.742-2.252 2.912-2.725 2.672-.477-.24 0-2.559.75-4.053.75-1.479 1.621-1.584 2.08-1.336.45.246.548 1.17-.105 2.717Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_812",
    fill: "#2A3967",
    d: "m301.604 322.261-3.002 2.621a.534.534 0 0 0-.15.586l.221.697a.451.451 0 0 0 .109.211.453.453 0 0 0 .639.017c.002 0 .002 0 .002-.002.785-.75 2.252-2.109 2.564-2.507.488-.541.668-1.231.189-1.637a.433.433 0 0 0-.57.021v-.007h-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_813",
    fill: "#A8CFFF",
    d: "m298.963 325.107-4.369 3.646c.314.257.75.322 1.125.166.676-.393 3.559-2.814 3.559-2.814l-.315-.998Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_814",
    fill: "#F29A7E",
    d: "M315.521 325.475c.201-.195.359-.429.457-.688.113-.257.158-.533.15-.812a1.613 1.613 0 0 0-1.539 1.088l-.826 2.252.357.091c.166-.136.305-.302.414-.474a3.911 3.911 0 0 1 .979-1.457h.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_815",
    fill: "#F29A7E",
    d: "M315.131 326c-.375 1.916.256 3.814.752 3.867.51.061 1.5-2.178 1.703-3.904.195-1.74-.467-2.305-1.006-2.363-.541-.061-1.098.697-1.441 2.4h-.008Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_816",
    fill: "#A8CFFF",
    d: "m264.16 322.945-5.6 4.678c.396.33.953.412 1.439.209.887-.494 4.563-3.609 4.563-3.609l-.396-1.277h-.006v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_817",
    fill: "#2A3967",
    d: "m267.539 319.296-3.807 3.349a.75.75 0 0 0-.203.752l.285.899a.566.566 0 0 0 .396.429.57.57 0 0 0 .563-.136 105.107 105.107 0 0 0 3.295-3.213c.623-.705.855-1.592.24-2.103a.572.572 0 0 0-.767.021l-.002.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_818",
    fill: "#28130F",
    d: "M264.911 321.609c.495 2.252 2.063 3.949 2.673 3.754.602-.195.578-3.004 0-4.977-.578-1.977-1.592-2.254-2.2-2.053-.609.206-.915 1.249-.473 3.276Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_819",
    fill: "#fff",
    d: "m232.887 321.923-4.054 3.388c.301.239.698.301 1.044.149.646-.36 3.303-2.612 3.303-2.612l-.301-.925h.008Z",
    className: "Vector"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5616_44294",
    x1: 126.605,
    x2: 125.134,
    y1: 531.177,
    y2: 534.901,
    className: "paint0_linear_5616",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD7A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5616_44294",
    x1: 122.038,
    x2: 127.043,
    y1: 534.614,
    y2: 534.606,
    className: "paint1_linear_5616",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD7A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5616_44294",
    x1: 115.937,
    x2: 122.196,
    y1: 521.045,
    y2: 521.037,
    className: "paint2_linear_5616",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F8D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#639C38"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthyNewWorld);
export default __webpack_public_path__ + "static/media/healthy-new-world.efd7935fdf5d57ca982e77855759e570.svg";
export { ForwardRef as ReactComponent };